"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Book = /*#__PURE__*/function (_React$Component) {
  _inherits(Book, _React$Component);

  var _super = _createSuper(Book);

  function Book(props) {
    var _this2;

    _classCallCheck(this, Book);

    _this2 = _super.call(this, props);
    _this2.linkScrollingX = _this2.linkScrollingX.bind(_assertThisInitialized(_this2));
    _this2.linkScrollingY = _this2.linkScrollingY.bind(_assertThisInitialized(_this2));
    _this2.setBarDisplayMode = _this2.setBarDisplayMode.bind(_assertThisInitialized(_this2));
    _this2.hoursDisplay = _this2.hoursDisplay.bind(_assertThisInitialized(_this2));
    _this2.showModal = _this2.showModal.bind(_assertThisInitialized(_this2));
    _this2.hideModal = _this2.hideModal.bind(_assertThisInitialized(_this2));
    _this2.hideCarouselModal = _this2.hideCarouselModal.bind(_assertThisInitialized(_this2));
    _this2.showCarouselModal = _this2.showCarouselModal.bind(_assertThisInitialized(_this2));
    _this2.showAddBookingModal = _this2.showAddBookingModal.bind(_assertThisInitialized(_this2));
    _this2.hideAddBookingModal = _this2.hideAddBookingModal.bind(_assertThisInitialized(_this2));
    _this2.state = {
      modalItem: {},
      buildingForModel: {},
      bookingModalShowing: false,
      completionModalShowing: false,
      completionTypes: [],
      bookStart: moment(_this2.props.onDate).startOf('day'),
      bookEnd: moment(_this2.props.onDate).add(1, 'day').startOf('day'),
      hours: [],
      barDisplayMode: 0,
      carouselModalShowing: false,
      carouselModalItem: {},
      slidesForModal: [],
      addBookingModalShowing: false,
      roomForAddBooking: {},
      clickedOnHour: 0
    };
    return _this2;
  }

  _createClass(Book, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.loadHours();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var sl = 400;
      document.getElementById('bookScroll').scrollLeft = sl;
      document.getElementById('topTimeContainer').scrollLeft = sl;
    }
  }, {
    key: "showCarouselModal",
    value: function showCarouselModal(item, isForDiagrams) {
      var _that = this;

      if (!isForDiagrams) {
        _that.setState({
          carouselTitle: "Attachments"
        });

        this.props.slidesDataService.getItems('api/DailySetup/GetSetupDiagrams/' + item.BookingId + '?reservationId=' + item.ReservationId).then(function (response) {
          _that.setState({
            carouselModalShowing: true,
            carouselModalItem: item,
            slidesForModal: response.data
          });
        }, function (error) {});
      } else {
        _that.setState({
          carouselTitle: "Drawings"
        });

        if (item.ExternalDrawingUrl) {
          window.open(item.ExternalDrawingUrl);
        } else {
          this.props.slidesDataService.getItems('api/DailySetup/GetDrawings/' + item.BookingId).then(function (response) {
            var drawings = response.data;
            var slides = [];

            for (var j = 0; j < drawings.length; j++) {
              var url = drawings[j].Url;

              if (url) {
                if (url.toLowerCase().indexOf("socialtables.com") != -1 || url.toLowerCase().indexOf("bit.ly") != -1 || url.toLowerCase().indexOf("allseated.com") != -1 || url.toLowerCase().indexOf("teams.microsoft.com") != -1 || url.toLowerCase().indexOf("sharepoint.com") != -1 || url.toLowerCase().indexOf("prismm.com") != -1) {
                  slides.push(drawings[j]);
                }
              }
            }

            if (slides.length > 0) {
              if (slides.length == 1) {
                window.open(slides[0].Url);
              } else {
                _that.setState({
                  carouselModalShowing: true,
                  carouselModalItem: item,
                  slidesForModal: slides
                });
              }
            }
          }, function (error) {});
        }
      }
    }
  }, {
    key: "hideCarouselModal",
    value: function hideCarouselModal() {
      this.setState({
        carouselModalShowing: false
      });
    }
  }, {
    key: "setBarDisplayMode",
    value: function setBarDisplayMode(setTo) {
      this.setState({
        barDisplayMode: setTo
      });
    }
  }, {
    key: "showAddBookingModal",
    value: function showAddBookingModal(room, hourOfDay) {
      var _that = this;

      this.setState({
        addBookingModalShowing: true,
        roomForAddBooking: room,
        clickedOnHour: hourOfDay
      });
    }
  }, {
    key: "hideAddBookingModal",
    value: function hideAddBookingModal() {
      this.setState({
        addBookingModalShowing: false
      });
    }
  }, {
    key: "showModal",
    value: function showModal(item, building) {
      this.setState({
        modalItem: item
      });

      if (building) {
        this.setState({
          buildingForModel: building
        });
      }

      if (this.state.barDisplayMode == 1) {
        var _that = this;

        this.props.completionsDataService.getCompletionTypesForItem(item).then(function (result) {
          _that.setState({
            completionModalShowing: true,
            completionTypes: result
          });
        }, function (error) {});
      } else if (this.state.barDisplayMode === 3) {
        //attachments
        if (item.HasBookingAttachment) {
          this.showCarouselModal(item, false);
        }
      } else if (this.state.barDisplayMode === 4) {
        //drawings
        var isMazevo = this.props.userService.apiTypeId() === "0E9DADB2-F56B-4E7E-A3B2-A59632C91D86";

        if (isMazevo) {
          if (item.HasBookingAttachment) {
            this.showCarouselModal(item, false);
          }
        } else {
          if (item.HasDrawings) {
            this.showCarouselModal(item, true);
          }
        }
      } else {
        var apiTypeId = this.props.common.userService.apiTypeId();

        if (apiTypeId == "4CF523BF-F6DD-441C-810F-C87347963B5D") {
          if (!item.Phone) {
            var _this = this;

            this.props.slidesDataService.getItem("api/DailySetup/ReservationDetails/" + item.ReservationId).then(function (response) {
              item.Phone = response.data.Phone;

              if (response.data.EmailAddress) {
                item.Email = response.data.EmailAddress;
              }

              item.GroupType = response.data.GroupType;
              item.WebUser = response.data.WebUser;
              item.EventCoordinator = response.data.EventCoordinator;
              item.GroupType = response.data.GroupType;
            });
          }
        }

        if (apiTypeId === "0E9DADB2-F56B-4E7E-A3B2-A59632C91D86") {
          this.props.slidesDataService.getItem("api/DailySetup/MazevoEventDetails/" + item.EventLocator).then(function (response) {
            item.Phone = response.data.Phone;

            if (response.data.EmailAddress) {
              item.Email = response.data.EmailAddress;
            }
          });
        }

        this.setState({
          bookingModalShowing: true
        });
      }
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      if (this.state.barDisplayMode == 1) {
        this.setState({
          completionModalShowing: false
        });
      } else {
        this.setState({
          bookingModalShowing: false
        });
      }
    }
  }, {
    key: "loadHours",
    value: function loadHours() {
      var bookStart = this.state.bookStart;
      var bookEnd = this.state.bookEnd;

      if (this.state.hours.length === 0) {
        var hours = [];
        var onTime = bookStart.clone();

        while (onTime.isBefore(bookEnd)) {
          hours.push(onTime.hours());
          onTime = onTime.add(1, 'hour');
        }

        this.setState({
          hours: hours
        });
      }
    }
  }, {
    key: "hoursDisplay",
    value: function hoursDisplay(h) {
      if (h == 0) return "12 AM";else if (h == 12) return "12 PM";else return h % 12;
    }
  }, {
    key: "linkScrollingX",
    value: function linkScrollingX(e) {
      document.getElementById('topTimeContainer').scrollLeft = e.currentTarget.scrollLeft;
    }
  }, {
    key: "linkScrollingY",
    value: function linkScrollingY(e) {
      document.getElementById('locationColumnWrapper').scrollTop = e.currentTarget.scrollTop;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // let adjustTimes = this.props.userService.apiTypeId() !== "4CF523BF-F6DD-441C-810F-C87347963B5D"; 
      var adjustTimes = false; //let midnight = moment().startOf('day');

      var now = moment();
      var hours = now.hours();
      var minutes = now.minutes(); //let minutesFromMidnightToNow = 220 +  now.diff(midnight, 'minutes');

      var minutesFromMidnightToNow = 220 + hours * 60 + minutes; //console.log(now.diff(midnight, 'minutes'))

      var nowLeftStyle = {
        left: minutesFromMidnightToNow + "px"
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "bookContainer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "topTimeContainer",
        id: "topTimeContainer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "topTimeRow"
      }, /*#__PURE__*/React.createElement("div", {
        className: "topTimeOverflow"
      }, /*#__PURE__*/React.createElement("div", {
        className: "barActionWrapper"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-header fa-1-5x pointer",
        style: {
          color: this.state.barDisplayMode == 0 ? 'green' : 'grey'
        },
        onClick: function onClick() {
          return _this3.setBarDisplayMode(0);
        },
        title: "Show Event Name"
      }), "\xA0\xA0", /*#__PURE__*/React.createElement("i", {
        className: "fa fa-user fa-1-5x pointer",
        style: {
          color: this.state.barDisplayMode == 5 ? 'green' : 'grey'
        },
        onClick: function onClick() {
          return _this3.setBarDisplayMode(5);
        },
        title: "Show Group Name"
      }), "\xA0\xA0", /*#__PURE__*/React.createElement("i", {
        className: "fa fa-wrench fa-1-5x pointer",
        style: {
          color: this.state.barDisplayMode == 1 ? 'green' : 'grey'
        },
        onClick: function onClick() {
          return _this3.setBarDisplayMode(1);
        },
        title: "Show Completion Items"
      }), "\xA0\xA0", /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cutlery fa-1-5x pointer",
        style: {
          color: this.state.barDisplayMode == 2 ? 'green' : 'grey'
        },
        onClick: function onClick() {
          return _this3.setBarDisplayMode(2);
        },
        title: "Show Services"
      }), "\xA0\xA0", /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cubes fa-1-5x pointer",
        style: {
          color: this.state.barDisplayMode == 3 ? 'green' : 'grey'
        },
        onClick: function onClick() {
          return _this3.setBarDisplayMode(3);
        },
        title: "Show Attachments"
      }), "\xA0\xA0", /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cube fa-1-5x pointer",
        style: {
          color: this.state.barDisplayMode == 4 ? 'green' : 'grey'
        },
        onClick: function onClick() {
          return _this3.setBarDisplayMode(4);
        },
        title: "Show Drawings"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "topTimeRoomPadding"
      }), this.state.hours.map(function (h) {
        return /*#__PURE__*/React.createElement("div", {
          key: h,
          className: "tb"
        }, /*#__PURE__*/React.createElement("div", {
          className: "tbv"
        }, _this3.hoursDisplay(h)));
      }))), /*#__PURE__*/React.createElement("div", {
        id: "bookScroll",
        className: "bookScroll",
        onScroll: function onScroll(e) {
          return _this3.linkScrollingX(e);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "book",
        onScroll: function onScroll(e) {
          return _this3.linkScrollingY(e);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "hideLocationScrollBars"
      }, /*#__PURE__*/React.createElement("div", {
        className: "locationColumnWrapper",
        id: "locationColumnWrapper"
      }, this.props.bookData.map(function (b) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "buildingColumn buildingColor"
        }, /*#__PURE__*/React.createElement("div", {
          className: "buildingText buildingTextColor"
        }, b.Description)), b.Rooms.map(function (r) {
          return /*#__PURE__*/React.createElement("div", {
            className: "roomColumn"
          }, _this3.props.showRoomCode && /*#__PURE__*/React.createElement("div", {
            className: "roomText"
          }, r.Code), !_this3.props.showRoomCode && /*#__PURE__*/React.createElement("div", {
            className: "roomText"
          }, r.Description));
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "buildingsContainer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "nowBar",
        style: nowLeftStyle
      }), this.props.bookData.map(function (b) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BuildingRow, {
          hoursDisplay: _this3.hoursDisplay,
          building: b,
          bookStart: _this3.state.bookStart,
          bookEnd: _this3.state.bookEnd
        }), b.Rooms.map(function (r) {
          return /*#__PURE__*/React.createElement(BookRow, {
            key: r.Id,
            onDate: _this3.props.onDate,
            bookRowClicked: _this3.showAddBookingModal,
            room: r,
            hours: _this3.state.hours,
            date: _this3.props.onDate,
            building: b,
            showBookingModal: _this3.showModal,
            eventBarColor: _this3.props.eventBarColor,
            reservedBarColor: _this3.props.reservedBarColor,
            cancelledBarColor: _this3.props.cancelledBarColor,
            textColor: _this3.props.textColor,
            allCompletions: _this3.props.allCompletions,
            barDisplayMode: _this3.state.barDisplayMode,
            settings: _this3.props.settings,
            adjustTimes: adjustTimes,
            userService: _this3.props.userService
          });
        }));
      }))))), /*#__PURE__*/React.createElement(BookingModal, {
        show: this.state.bookingModalShowing,
        booking: this.state.modalItem,
        building: this.state.buildingForModel,
        close: this.hideModal,
        adjustTimes: adjustTimes,
        userService: this.props.userService
      }), /*#__PURE__*/React.createElement(CompletionsModal, {
        show: this.state.completionModalShowing,
        item: this.state.modalItem,
        close: this.hideModal,
        completionTypes: this.state.completionTypes,
        completionsDataService: this.props.completionsDataService,
        userService: this.props.userService
      }), /*#__PURE__*/React.createElement(CarouselModal, {
        show: this.state.carouselModalShowing,
        close: this.hideCarouselModal,
        slidesForModal: this.state.slidesForModal,
        title: this.state.carouselTitle,
        dataService: this.props.slidesDataService,
        item: this.state.carouselModalItem
      }), /*#__PURE__*/React.createElement(AddBookingModal, {
        refresh: this.props.refresh,
        common: this.props.common,
        show: this.state.addBookingModalShowing,
        clickedOnHour: this.state.clickedOnHour,
        room: this.state.roomForAddBooking,
        close: this.hideAddBookingModal,
        apiService: this.props.slidesDataService
      }));
    }
  }]);

  return Book;
}(React.Component);

Book.propTypes = {
  bookData: React.PropTypes.array,
  onDate: React.PropTypes.date,
  eventBarColor: React.PropTypes.string,
  reservedBarColor: React.PropTypes.string,
  cancelledBarColor: React.PropTypes.string,
  textColor: React.PropTypes.string,
  allCompletions: React.PropTypes.array,
  settings: React.PropTypes.array,
  completionsDataService: React.PropTypes.object,
  slidesDataService: React.PropTypes.object,
  userService: React.PropTypes.object,
  common: React.PropTypes.object,
  refresh: React.PropTypes.func,
  showRoomCode: React.PropTypes.bool
};
Book.defaultProps = {
  bookData: [],
  onDate: moment().startOf('day'),
  allCompletions: [],
  settings: []
};

var AddBookingModal = /*#__PURE__*/function (_React$Component2) {
  _inherits(AddBookingModal, _React$Component2);

  var _super2 = _createSuper(AddBookingModal);

  function AddBookingModal(props) {
    var _this4;

    _classCallCheck(this, AddBookingModal);

    _this4 = _super2.call(this, props);
    _this4.addBooking = _this4.addBooking.bind(_assertThisInitialized(_this4));
    _this4.addAndClose = _this4.addAndClose.bind(_assertThisInitialized(_this4));
    _this4.durationClicked = _this4.durationClicked.bind(_assertThisInitialized(_this4));
    _this4.startTimeClicked = _this4.startTimeClicked.bind(_assertThisInitialized(_this4));
    _this4.state = {
      timesForButtons: [],
      potentialDurations: [30, 60, 90, 120, 180, 240, 360, 480],
      selectedStart: "",
      selectedDuration: 30
    };
    return _this4;
  }

  _createClass(AddBookingModal, [{
    key: "addBooking",
    value: function addBooking() {
      var that = this;
      var en = $("#eventName").val();
      var sc = $("#setupCount").val();

      if (!en) {
        this.props.common.logger.error('You must supply an event name');
        return;
      }

      var dto = {
        eventName: en,
        setupCount: sc,
        startTime: this.state.selectedStart,
        duration: this.state.selectedDuration,
        roomId: this.props.room.Id
      };
      this.props.apiService.saveItem('api/DailySetup/AddBooking', dto, true).then(function (response) {
        if (response.status != 200) {
          that.props.common.logger.error("There was a problem creating your booking");
        } else {
          that.props.common.logger.success("Booking Created");
          that.props.refresh();
          that.props.close();
        }
      }, function (error) {
        console.log(error);
      }); //this.props.notesDataService.newNote(note, this.props.item);

      $("#eventName").val("");
      $("#setupCount").val("");
    }
  }, {
    key: "addAndClose",
    value: function addAndClose() {
      this.addBooking();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var bookings = nextProps.room.bookings;
      var quaterHour = nextProps.clickedOnHour;
      quaterHour = (Math.round(quaterHour * 4) / 4).toFixed(2);
      var m = quaterHour.split('.')[1];
      var minutes = m == 25 ? 15 : m == 50 ? 30 : m == 75 ? 45 : 0;
      var flooredHour = Math.floor(nextProps.clickedOnHour);
      var timesForButtons = [];
      var d = new Date();
      var year = d.getFullYear();
      var monthIndex = d.getMonth();
      var day = d.getDate();
      var onDate = moment(new Date(year, monthIndex, day, flooredHour, 0));

      for (var i = 0; i < 7; i++) {
        onDate = moment(onDate).add(15, "m").toDate();
        timesForButtons.push(onDate);
      }

      var ss = new Date(year, monthIndex, day, flooredHour, minutes);
      this.setState({
        timesForButtons: timesForButtons,
        selectedStart: ss,
        selectedDuration: 30
      });
    }
  }, {
    key: "durationClicked",
    value: function durationClicked(d) {
      this.setState({
        selectedDuration: d
      });
    }
  }, {
    key: "startTimeClicked",
    value: function startTimeClicked(d) {
      this.setState({
        selectedStart: d
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, "Add New Booking in ", this.props.room.Description)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "newEmsBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Booking Details"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", {
        "for": "eventName"
      }, "Event Name:"), /*#__PURE__*/React.createElement("input", {
        name: "eventName",
        id: "eventName",
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", null, "Start At:"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "btn-group"
      }, this.state.timesForButtons.map(function (d) {
        var o = moment(d).format("hh:mm");
        var s = moment(_this5.state.selectedStart).format("hh:mm");
        var cn = o == s ? "btn btn-success" : " btn btn-grey";
        return /*#__PURE__*/React.createElement("button", {
          className: cn,
          onClick: function onClick() {
            return _this5.startTimeClicked(d);
          }
        }, moment(d).format('h:mm a'));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", null, "Duration: "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "btn-group"
      }, this.state.potentialDurations.map(function (d) {
        var cn = d == _this5.state.selectedDuration ? "btn btn-success" : " btn btn-grey";
        var text = d == 30 ? "30 min" : d == 60 ? "1 hr" : d / 60 + " hr";
        return /*#__PURE__*/React.createElement("button", {
          className: cn,
          onClick: function onClick() {
            return _this5.durationClicked(d);
          }
        }, text);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", {
        "for": "setupCount"
      }, "Setup Count:"), /*#__PURE__*/React.createElement("input", {
        name: "setupCount",
        id: "setupCount",
        className: "form-control"
      }))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.addAndClose
      }, "Ok")));
    }
  }]);

  return AddBookingModal;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Booking = /*#__PURE__*/function (_React$Component) {
  _inherits(Booking, _React$Component);

  var _super = _createSuper(Booking);

  function Booking(props) {
    _classCallCheck(this, Booking);

    return _super.call(this, props);
  }

  _createClass(Booking, [{
    key: "hasCompletionType",
    value: function hasCompletionType(ct) {
      var completion = this.getLastCompletionForType(ct.ID, this.props.booking);

      if (completion) {
        if (completion.CompletedAtUtc != null) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getLastCompletionForType",
    value: function getLastCompletionForType(completionTypeId, item) {
      var completions = item.Completions.filter(this.isCompletionType(completionTypeId));
      completions.sort(function (a, b) {
        a = new Date(a.DateAddedUtc);
        b = new Date(b.DateAddedUtc);
        return a > b ? -1 : a < b ? 1 : 0;
      });
      return completions[0];
    }
  }, {
    key: "isCompletionType",
    value: function isCompletionType(completionTypeId) {
      return function (element) {
        return element.CompletionTypeId == completionTypeId;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var isMazevo = this.props.userService.apiTypeId() === "0E9DADB2-F56B-4E7E-A3B2-A59632C91D86";
      var midnight = moment(this.props.date).startOf('day');
      var showEvent = false;
      var showBooking = false; //let timezoneOffsetMinutes = -1 * this.props.building.EmsTimezoneMinuteOffsetFromTenantTimezone

      var timezoneOffsetMinutes = this.props.building.EmsTimezoneMinuteOffsetFromTenantTimezone;
      var eventStart, eventEnd, bookingStart, bookingEnd;

      if (this.props.adjustTimes) {
        eventStart = moment(this.props.booking.BuildingLocalEventStart).add(timezoneOffsetMinutes, 'minutes');
        eventEnd = moment(this.props.booking.BuildingLocalEventEnd).add(timezoneOffsetMinutes, 'minutes');
        bookingStart = moment(this.props.booking.BuildingLocalReseveredStart).add(timezoneOffsetMinutes, 'minutes');
        bookingEnd = moment(this.props.booking.BuildingLocalReseveredEnd).add(timezoneOffsetMinutes, 'minutes');
      } else {
        eventStart = moment(this.props.booking.BuildingLocalEventStart);
        eventEnd = moment(this.props.booking.BuildingLocalEventEnd);
        bookingStart = moment(this.props.booking.BuildingLocalReseveredStart);
        bookingEnd = moment(this.props.booking.BuildingLocalReseveredEnd);
      }

      var notInRoomClass = this.props.booking.AssociatedRoomId > 0 && this.props.booking.AssociatedRoomId !== this.props.booking.RoomId ? "notInRoom" : "";

      if (eventStart.date() === midnight.date() || eventEnd.date() === midnight.date()) {
        showEvent = true;
      }

      if (bookingStart.date() === midnight.date() || bookingEnd.date() === midnight.date()) {
        showBooking = true;
      }

      var minutesFromMidnightToBookingStart = bookingStart.diff(midnight, 'minutes');
      var minutesFromMidnightToEventStart = eventStart.diff(midnight, 'minutes');

      if (minutesFromMidnightToEventStart < 0) {
        eventStart = eventStart.startOf('day').add(1, 'day');
        minutesFromMidnightToEventStart = 0;
      } else {
        minutesFromMidnightToEventStart = eventStart.hours() * 60 + eventStart.minutes();
      }

      if (minutesFromMidnightToBookingStart < 0) {
        bookingStart = bookingStart.startOf('day').add(1, 'day');
        minutesFromMidnightToBookingStart = 0;
      } else {
        minutesFromMidnightToBookingStart = bookingStart.hours() * 60 + bookingStart.minutes();
      }

      var widthOfBooking = bookingEnd.diff(bookingStart, 'minutes');
      var widthOfEvent = eventEnd.diff(eventStart, 'minutes');
      var eventBarColor = this.props.booking.Status.StatusType == -1 ? this.props.cancelledBarColor : this.props.eventBarColor;
      var eventStyle = {
        left: minutesFromMidnightToEventStart + "px",
        width: widthOfEvent + "px",
        backgroundColor: eventBarColor
      };
      var reservedStyle = {
        left: minutesFromMidnightToBookingStart + "px",
        width: widthOfBooking + "px",
        backgroundColor: this.props.reservedBarColor
      };
      var textStyle = {
        width: widthOfEvent - 10 + "px",
        color: this.props.textColor
      };
      return /*#__PURE__*/React.createElement("div", {
        onClick: this.props.showBookingModal.bind(this, this.props.booking, this.props.building),
        className: "pointer"
      }, showEvent && widthOfEvent > 0 && /*#__PURE__*/React.createElement("div", {
        className: "e " + notInRoomClass,
        style: eventStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "eventBarText",
        style: textStyle
      }, this.props.barDisplayMode == 1 && /*#__PURE__*/React.createElement("ul", {
        className: "completionIcons"
      }, this.props.allCompletions.map(function (ct) {
        return _this.hasCompletionType(ct) && /*#__PURE__*/React.createElement("li", {
          key: ct.ID
        }, /*#__PURE__*/React.createElement("i", {
          className: ct.IconClass,
          style: {
            color: ct.IconColor
          }
        }));
      })), this.props.barDisplayMode == 0 && this.props.booking.EventName, this.props.barDisplayMode == 5 && this.props.booking.GroupName, this.props.barDisplayMode == 2 && /*#__PURE__*/React.createElement(ServicesCell, {
        item: this.props.booking,
        settings: this.props.settings,
        toggleServices: function toggleServices() {
          return;
        },
        iconSizeClass: "",
        textColor: this.props.textColor,
        userService: this.props.userService
      }), this.props.barDisplayMode == 3 && !isMazevo && this.props.booking.HasBookingAttachment && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cubes fa-1-5x pointer"
      }), this.props.barDisplayMode == 4 && this.props.booking.HasDrawings && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cube fa-1-5x pointer"
      }), this.props.barDisplayMode == 4 && isMazevo && this.props.booking.HasBookingAttachment && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cube fa-1-5x pointer"
      }))), showBooking && widthOfBooking > 0 && widthOfBooking != widthOfEvent && /*#__PURE__*/React.createElement("div", {
        className: "b " + notInRoomClass,
        style: reservedStyle
      }, "\xA0"));
    }
  }]);

  return Booking;
}(React.Component);

Booking.propTypes = {
  booking: React.PropTypes.object,
  date: React.PropTypes.date,
  building: React.PropTypes.object,
  showBookingModal: React.PropTypes.func,
  eventBarColor: React.PropTypes.string,
  reservedBarColor: React.PropTypes.string,
  textColor: React.PropTypes.string,
  allCompletions: React.PropTypes.array,
  settings: React.PropTypes.array,
  cancelledBarColor: React.PropTypes.string
};
Booking.defaultProps = {
  settings: [],
  cancelledBarColor: 'red'
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BookingModal = /*#__PURE__*/function (_React$Component) {
  _inherits(BookingModal, _React$Component);

  var _super = _createSuper(BookingModal);

  function BookingModal(props) {
    var _this;

    _classCallCheck(this, BookingModal);

    _this = _super.call(this, props);
    _this.state = {
      booking: _this.props.booking,
      showExtend: false
    };
    return _this;
  }

  _createClass(BookingModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        booking: nextProps.booking
      });
      var tId = nextProps.userService.tenantId();
      var allowedIds = ["155", "1", "166"];

      if (allowedIds.indexOf(tId) >= 0) {
        this.setState({
          showExtend: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      //let timezoneOffsetMinutes = -1 * this.props.building.EmsTimezoneMinuteOffsetFromTenantTimezone;
      var timezoneOffsetMinutes = this.props.building.EmsTimezoneMinuteOffsetFromTenantTimezone;
      var eventStart, eventEnd, bookingStart, bookingEnd;

      if (this.props.adjustTimes) {
        eventStart = moment(this.props.booking.BuildingLocalEventStart).add(timezoneOffsetMinutes, 'minutes').format("LT");
        eventEnd = moment(this.props.booking.BuildingLocalEventEnd).add(timezoneOffsetMinutes, 'minutes').format("LT");
        bookingStart = moment(this.props.booking.BuildingLocalReseveredStart).add(timezoneOffsetMinutes, 'minutes').format("LT");
        bookingEnd = moment(this.props.booking.BuildingLocalReseveredEnd).add(timezoneOffsetMinutes, 'minutes').format("LT");
      } else {
        eventStart = moment(this.props.booking.BuildingLocalEventStart).format("LT");
        eventEnd = moment(this.props.booking.BuildingLocalEventEnd).format("LT");
        bookingStart = moment(this.props.booking.BuildingLocalReseveredStart).format("LT");
        bookingEnd = moment(this.props.booking.BuildingLocalReseveredEnd).format("LT");
      }

      var gtLabel = null;
      var gtData = null;

      if (this.props.booking.GroupType) {
        gtLabel = /*#__PURE__*/React.createElement("dt", null, "Group Type");
        gtData = /*#__PURE__*/React.createElement("dd", null, this.props.booking.GroupType);
      }

      var bcDash = null;

      if (this.props.booking.BuildingCode) {
        bcDash = /*#__PURE__*/React.createElement("span", null, " - ");
      }

      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        bsSize: "lg"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.booking.EventName, " - ", this.props.booking.BuildingCode, " ", bcDash, " ", /*#__PURE__*/React.createElement("span", {
        className: "roomDesc"
      }, " ", this.props.booking.RoomDescription), " - (", this.props.booking.SetupType, ", ", this.props.booking.SetupCount, ", act. ", this.props.booking.ActualCount, ")")), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "groupDetails"
      }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Reserved Start"), /*#__PURE__*/React.createElement("dd", null, bookingStart, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Event Start"), /*#__PURE__*/React.createElement("dd", null, eventStart, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Event End"), /*#__PURE__*/React.createElement("dd", null, eventEnd, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Reserved End"), /*#__PURE__*/React.createElement("dd", null, bookingEnd, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Status"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.Status && this.props.booking.Status.Description, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Event Type"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.EventType, "\xA0")))), /*#__PURE__*/React.createElement("div", {
        className: "col-md-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "groupDetails"
      }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Reservation ID"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.ReservationId, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Booking ID"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.EventLocator, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Phone"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("a", {
        href: "tel:{this.props.booking.Phone}"
      }, this.props.booking.Phone), "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Email"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("a", {
        href: "mailto:{this.props.booking.Email}"
      }, this.props.booking.Email), "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Event Coordinator"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.EventCoordinator, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Group"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.GroupName, "\xA0"), gtLabel, gtData, /*#__PURE__*/React.createElement("dt", null, "Contact"), /*#__PURE__*/React.createElement("dd", null, this.props.booking.FirstContact, "\xA0"))))), this.props.booking.Services && this.props.booking.Services.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Services"), /*#__PURE__*/React.createElement(ServicesList, {
        services: this.props.booking.Services,
        minutesSinceLastChange: "1440"
      })), this.props.booking.Udfs && this.props.booking.Udfs.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "User Defined Fields"), /*#__PURE__*/React.createElement(UdfsList, {
        udfs: this.props.booking.Udfs
      }))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Close")));
    }
  }]);

  return BookingModal;
}(React.Component);

BookingModal.propTypes = {
  booking: React.PropTypes.object,
  close: React.PropTypes.func
};
BookingModal.defaultProps = {
  booking: {
    Status: {}
  }
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BookRow = /*#__PURE__*/function (_React$Component) {
  _inherits(BookRow, _React$Component);

  var _super = _createSuper(BookRow);

  function BookRow(props) {
    var _this;

    _classCallCheck(this, BookRow);

    _this = _super.call(this, props);
    _this.rowClicked = _this.rowClicked.bind(_assertThisInitialized(_this));
    _this.state = {
      startTimesToShow: []
    };
    return _this;
  }

  _createClass(BookRow, [{
    key: "componentWillMount",
    value: function componentWillMount() {}
  }, {
    key: "rowClicked",
    value: function rowClicked(e) {
      var now = new Date();

      if (now.getDate() !== this.props.onDate.getDate()) {
        return;
      }

      var tId = this.props.userService.tenantId();
      var allowedIds = ["155", "1", "166"];

      if (allowedIds.indexOf(tId) === -1) {
        return;
      }

      var bookContainer = document.getElementById("bookScroll");
      var scrollLeft = bookContainer.scrollLeft;
      var clientX = e.clientX;
      var totalLeft = scrollLeft + clientX;
      var midnightX = 408;
      var hourOfDay = (totalLeft - midnightX) / 60;
      var nowHour = now.getHours();

      for (var i = 0; i < this.props.room.Bookings.length; i++) {
        var bookingStart = moment(this.props.room.Bookings[i].BuildingLocalReseveredStart).toDate();
        var bookingEnd = moment(this.props.room.Bookings[i].BuildingLocalReseveredEnd).toDate();
        var bsHours = bookingStart.getHours();
        var beHours = bookingEnd.getHours();

        if (nowHour > hourOfDay) {
          return;
        }

        if (hourOfDay > bsHours && hourOfDay < beHours) {
          return;
        }
      }

      this.props.bookRowClicked(this.props.room, hourOfDay);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.room.Bookings) {
        this.props.room.Bookings = [];
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "br " + this.props["class"],
        onClick: this.rowClicked
      }, this.props.room.Bookings.map(function (b) {
        return /*#__PURE__*/React.createElement(Booking, {
          key: b.Id,
          booking: b,
          date: _this2.props.date,
          building: _this2.props.building,
          showBookingModal: _this2.props.showBookingModal,
          eventBarColor: _this2.props.eventBarColor,
          reservedBarColor: _this2.props.reservedBarColor,
          cancelledBarColor: _this2.props.cancelledBarColor,
          textColor: _this2.props.textColor,
          allCompletions: _this2.props.allCompletions,
          barDisplayMode: _this2.props.barDisplayMode,
          settings: _this2.props.settings,
          adjustTimes: _this2.props.adjustTimes,
          userService: _this2.props.userService
        });
      }));
    }
  }]);

  return BookRow;
}(React.Component);

BookRow.propTypes = {
  "class": React.PropTypes.string,
  date: React.PropTypes.date,
  building: React.PropTypes.object,
  showBookingModal: React.PropTypes.func,
  eventBarColor: React.PropTypes.string,
  reservedBarColor: React.PropTypes.string,
  cancelledBarColor: React.PropTypes.string,
  textColor: React.PropTypes.string,
  allCompletions: React.PropTypes.array,
  barDisplayMode: React.PropTypes.number,
  settings: React.PropTypes.array,
  room: React.PropTypes.object,
  bookRowClicked: React.PropTypes.func
};
BookRow.defaultProps = {
  bookings: [],
  "class": "",
  allCompletions: [],
  barDisplayMode: 0,
  settings: []
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BuildingRow = /*#__PURE__*/function (_React$Component) {
  _inherits(BuildingRow, _React$Component);

  var _super = _createSuper(BuildingRow);

  function BuildingRow(props) {
    _classCallCheck(this, BuildingRow);

    return _super.call(this, props);
  }

  _createClass(BuildingRow, [{
    key: "render",
    value: function render() {
      var _this = this;

      var hours = [];
      var onTime = this.props.bookStart.clone();
      var endTime = this.props.bookEnd.clone();
      var minuteOffset = -1 * this.props.building.EmsTimezoneMinuteOffsetFromTenantTimezone;
      onTime = onTime.add(minuteOffset, 'minute');
      endTime = endTime.add(minuteOffset, 'minute');

      while (onTime.isBefore(endTime)) {
        hours.push(onTime.hours());
        onTime = onTime.add(1, 'hour');
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "buildingRow buildingColor"
      }, hours.map(function (h) {
        return /*#__PURE__*/React.createElement("div", {
          key: h,
          className: "bTb"
        }, /*#__PURE__*/React.createElement("div", {
          className: "tbv"
        }, _this.props.hoursDisplay(h)));
      }));
    }
  }]);

  return BuildingRow;
}(React.Component);

BuildingRow.propTypes = {
  hoursDisplay: React.PropTypes.func,
  building: React.PropTypes.object,
  bookStart: React.PropTypes.object,
  bookEnd: React.PropTypes.object
};
BuildingRow.defaultProps = {
  building: {}
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TimeBlock = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeBlock, _React$Component);

  var _super = _createSuper(TimeBlock);

  function TimeBlock(props) {
    _classCallCheck(this, TimeBlock);

    return _super.call(this, props);
  }

  _createClass(TimeBlock, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "tb"
      }, this.props.hour);
    }
  }]);

  return TimeBlock;
}(React.Component);

TimeBlock.propTypes = {
  hour: React.PropTypes.number
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ACTItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ACTItem, _React$Component);

  var _super = _createSuper(ACTItem);

  function ACTItem(props) {
    _classCallCheck(this, ACTItem);

    return _super.call(this, props);
  }

  _createClass(ACTItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      var s = {};

      if (this.props.highlightColor !== "") {
        s.color = this.props.highlightColor;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "categoryHeading ACT"
      }, this.props.service.Category.Description), /*#__PURE__*/React.createElement("ul", null, this.props.service.ServiceOrderDetails.map(function (sod) {
        return /*#__PURE__*/React.createElement("li", {
          key: sod.ID,
          style: sod.MinutesSinceLastChange < _this.props.minutesSinceLastChange ? s : {},
          className: sod.MinutesSinceLastChange < _this.props.minutesSinceLastChange ? "sodRecentlyChanged" : ""
        }, moment(sod.TimeStart).format("LT"), " ", sod.TimeEnd && /*#__PURE__*/React.createElement("span", null, " - ", moment(sod.TimeEnd).format("LT"), " "), sod.TempResourceDescription, "  ", sod.Notes && /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.Notes));
      })));
    }
  }]);

  return ACTItem;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ATTItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ATTItem, _React$Component);

  var _super = _createSuper(ATTItem);

  function ATTItem(props) {
    var _this;

    _classCallCheck(this, ATTItem);

    _this = _super.call(this, props);
    _this.showCheckinModal = _this.showCheckinModal.bind(_assertThisInitialized(_this));
    _this.hideCheckinModal = _this.hideCheckinModal.bind(_assertThisInitialized(_this));
    _this.state = {
      checkinModalShowing: false,
      checkInSod: {}
    };
    return _this;
  }

  _createClass(ATTItem, [{
    key: "showCheckinModal",
    value: function showCheckinModal(item) {
      this.setState({
        checkinModalShowing: true,
        checkInSod: item
      });
    }
  }, {
    key: "hideCheckinModal",
    value: function hideCheckinModal() {
      this.setState({
        checkinModalShowing: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var s = {};

      if (this.props.highlightColor !== "") {
        s.color = this.props.highlightColor;
      }

      var internalAttendees = [];
      var externalAttendees = [];
      this.props.service.ServiceOrderDetails.map(function (sod) {
        if (sod.ExternalAttendee) {
          externalAttendees.push(sod);
        } else {
          internalAttendees.push(sod);
        }
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "categoryHeading ATT"
      }, this.props.service.Category.Description), /*#__PURE__*/React.createElement("ul", null, externalAttendees.length > 0 && /*#__PURE__*/React.createElement("li", null, "External", /*#__PURE__*/React.createElement("ul", null, externalAttendees.map(function (sod) {
        return /*#__PURE__*/React.createElement("li", {
          style: sod.MinutesSinceLastChange < _this2.props.minutesSinceLastChange ? s : {},
          className: sod.MinutesSinceLastChange < _this2.props.minutesSinceLastChange ? "sodRecentlyChanged" : ""
        }, sod.TempResourceDescription, sod.EmailAddress && /*#__PURE__*/React.createElement("span", null, "\xA0-\xA0", /*#__PURE__*/React.createElement("a", {
          "ng-href": "mailto:{sod.EmailAddress}"
        }, sod.EmailAddress)), sod.Phone && /*#__PURE__*/React.createElement("span", null, "\xA0-\xA0", /*#__PURE__*/React.createElement("a", {
          "ng-href": "tel:{sod.Phone}"
        }, sod.Phone)), /*#__PURE__*/React.createElement("span", null, "\xA0-\xA0"), sod.CheckedIn && /*#__PURE__*/React.createElement("i", {
          className: "fa fa-check-square green",
          title: "Checked in"
        }), !sod.CheckedIn && /*#__PURE__*/React.createElement("i", {
          className: "fa fa-square red",
          title: "Not checked in"
        }), /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.Notes), /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.SpecialInstructions));
      }))), internalAttendees.length > 0 && /*#__PURE__*/React.createElement("li", null, "Internal", /*#__PURE__*/React.createElement("ul", null, internalAttendees.map(function (sod) {
        return /*#__PURE__*/React.createElement("li", {
          style: sod.MinutesSinceLastChange < _this2.props.minutesSinceLastChange ? s : {},
          className: sod.MinutesSinceLastChange < _this2.props.minutesSinceLastChange ? "sodRecentlyChanged" : ""
        }, sod.TempResourceDescription, sod.EmailAddress && /*#__PURE__*/React.createElement("span", null, "\xA0-\xA0", /*#__PURE__*/React.createElement("a", {
          "ng-href": "mailto:{sod.EmailAddress}"
        }, sod.EmailAddress)), sod.Phone && /*#__PURE__*/React.createElement("span", null, "\xA0-\xA0", /*#__PURE__*/React.createElement("a", {
          "ng-href": "tel:{sod.Phone}"
        }, sod.Phone)), /*#__PURE__*/React.createElement("span", null, "\xA0-\xA0"), sod.CheckedIn && /*#__PURE__*/React.createElement("i", {
          className: "fa fa-check-square green",
          title: "Checked in"
        }), !sod.CheckedIn && /*#__PURE__*/React.createElement("i", {
          className: "fa fa-square red",
          title: "Not checked in"
        }), /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.Notes), /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.SpecialInstructions));
      })))), /*#__PURE__*/React.createElement(ConfirmAttendeeCheckinModal, {
        show: this.state.checkinModalShowing,
        close: this.hideCheckinModal,
        sod: this.state.checkInSod,
        apiService: this.props.apiService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.props.updateItemInCollection
      }));
    }
  }]);

  return ATTItem;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AvailableAtCell = /*#__PURE__*/function (_React$Component) {
  _inherits(AvailableAtCell, _React$Component);

  var _super = _createSuper(AvailableAtCell);

  function AvailableAtCell(props) {
    var _this;

    _classCallCheck(this, AvailableAtCell);

    _this = _super.call(this, props);
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    _this.selectChanged = _this.selectChanged.bind(_assertThisInitialized(_this));
    _this.state = {
      editMode: false,
      timeData: []
    };
    return _this;
  }

  _createClass(AvailableAtCell, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.loadTimeData();
    }
  }, {
    key: "loadTimeData",
    value: function loadTimeData() {
      if (this.state.timeData.length === 0) {
        var times = [],
            i,
            j,
            t,
            h,
            hh,
            m;

        for (i = 0; i < 24; i++) {
          hh = i;

          if (i === 0) {
            h = "12";
          } else {
            if (i > 12) {
              h = i % 12;
            } else {
              h = i;
            }
          }

          for (j = 0; j < 4; j++) {
            t = h + ":" + (j === 0 ? "00" : 15 * j);
            m = (hh < 10 ? "0" + hh : hh) + ":" + (j === 0 ? "00" : 15 * j);
            t += " " + Number(i) < 12 ? " AM" : " PM";
            times.push({
              value: m,
              text: t
            });
          }
        }

        this.setState({
          timeData: times
        });
      }
    }
  }, {
    key: "roomsAvailableAtHtml",
    value: function roomsAvailableAtHtml(item) {
      if (item.RoomAvailableAtAsDate) {
        // this will only be populated for EMS PS and only if it is calculated
        var rat = moment(item.RoomAvailableAtAsDate);
        return /*#__PURE__*/React.createElement("div", null, rat.format("h:mm A"));
      }

      if (item.RoomAvailableAt) {
        var buildingLocalTime = moment(item.BuildingLocalEventStart);
        var roomAvailSort = moment(item.RoomAvailableAtSort);
        var raat = moment(item.BuildingLocalEventStart);
        var timeParts = item.RoomAvailableAt.split(':');
        raat = raat.hour(timeParts[0]);
        raat = raat.minute(timeParts[1]);

        if (roomAvailSort.isBefore(buildingLocalTime, 'day')) {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-chevron-left"
          }), "\xA0", raat.format("h:mm A"));
        } else {
          return /*#__PURE__*/React.createElement("div", null, raat.format("h:mm A"));
        }
      }

      return /*#__PURE__*/React.createElement("div", null, "\xA0");
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        editMode: !this.state.editMode
      });
    }
  }, {
    key: "selectChanged",
    value: function selectChanged(event) {
      var availAtTime = event.target.value;
      this.props.setAvailableAt(this.props.item, availAtTime);
      this.setState({
        editMode: false
      });
    }
  }, {
    key: "buildHtml",
    value: function buildHtml() {
      if (this.state.editMode) {
        var times = this.state.timeData;
        var selectedTime = ''; //var options

        if (this.props.item.RoomAvailableAt != null) {
          selectedTime = this.props.item.RoomAvailableAt;
        }

        return /*#__PURE__*/React.createElement("td", {
          className: "noPadding aaCell"
        }, /*#__PURE__*/React.createElement("select", {
          value: selectedTime,
          onChange: this.selectChanged
        }, /*#__PURE__*/React.createElement("option", {
          value: ""
        }), times.map(function (time, i) {
          return /*#__PURE__*/React.createElement("option", {
            key: time.value,
            value: time.value
          }, time.text);
        })), /*#__PURE__*/React.createElement("div", {
          className: "text-center"
        }, /*#__PURE__*/React.createElement("a", {
          onClick: this.toggle
        }, "cancel")));
      } else {
        return /*#__PURE__*/React.createElement("td", {
          onClick: this.toggle,
          className: "aaCell"
        }, this.roomsAvailableAtHtml(this.props.item));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.buildHtml();
    }
  }]);

  return AvailableAtCell;
}(React.Component);

AvailableAtCell.propTypes = {
  item: React.PropTypes.object,
  setAvailableAt: React.PropTypes.func
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AddEmsNoteModal = /*#__PURE__*/function (_React$Component) {
  _inherits(AddEmsNoteModal, _React$Component);

  var _super = _createSuper(AddEmsNoteModal);

  function AddEmsNoteModal(props) {
    var _this;

    _classCallCheck(this, AddEmsNoteModal);

    _this = _super.call(this, props);
    _this.addNote = _this.addNote.bind(_assertThisInitialized(_this));
    _this.addAndClose = _this.addAndClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AddEmsNoteModal, [{
    key: "addNote",
    value: function addNote() {
      var that = this;
      var notes = $("#newNote").val();

      if (notes) {
        var dto = {
          BookingId: this.props.item.BookingId,
          Note: $("#newNote").val()
        };
        this.props.apiService.saveItem('api/DailySetup/AddEmsNote', dto).then(function (response) {
          if (response.data) {
            that.props.updateItemForBookingAction(response.data);
            that.props.updateItemInCollection(response.data);
          }
        }, function (error) {
          console.log(error);
        });
      } //this.props.notesDataService.newNote(note, this.props.item);


      $("#newNote").val("");
    }
  }, {
    key: "addAndClose",
    value: function addAndClose() {
      this.addNote();
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName || this.props.item.TaskDescription)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsNoteModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Notes"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "text-left"
      }, "Note"), /*#__PURE__*/React.createElement("textarea", {
        id: "newNote",
        name: "newNote",
        className: "form-control"
      }))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.addAndClose
      }, "Ok")));
    }
  }]);

  return AddEmsNoteModal;
}(React.Component);

AddEmsNoteModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  apiService: React.PropTypes.object,
  updateItemForBookingAction: React.PropTypes.func,
  updateItemInCollection: React.PropTypes.func
};

var ActualCountModal = /*#__PURE__*/function (_React$Component2) {
  _inherits(ActualCountModal, _React$Component2);

  var _super2 = _createSuper(ActualCountModal);

  function ActualCountModal(props) {
    var _this2;

    _classCallCheck(this, ActualCountModal);

    _this2 = _super2.call(this, props);
    _this2.setActualAttendance = _this2.setActualAttendance.bind(_assertThisInitialized(_this2));
    _this2.addAndClose = _this2.addAndClose.bind(_assertThisInitialized(_this2));
    _this2.state = {
      value: ''
    };
    _this2.onChange = _this2.onChange.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(ActualCountModal, [{
    key: "setActualAttendance",
    value: function setActualAttendance() {
      var that = this;
      var count = this.state.value;

      if (count) {
        var dto = {
          Filters: this.props.filters,
          ActionDto: {
            BookingId: this.props.item.BookingId,
            ActualCount: count
          }
        };
        this.props.apiService.saveItem('api/DailySetup/UpdateActualCount', dto).then(function (response) {
          if (response.data) {
            that.props.updateItemForBookingAction(response.data);
            that.props.updateItemInCollection(response.data);
          }
        }, function (error) {
          console.log(error);
        });
      }

      this.setState({
        value: ""
      });
    }
  }, {
    key: "addAndClose",
    value: function addAndClose() {
      this.setActualAttendance();
      this.props.close();
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var re = /^[0-9\b]+$/;

      if (e.target.value == '' || re.test(e.target.value)) {
        this.setState({
          value: e.target.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsActualCountModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Actual Count"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "text-left",
        "for": "actualCount"
      }, "Actual Count"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        id: "actualCount",
        name: "actualCount",
        className: "form-control",
        value: this.state.value,
        onChange: this.onChange
      }))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.addAndClose
      }, "Ok"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Cancel")));
    }
  }]);

  return ActualCountModal;
}(React.Component);

ActualCountModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  apiService: React.PropTypes.object,
  close: React.PropTypes.func,
  updateItemForBookingAction: React.PropTypes.func,
  filters: React.PropTypes.object
};

var NoShowBookingModal = /*#__PURE__*/function (_React$Component3) {
  _inherits(NoShowBookingModal, _React$Component3);

  var _super3 = _createSuper(NoShowBookingModal);

  function NoShowBookingModal(props) {
    var _this3;

    _classCallCheck(this, NoShowBookingModal);

    _this3 = _super3.call(this, props);
    _this3.noShowBooking = _this3.noShowBooking.bind(_assertThisInitialized(_this3));
    _this3.saveAndClose = _this3.saveAndClose.bind(_assertThisInitialized(_this3));
    return _this3;
  }

  _createClass(NoShowBookingModal, [{
    key: "noShowBooking",
    value: function noShowBooking() {
      var that = this;
      var dto = {
        Filters: this.props.filters,
        ActionDto: {
          BookingId: this.props.item.BookingId
        }
      };
      this.props.apiService.saveItem('api/DailySetup/NoShowBooking', dto).then(function (response) {
        if (response.data) {
          that.props.updateItemForBookingAction(response.data);
          that.props.updateItemInCollection(response.data);
        }
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.noShowBooking();
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsNoShowBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Are you sure you want to No Show this meeting?"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, "This action can not be undone.  Are you sure?")))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return NoShowBookingModal;
}(React.Component);

NoShowBookingModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  apiService: React.PropTypes.object,
  close: React.PropTypes.func,
  settings: React.PropTypes.array,
  updateItemForBookingAction: React.PropTypes.func,
  filters: React.PropTypes.object,
  updateItemInCollection: React.PropTypes.func
};

var ExtendBookingModal = /*#__PURE__*/function (_React$Component4) {
  _inherits(ExtendBookingModal, _React$Component4);

  var _super4 = _createSuper(ExtendBookingModal);

  function ExtendBookingModal(props) {
    var _this4;

    _classCallCheck(this, ExtendBookingModal);

    _this4 = _super4.call(this, props);
    _this4.extendBooking = _this4.extendBooking.bind(_assertThisInitialized(_this4));
    _this4.saveAndClose = _this4.saveAndClose.bind(_assertThisInitialized(_this4));
    _this4.state = {
      potentialDurations: [5, 15, 30, 60, 120],
      selectedDuration: 30
    };
    return _this4;
  }

  _createClass(ExtendBookingModal, [{
    key: "extendBooking",
    value: function extendBooking() {
      var that = this;
      var dto = {
        Filters: this.props.filters,
        ActionDto: {
          BookingId: this.props.item.BookingId,
          ExtendForXMinutes: that.state.selectedDuration
        }
      };
      this.props.apiService.saveItem('api/DailySetup/ExtendBooking', dto).then(function (response) {
        if (response.status != 200) {
          that.props.common.logger.error("There was a problem extending your meeting");
        } else if (response.data) {
          that.props.updateItemForBookingAction(response.data);
          that.props.updateItemInCollection(response.data);
        }
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.extendBooking();
      this.props.close();
    }
  }, {
    key: "durationClicked",
    value: function durationClicked(d) {
      this.setState({
        selectedDuration: d
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsNoExtendBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Extend this meeting?"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", null, "How much longer: "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "btn-group"
      }, this.state.potentialDurations.map(function (d) {
        var cn = d == _this5.state.selectedDuration ? "btn btn-success" : " btn btn-grey";
        var text = d <= 30 ? d + " min" : d == 60 ? "1 hr" : d / 60 + " hr";
        return /*#__PURE__*/React.createElement("button", {
          className: cn,
          onClick: function onClick() {
            return _this5.durationClicked(d);
          }
        }, text);
      })))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return ExtendBookingModal;
}(React.Component);

ExtendBookingModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  apiService: React.PropTypes.object,
  close: React.PropTypes.func,
  settings: React.PropTypes.array,
  updateItemForBookingAction: React.PropTypes.func,
  filters: React.PropTypes.object,
  updateItemInCollection: React.PropTypes.func
};

var EndBookingModal = /*#__PURE__*/function (_React$Component5) {
  _inherits(EndBookingModal, _React$Component5);

  var _super5 = _createSuper(EndBookingModal);

  function EndBookingModal(props) {
    var _this6;

    _classCallCheck(this, EndBookingModal);

    _this6 = _super5.call(this, props);
    _this6.endBooking = _this6.endBooking.bind(_assertThisInitialized(_this6));
    _this6.saveAndClose = _this6.saveAndClose.bind(_assertThisInitialized(_this6));
    return _this6;
  }

  _createClass(EndBookingModal, [{
    key: "endBooking",
    value: function endBooking() {
      var that = this;
      var dto = {
        Filters: this.props.filters,
        ActionDto: {
          BookingId: this.props.item.BookingId
        }
      };
      this.props.apiService.saveItem('api/DailySetup/EndBooking', dto).then(function (response) {
        if (response.data) {
          that.props.updateItemForBookingAction(response.data);
          that.props.updateItemInCollection(response.data);
        }
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.endBooking();
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsEndBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Are you sure you want to end this meeting?"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, "This action can not be undone.  Are you sure?")))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return EndBookingModal;
}(React.Component);

var ClearServiceModal = /*#__PURE__*/function (_React$Component6) {
  _inherits(ClearServiceModal, _React$Component6);

  var _super6 = _createSuper(ClearServiceModal);

  function ClearServiceModal(props) {
    var _this7;

    _classCallCheck(this, ClearServiceModal);

    _this7 = _super6.call(this, props);
    _this7.clearService = _this7.clearService.bind(_assertThisInitialized(_this7));
    _this7.saveAndClose = _this7.saveAndClose.bind(_assertThisInitialized(_this7));
    return _this7;
  }

  _createClass(ClearServiceModal, [{
    key: "clearService",
    value: function clearService() {
      var that = this;
      var dto = {
        Filters: this.props.filters,
        ActionDto: {
          BookingId: this.props.item.BookingId
        }
      };
      this.props.apiService.saveItem('api/DailySetup/ClearServiceMode', dto).then(function (response) {
        if (response.data) {
          that.props.updateItemForBookingAction(response.data);
          that.props.updateItemInCollection(response.data);
        }
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.clearService();
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsEndBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Clear service mode for this room?"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, "Are you sure?")))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return ClearServiceModal;
}(React.Component);

var ConfirmCheckinModal = /*#__PURE__*/function (_React$Component7) {
  _inherits(ConfirmCheckinModal, _React$Component7);

  var _super7 = _createSuper(ConfirmCheckinModal);

  function ConfirmCheckinModal(props) {
    var _this8;

    _classCallCheck(this, ConfirmCheckinModal);

    _this8 = _super7.call(this, props);
    _this8.confirmCheckin = _this8.confirmCheckin.bind(_assertThisInitialized(_this8));
    _this8.saveAndClose = _this8.saveAndClose.bind(_assertThisInitialized(_this8));
    return _this8;
  }

  _createClass(ConfirmCheckinModal, [{
    key: "confirmCheckin",
    value: function confirmCheckin() {
      var that = this;
      var dto = {
        Filters: this.props.filters,
        ActionDto: {
          BookingId: this.props.item.BookingId
        }
      };
      this.props.apiService.saveItem('api/DailySetup/BookingCheckin', dto).then(function (response) {
        if (response.data) {
          that.props.updateItemForBookingAction(response.data);
          that.props.updateItemInCollection(response.data);
        }
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.confirmCheckin();
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.EventName)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsEndBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Booking Check-In"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, "Are you sure you want to check this booking in?")))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return ConfirmCheckinModal;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BookingHistoryModal = /*#__PURE__*/function (_React$Component) {
  _inherits(BookingHistoryModal, _React$Component);

  var _super = _createSuper(BookingHistoryModal);

  function BookingHistoryModal(props) {
    _classCallCheck(this, BookingHistoryModal);

    return _super.call(this, props);
  }

  _createClass(BookingHistoryModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, "Booking History")), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, null, /*#__PURE__*/React.createElement("table", {
        className: "table table-condensed table-striped"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Field"), /*#__PURE__*/React.createElement("th", null, "Old Value"), /*#__PURE__*/React.createElement("th", null, "New Value"), /*#__PURE__*/React.createElement("th", null, "History Date"))), /*#__PURE__*/React.createElement("tbody", null, (this.props.item.history == null || this.props.item.history.length == 0) && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "4"
      }, "New Booking or New/Changed Services")), this.props.item.history && this.props.item.history.length > 0 && this.props.item.history.map(function (h) {
        return /*#__PURE__*/React.createElement("tr", {
          key: h.HistoryUniqueId
        }, /*#__PURE__*/React.createElement("td", null, h.FieldName), /*#__PURE__*/React.createElement("td", null, h.OldValue), /*#__PURE__*/React.createElement("td", null, h.NewValue), /*#__PURE__*/React.createElement("td", null, moment(moment.utc(h.DateChangedUtc).toDate()).format("L LT")));
      })))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Close")));
    }
  }]);

  return BookingHistoryModal;
}(React.Component);

BookingHistoryModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EventsTable = /*#__PURE__*/function (_React$Component) {
  _inherits(EventsTable, _React$Component);

  var _super = _createSuper(EventsTable);

  function EventsTable(props) {
    var _this;

    _classCallCheck(this, EventsTable);

    _this = _super.call(this, props);
    _this.hideNewTaskModal = _this.hideNewTaskModal.bind(_assertThisInitialized(_this));
    _this.showNewTaskModal = _this.showNewTaskModal.bind(_assertThisInitialized(_this));
    _this.showAddEmsNoteModal = _this.showAddEmsNoteModal.bind(_assertThisInitialized(_this));
    _this.hideAddEmsNoteModal = _this.hideAddEmsNoteModal.bind(_assertThisInitialized(_this));
    _this.showActualCountModal = _this.showActualCountModal.bind(_assertThisInitialized(_this));
    _this.hideActualCountModal = _this.hideActualCountModal.bind(_assertThisInitialized(_this));
    _this.showNoShowBookingModal = _this.showNoShowBookingModal.bind(_assertThisInitialized(_this));
    _this.hideNoShowBookingModal = _this.hideNoShowBookingModal.bind(_assertThisInitialized(_this));
    _this.showExtendBookingModal = _this.showExtendBookingModal.bind(_assertThisInitialized(_this));
    _this.showEndBookingModal = _this.showEndBookingModal.bind(_assertThisInitialized(_this));
    _this.showClearServiceModal = _this.showClearServiceModal.bind(_assertThisInitialized(_this));
    _this.showConfirmCheckinModal = _this.showConfirmCheckinModal.bind(_assertThisInitialized(_this));
    _this.hideConfirmCheckinModal = _this.hideConfirmCheckinModal.bind(_assertThisInitialized(_this));
    _this.hideExtendBookingModal = _this.hideExtendBookingModal.bind(_assertThisInitialized(_this));
    _this.updateItemInCollection = _this.updateItemInCollection.bind(_assertThisInitialized(_this));
    _this.hideEndBookingModal = _this.hideEndBookingModal.bind(_assertThisInitialized(_this));
    _this.hideClearServiceModal = _this.hideClearServiceModal.bind(_assertThisInitialized(_this));
    _this.isAllDone = _this.isAllDone.bind(_assertThisInitialized(_this));
    _this.showRow = _this.showRow.bind(_assertThisInitialized(_this));
    _this.sort = _this.sort.bind(_assertThisInitialized(_this));
    _this.state = {
      newTaskModalItem: {},
      newTaskModalShowing: false,
      actualCountModalShowing: false,
      servicesShowFor: [],
      linkedTaskModalItem: {},
      addEmsNoteModalShowing: false,
      noShowBookingModalShowing: false,
      extendBookingModalShowing: false,
      clearServiceModalShowing: false,
      endBookingModalShowing: false,
      confirmCheckinModalShowing: false,
      bookingActionItem: {},
      taskTemplates: []
    };
    return _this;
  }

  _createClass(EventsTable, [{
    key: "sort",
    value: function sort(propertyName, parser, sortPropertyName) {
      this.props.sort(this.props.items, propertyName, parser, sortPropertyName);
    }
  }, {
    key: "hideNewTaskModal",
    value: function hideNewTaskModal() {
      this.setState({
        newTaskModalShowing: false
      });
    }
  }, {
    key: "showAddEmsNoteModal",
    value: function showAddEmsNoteModal(item) {
      this.setState({
        addEmsNoteModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "hideAddEmsNoteModal",
    value: function hideAddEmsNoteModal() {
      this.setState({
        addEmsNoteModalShowing: false
      });
    }
  }, {
    key: "showActualCountModal",
    value: function showActualCountModal(item) {
      this.setState({
        actualCountModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "showExtendBookingModal",
    value: function showExtendBookingModal(item) {
      this.setState({
        extendBookingModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "hideExtendBookingModal",
    value: function hideExtendBookingModal() {
      this.setState({
        extendBookingModalShowing: false
      });
    }
  }, {
    key: "showEndBookingModal",
    value: function showEndBookingModal(item) {
      this.setState({
        endBookingModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "showClearServiceModal",
    value: function showClearServiceModal(item) {
      this.setState({
        clearServiceModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "hideClearServiceModal",
    value: function hideClearServiceModal() {
      this.setState({
        clearServiceModalShowing: false
      });
    }
  }, {
    key: "showConfirmCheckinModal",
    value: function showConfirmCheckinModal(item) {
      this.setState({
        confirmCheckinModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "hideConfirmCheckinModal",
    value: function hideConfirmCheckinModal() {
      this.setState({
        confirmCheckinModalShowing: false
      });
    }
  }, {
    key: "hideEndBookingModal",
    value: function hideEndBookingModal() {
      this.setState({
        endBookingModalShowing: false
      });
    }
  }, {
    key: "hideActualCountModal",
    value: function hideActualCountModal() {
      this.setState({
        actualCountModalShowing: false
      });
    }
  }, {
    key: "showNoShowBookingModal",
    value: function showNoShowBookingModal(item) {
      this.setState({
        noShowBookingModalShowing: true,
        bookingActionItem: item
      });
    }
  }, {
    key: "hideNoShowBookingModal",
    value: function hideNoShowBookingModal() {
      this.setState({
        noShowBookingModalShowing: false
      });
    }
  }, {
    key: "updateItemInCollection",
    value: function updateItemInCollection(item) {
      for (var i = 0; i < this.props.items.length; i++) {
        if (this.props.items[i]["BookingId"] === item["BookingId"]) {
          this.props.items[i] = item;
          break;
        }
      }
    }
  }, {
    key: "isAllDone",
    value: function isAllDone(item) {
      return this.props.completionsDataService.isAllDone(item);
    }
  }, {
    key: "showRow",
    value: function showRow(item) {
      if (this.props.dropBookingsWhenComplete && this.isAllDone(item)) {
        return false;
      }

      if (this.props.checkedInOnly && !item.IsCheckedIn) {
        return false;
      }

      return true;
    }
  }, {
    key: "showNewTaskModal",
    value: function showNewTaskModal(item) {
      this.props.openNewTaskModal(item);
      return;

      var _that = this;

      var linkedTask;
      this.props.slidesDataService.getItem("api/Tasks/0").then(function (response) {
        var allUsers = response.data.usersWithDepartments;
        var deptId = parseInt(window.localStorage.getItem("SevenPointTaskDepartmentId")) || 0;

        _that.setState({
          departments: response.data.departments,
          allUsers: allUsers,
          taskTemplates: response.data.taskTemplates
        });

        linkedTask = {
          ID: -1,
          Description: "Set " + item.RoomDescription + " for " + item.EventName + " on " + moment(item.BuildingLocalEventStart).format("L"),
          StartAt: "06:00",
          FinishBy: "",
          DisplayOn: new Date().toISOString(),
          DepartmentIds: [deptId],
          DisplayUntil: "",
          //DisplayUntil: moment(item.BuildingLocalReseveredStart).add(-1, 'days').toDate().toISOString(),
          DisplaysOnSunday: 0,
          DisplaysOnMonday: 0,
          DisplaysOnTuesday: 0,
          DisplaysOnWednesday: 0,
          DisplaysOnThursday: 0,
          DisplaysOnFriday: 0,
          DisplaysOnSaturday: 0,
          LinkedBookingId: item.BookingId,
          AssignedToUserId: null
        };
        var usersInDepartments = [];

        for (var i = 0; i < allUsers.length; i++) {
          var user = allUsers[i];

          for (var j = 0; j < user.Departments.length; j++) {
            if (deptId == user.Departments[j]) {
              usersInDepartments.push(user);
            }
          }
        }

        _that.setState({
          newTaskModalShowing: true,
          newTaskModalItem: linkedTask,
          linkedTaskModalItem: item,
          initialUsersInDepartment: usersInDepartments
        });
      }, function (error) {});
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var canShowLocationDetails = this.props.userService.apiTypeId() !== "4D2BFEBD-7631-4AEE-96CF-392CFA0BFB3A" && this.props.userService.apiTypeId() !== "5C088F8B-7D16-4C06-B691-7E6FCD4344AD";
      var haveNoShowStatus = false;
      var showAvailAt = true;
      var serviceHighlightColor = "";
      var nothingDoneColor = "red";

      for (var i = 0; i < this.props.settings.length; i++) {
        if (this.props.settings[i].SettingKey === "NoShowStatusId") {
          if (this.props.settings[i].SettingValue > 0) {
            haveNoShowStatus = true;
          }
        } else if (this.props.settings[i].SettingKey === "AvailableAtTimeToUse") {
          if (this.props.settings[i].SettingValue.toLowerCase() === 'fb35dae1-e2e8-4aac-b5c0-6236e594acc9') {
            showAvailAt = false;
          }
        } else if (this.props.settings[i].SettingKey === "ServiceHighlightColor") {
          serviceHighlightColor = this.props.settings[i].SettingValue;
        } else if (this.props.settings[i].SettingKey === "NothingDoneDotColor") {
          nothingDoneColor = this.props.settings[i].SettingValue;
        }
      }

      var udfLabel = this.props.userService.apiTypeId() === "355A9B3B-BF7E-4D96-8B06-27B310EB01F0" ? "Custom Attributes" : "User Defined Fields";
      var resTimeLabel = null;
      var resEndTimeLabel = null;
      var brLabel = null;

      if (this.props.showReservedTime) {
        resTimeLabel = /*#__PURE__*/React.createElement("span", {
          className: this.props.sortHeaderClass("BuildingLocalReseveredStart"),
          onClick: function onClick() {
            return _this2.sort('BuildingLocalReseveredStart');
          }
        }, "Res Start");
        resEndTimeLabel = /*#__PURE__*/React.createElement("span", {
          className: this.props.sortHeaderClass("BuildingLocalReseveredEnd"),
          onClick: function onClick() {
            return _this2.sort('BuildingLocalReseveredEnd');
          }
        }, "Res End");
        brLabel = /*#__PURE__*/React.createElement("br", null);
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
        id: "dailySetupBookings",
        className: "responsiveTable dailySetup table table-condensed table-striped-hiddenRows"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, "Recent Changes")), /*#__PURE__*/React.createElement("th", {
        className: "dotColumn"
      }, "Done"), showAvailAt && /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 80 + 'px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.props.sortHeaderClass("RoomAvailableAtSort"),
        onClick: function onClick() {
          return _this2.sort('RoomAvailableAt', null, 'RoomAvailableAtSort');
        }
      }, "Available")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 85 + 'px'
        }
      }, resTimeLabel, brLabel, /*#__PURE__*/React.createElement("span", {
        className: this.props.sortHeaderClass("BuildingLocalEventStart"),
        onClick: function onClick() {
          return _this2.sort('BuildingLocalEventStart');
        }
      }, "Evt Start")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 80 + 'px'
        }
      }, resEndTimeLabel, brLabel, /*#__PURE__*/React.createElement("span", {
        className: this.props.sortHeaderClass("BuildingLocalEventEnd"),
        onClick: function onClick() {
          return _this2.sort('BuildingLocalEventEnd');
        }
      }, "Evt End")), /*#__PURE__*/React.createElement("th", {
        className: "pointer"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.sort('RoomDescription');
        },
        className: this.props.sortHeaderClass("RoomDescription")
      }, "Location"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.sort('EventName');
        },
        className: this.props.sortHeaderClass("EventName")
      }, "Event Name")), /*#__PURE__*/React.createElement("th", {
        className: "pointer"
      }, /*#__PURE__*/React.createElement("span", {
        className: this.props.sortHeaderClass("GroupName"),
        onClick: function onClick() {
          return _this2.sort('GroupName');
        }
      }, "Group"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: this.props.sortHeaderClass("FirstContact"),
        onClick: function onClick() {
          return _this2.sort('FirstContact');
        }
      }, "Contact")), /*#__PURE__*/React.createElement("th", {
        className: "pointer " + this.props.sortHeaderClass("Status.Description"),
        onClick: function onClick() {
          return _this2.sort('Status.Description');
        }
      }, "Status", /*#__PURE__*/React.createElement("br", null), "Event Type"), /*#__PURE__*/React.createElement("th", null, "Actions"), /*#__PURE__*/React.createElement("th", {
        className: "servicesColumn"
      }, "Details"), /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, "Linked Task")))), this.props.items.length === 0 && /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "11"
      }, this.props.noEventsMessage))), this.props.items.map(function (item) {
        return /*#__PURE__*/React.createElement("tbody", {
          key: item.BookingId
        }, /*#__PURE__*/React.createElement(BookingRow, {
          key: item.BookingId,
          item: item,
          minutesSinceLastChange: _this2.props.minutesSinceLastChange,
          showReservedTime: _this2.props.showReservedTime,
          settings: _this2.props.settings,
          completionTypes: _this2.props.completionTypes,
          getHistoryForBooking: _this2.props.getHistoryForBooking,
          completionsDataService: _this2.props.completionsDataService,
          showCompletionModal: _this2.props.showCompletionModal,
          showHistoryModal: _this2.props.showHistoryModal,
          allCompletionTypes: _this2.props.allCompletionTypes,
          setAvailableAt: _this2.props.setAvailableAt,
          showNotesModal: _this2.props.showNotesModal,
          showCarouselModal: _this2.props.showCarouselModal,
          showNewTaskModal: _this2.showNewTaskModal,
          showExtendBookingModal: _this2.showExtendBookingModal,
          showEndBookingModal: _this2.showEndBookingModal,
          toggleServices: _this2.props.toggleServices,
          showAddEmsNoteModal: _this2.showAddEmsNoteModal,
          showActualCountModal: _this2.showActualCountModal,
          showNoShowBookingModal: _this2.showNoShowBookingModal,
          showNoShowAction: _this2.props.showNoShowAction,
          showEstimatedCountAction: _this2.props.showEstimatedCountAction,
          showAddToCalendarAction: _this2.props.showAddToCalendarAction,
          onDate: _this2.props.onDate,
          haveNoShowStatus: haveNoShowStatus,
          showAvailAt: showAvailAt,
          apiService: _this2.props.slidesDataService,
          userService: _this2.props.userService,
          limitCompletionsByDeparments: _this2.props.limitCompletionsByDeparments,
          nothingDoneColor: nothingDoneColor,
          showLocationDetailsModal: _this2.props.showLocationDetailsModal,
          canShowLocationDetails: canShowLocationDetails,
          showRow: _this2.showRow(item),
          showRoomCode: _this2.props.showRoomCode,
          showClearServiceModal: _this2.showClearServiceModal,
          showConfirmCheckinModal: _this2.showConfirmCheckinModal
        }), _this2.showRow(item) && item.Services.length > 0 && (item.servicesShowing || _this2.props.expandAllServices) && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colSpan: "11"
        }, /*#__PURE__*/React.createElement("div", {
          className: "detailsHeading"
        }, "Services"), /*#__PURE__*/React.createElement(ServicesList, {
          services: item.Services,
          apiService: _this2.props.slidesDataService,
          filters: _this2.props.filters,
          updateItemForBookingAction: _this2.props.updateItemForBookingAction,
          updateItemInCollection: _this2.updateItemInCollection,
          minutesSinceLastChange: _this2.props.minutesSinceLastChange,
          highlightColor: serviceHighlightColor
        }))), _this2.showRow(item) && item.Udfs !== null && item.Udfs.length > 0 && (item.servicesShowing || _this2.props.expandAllServices) && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colSpan: "11"
        }, /*#__PURE__*/React.createElement("div", {
          className: "detailsHeading"
        }, udfLabel), /*#__PURE__*/React.createElement(UdfsList, {
          udfs: item.Udfs
        }))), _this2.showRow(item) && item.LinkedTasks && item.LinkedTasks.length > 0 && (item.servicesShowing || _this2.props.expandAllServices) && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colSpan: "11"
        }, /*#__PURE__*/React.createElement("div", {
          className: "detailsHeading"
        }, "Linked Tasks"), /*#__PURE__*/React.createElement("div", {
          style: {
            width: 95 + "%"
          },
          className: "center"
        }, /*#__PURE__*/React.createElement("table", {
          width: "100%"
        }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
          className: "dotColumn"
        }, "Done"), /*#__PURE__*/React.createElement("th", {
          className: "pointer",
          style: {
            width: 13 + "%"
          }
        }, "Start At"), /*#__PURE__*/React.createElement("th", {
          className: "pointer",
          style: {
            width: 13 + "%"
          }
        }, "Finish By"), /*#__PURE__*/React.createElement("th", {
          className: "pointer",
          style: {
            width: 10 + "%"
          }
        }, "Department"), /*#__PURE__*/React.createElement("th", {
          className: "pointer",
          style: {
            width: 10 + "%"
          }
        }, "Assigned To"), /*#__PURE__*/React.createElement("th", {
          className: "pointer",
          style: {
            width: 34 + "%"
          }
        }, "Description"), /*#__PURE__*/React.createElement("th", {
          style: {
            width: 5 + "%"
          }
        }, "Notes"), /*#__PURE__*/React.createElement("th", {
          style: {
            width: 5 + "%"
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "sr-only"
        }, "Linked Tasks")))), item.LinkedTasks.map(function (task) {
          return /*#__PURE__*/React.createElement(TaskRow, {
            key: task.TaskId,
            item: task,
            includeDate: true,
            showCompletionModal: _this2.props.showCompletionModal,
            showNotesModal: _this2.props.showNotesModal,
            canEditTask: _this2.props.canEditTask,
            editTask: _this2.props.editTask,
            showHistoryModal: _this2.props.showHistoryModal,
            settings: _this2.props.settings,
            completionsDataService: _this2.props.completionsDataService,
            allCompletionTypes: _this2.props.allCompletionTypes,
            getLinkedBooking: _this2.props.getLinkedBooking,
            toggleServices: _this2.props.toggleServices,
            showCarouselModal: _this2.props.showCarouselModal,
            userService: _this2.props.userService,
            limitCompletionsByDeparments: _this2.props.limitCompletionsByDeparments,
            nothingDoneColor: nothingDoneColor,
            hideLinkedBooking: true
          });
        }))))));
      })), /*#__PURE__*/React.createElement(NewTaskModal, {
        show: this.state.newTaskModalShowing,
        linkedTask: this.state.newTaskModalItem,
        departments: this.state.departments,
        allUsers: this.state.allUsers,
        close: this.hideNewTaskModal,
        apiService: this.props.slidesDataService,
        updateBookingWithTaskId: this.props.updateBookingWithTaskId,
        linkedTaskModalItem: this.state.linkedTaskModalItem,
        initialUsersInDepartment: this.state.initialUsersInDepartment,
        taskTemplates: this.state.taskTemplates
      }), /*#__PURE__*/React.createElement(AddEmsNoteModal, {
        show: this.state.addEmsNoteModalShowing,
        close: this.hideAddEmsNoteModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection
      }), /*#__PURE__*/React.createElement(ActualCountModal, {
        show: this.state.actualCountModalShowing,
        close: this.hideActualCountModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection
      }), /*#__PURE__*/React.createElement(NoShowBookingModal, {
        settings: this.props.settings,
        show: this.state.noShowBookingModalShowing,
        close: this.hideNoShowBookingModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection
      }), /*#__PURE__*/React.createElement(ExtendBookingModal, {
        settings: this.props.settings,
        show: this.state.extendBookingModalShowing,
        close: this.hideExtendBookingModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection,
        common: this.props.common
      }), /*#__PURE__*/React.createElement(EndBookingModal, {
        settings: this.props.settings,
        show: this.state.endBookingModalShowing,
        close: this.hideEndBookingModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection,
        common: this.props.common
      }), /*#__PURE__*/React.createElement(ClearServiceModal, {
        settings: this.props.settings,
        show: this.state.clearServiceModalShowing,
        close: this.hideClearServiceModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection,
        common: this.props.common
      }), /*#__PURE__*/React.createElement(ConfirmCheckinModal, {
        settings: this.props.settings,
        show: this.state.confirmCheckinModalShowing,
        close: this.hideConfirmCheckinModal,
        item: this.state.bookingActionItem,
        apiService: this.props.slidesDataService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.updateItemInCollection,
        common: this.props.common
      }));
    }
  }]);

  return EventsTable;
}(React.Component);

EventsTable.propTypes = {
  items: React.PropTypes.array,
  showReservedTime: React.PropTypes.bool,
  minutesSinceLastChange: React.PropTypes.number,
  settings: React.PropTypes.array,
  expandAllServices: React.PropTypes.bool,
  allCompletionTypes: React.PropTypes.array,
  getHistoryForBooking: React.PropTypes.func,
  completionsDataService: React.PropTypes.object,
  setAvailableAt: React.PropTypes.func,
  notesDataService: React.PropTypes.object,
  userService: React.PropTypes.object,
  sort: React.PropTypes.func,
  sortProperty: React.PropTypes.string,
  sortIsDesc: React.PropTypes.bool,
  slidesDataService: React.PropTypes.object,
  showCarouselModal: React.PropTypes.func,
  toggleServices: React.PropTypes.func,
  noEventsMessage: React.PropTypes.string,
  toggleFullView: React.PropTypes.func,
  updateBookingWithTaskId: React.PropTypes.func.isRequired,
  showNoShowAction: React.PropTypes.bool,
  showEstimatedCountAction: React.PropTypes.bool,
  showAddToCalendarAction: React.PropTypes.bool,
  updateItemForBookingAction: React.PropTypes.func,
  filters: React.PropTypes.object
};

var BookingRow = /*#__PURE__*/function (_React$Component2) {
  _inherits(BookingRow, _React$Component2);

  var _super2 = _createSuper(BookingRow);

  function BookingRow(props) {
    var _this3;

    _classCallCheck(this, BookingRow);

    _this3 = _super2.call(this, props);
    _this3.toggleServices = _this3.toggleServices.bind(_assertThisInitialized(_this3));
    _this3.isAllDone = _this3.isAllDone.bind(_assertThisInitialized(_this3));
    _this3.bookingActionSelect = _this3.bookingActionSelect.bind(_assertThisInitialized(_this3));
    return _this3;
  }

  _createClass(BookingRow, [{
    key: "toggleServices",
    value: function toggleServices() {
      this.props.toggleServices(this.props.item);
    }
  }, {
    key: "bookingActionSelect",
    value: function bookingActionSelect(eventKey) {
      if (eventKey == 1) {
        this.props.showAddEmsNoteModal(this.props.item);
      }

      if (eventKey == 2) {
        this.props.showNoShowBookingModal(this.props.item);
      }

      if (eventKey == 3) {
        this.props.showActualCountModal(this.props.item);
      }

      if (eventKey == 4) {
        this.props.completionsDataService.getIcs(this.props.item);
      }

      if (eventKey == 6) {
        this.props.showLocationDetailsModal(this.props.item);
      }

      if (eventKey == 7) {
        this.props.showExtendBookingModal(this.props.item);
      }

      if (eventKey == 8) {
        this.props.showEndBookingModal(this.props.item);
      }

      if (eventKey == 9) {
        this.props.showClearServiceModal(this.props.item);
      }

      if (eventKey == 10) {
        this.props.showConfirmCheckinModal(this.props.item);
      }
    }
  }, {
    key: "isAllDone",
    value: function isAllDone() {
      var lastCompletion = this.props.completionsDataService.getLastCompletionForType(0, this.props.item);

      if (lastCompletion) {
        if (lastCompletion.CompletedAtUtc != null) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var tId = this.props.userService.tenantId();
      var showExtendBooking = false;
      var showEndBooking = false;
      var showCheckin = false;
      var allowedIds = ["1", "166", "155"];

      if (allowedIds.indexOf(tId) >= 0) {
        showExtendBooking = true;
      }

      var allowedEndIds = ["1", "166"];

      if (allowedEndIds.indexOf(tId) >= 0) {
        showEndBooking = true;
      }

      var showNoShow = this.props.haveNoShowStatus;
      var startTimeCell = null;
      var endTimeCell = null;
      var onDate = moment(this.props.onDate);
      var reservedStart = moment(this.props.item.BuildingLocalReseveredStart);
      var eventStart = moment(this.props.item.BuildingLocalEventStart);
      var eventEnd = moment(this.props.item.BuildingLocalEventEnd);
      var now = moment();

      if (now.isBefore(eventStart) || now.isAfter(eventEnd)) {
        showEndBooking = false;
        showExtendBooking = false;

        if (tId == "166") {
          if (now.isBefore(eventStart) || now.isSame(eventStart, 'day') == false) {
            showExtendBooking = false;
          } else {
            showExtendBooking = true;
          }
        } else {
          showExtendBooking = false;
        }
      }

      if (tId == "166") {
        if (this.props.item.IsCheckedIn == false) {
          if (now.isAfter(eventStart) && now.isBefore(eventEnd)) {
            showCheckin = true;
          }
        }
      }

      var rowStyle = {};

      if (this.props.showReservedTime) {
        if (reservedStart.isBefore(onDate, 'day')) {
          startTimeCell = /*#__PURE__*/React.createElement("td", {
            className: "showResStartTime",
            onClick: this.toggleServices
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-chevron-left",
            title: "Previous Day"
          }), this.props.item.BuildingLocalReseveredStartDisplay, /*#__PURE__*/React.createElement("br", null), this.props.item.BuildingLocalEventStartDisplay);
        } else {
          startTimeCell = /*#__PURE__*/React.createElement(TwoRowCell, {
            cellStyle: rowStyle,
            cellClass: "showResStartTime",
            item: this.props.item,
            rowOne: this.props.item.BuildingLocalReseveredStartDisplay,
            rowTwo: this.props.item.BuildingLocalEventStartDisplay,
            toggleServices: this.toggleServices
          });
        }

        endTimeCell = /*#__PURE__*/React.createElement(TwoRowCell, {
          cellClass: "showResEndTime",
          item: this.props.item,
          rowOne: this.props.item.BuildingLocalReseveredEndDisplay,
          rowTwo: this.props.item.BuildingLocalEventEndDisplay,
          toggleServices: this.toggleServices
        });
      } else {
        if (eventStart.isBefore(onDate, 'day')) {
          startTimeCell = /*#__PURE__*/React.createElement("td", {
            cellClass: "hideResStartTime",
            toggleServices: this.toggleServices
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-chevron-left"
          }), this.props.item.BuildingLocalEventStartDisplay);
        } else {
          startTimeCell = /*#__PURE__*/React.createElement(Cell, {
            cellClass: "hideResStartTime",
            data: this.props.item.BuildingLocalEventStartDisplay,
            item: this.props.item,
            toggleServices: this.toggleServices
          });
        }

        endTimeCell = /*#__PURE__*/React.createElement(Cell, {
          cellClass: "hideResEndTime",
          data: this.props.item.BuildingLocalEventEndDisplay,
          item: this.props.item,
          toggleServices: this.toggleServices
        });
      }

      var rowClass = " bookingRow ";

      if (this.props.item.Status && this.props.item.Status.StatusType == -1) {
        rowClass += " cancelled";
      }

      if (this.props.item.MinutesSinceLastChange < this.props.minutesSinceLastChange) {
        rowClass += " recentlyChanged";
      }

      if ((!this.props.item.Services || this.props.item.Services.length === 0) && (!this.props.item.LinkedTasks || this.props.item.LinkedTasks.length === 0) && (!this.props.item.Udfs || this.props.item.Udfs.length === 0)) {
        rowClass += " noPointer";
      }

      var notesCell = null;
      var actionButtonStyle = null;

      if (this.props.item.RequiresAcknowledgement) {
        notesCell = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-comments fa-1-5x",
          title: "View/Add Notes"
        });
        actionButtonStyle = "warning";
      } else if (this.props.item.Notes && this.props.item.Notes.length > 0) {
        notesCell = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-comments fa-1-5x",
          title: "View/Add Notes"
        });
        actionButtonStyle = "primary";
      } else {
        notesCell = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-comments-o fa-1-5x",
          title: "Add Notes"
        });
        actionButtonStyle = "default";
      }

      return this.props.showRow && /*#__PURE__*/React.createElement("tr", {
        key: this.props.item.BookingId,
        className: "responsiveRow dailySetupRow" + rowClass
      }, /*#__PURE__*/React.createElement(RecentChangesCell, {
        item: this.props.item,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        showHistoryModal: this.props.showHistoryModal
      }), /*#__PURE__*/React.createElement(CompletionsCell, {
        item: this.props.item,
        showCompletionModal: this.props.showCompletionModal,
        allCompletionTypes: this.props.allCompletionTypes,
        completionsDataService: this.props.completionsDataService,
        isAllDone: this.isAllDone,
        userService: this.props.userService,
        limitCompletionsByDeparments: this.props.limitCompletionsByDeparments,
        nothingDoneColor: this.props.nothingDoneColor
      }), this.props.showAvailAt && /*#__PURE__*/React.createElement(AvailableAtCell, {
        item: this.props.item,
        setAvailableAt: this.props.setAvailableAt
      }), startTimeCell, endTimeCell, /*#__PURE__*/React.createElement(LocationEventNameCell, {
        showLocationDetailsModal: this.props.showLocationDetailsModal,
        item: this.props.item,
        showCarouselModal: this.props.showCarouselModal,
        toggleServices: this.toggleServices,
        showRoomCode: this.props.showRoomCode,
        userService: this.props.userService
      }), /*#__PURE__*/React.createElement(GroupContactCell, {
        item: this.props.item,
        apiService: this.props.apiService,
        userService: this.props.userService
      }), /*#__PURE__*/React.createElement(TwoRowCell, {
        cellClass: "seCell",
        rowOne: this.props.item.Status.Description,
        rowTwo: this.props.item.EventType,
        item: this.props.item,
        toggleServices: this.toggleServices
      }), /*#__PURE__*/React.createElement("td", {
        className: "aCell"
      }, this.props.showNoShowAction == false && this.props.showEstimatedCountAction == false && this.props.showAddToCalendarAction == false && /*#__PURE__*/React.createElement("a", {
        onClick: this.props.showNotesModal.bind(this, this.props.item)
      }, notesCell), (this.props.showNoShowAction || this.props.showEstimatedCountAction || this.props.showAddToCalendarAction) && /*#__PURE__*/React.createElement(ReactBootstrap.ButtonToolbar, null, /*#__PURE__*/React.createElement(ReactBootstrap.Dropdown, null, /*#__PURE__*/React.createElement(ReactBootstrap.Dropdown.Toggle, {
        noCaret: true,
        bsStyle: actionButtonStyle,
        "aria-label": "Open booking actions menu"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Glyphicon, {
        glyph: "pencil"
      })), /*#__PURE__*/React.createElement(ReactBootstrap.Dropdown.Menu, null, /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "1",
        onSelect: this.props.showNotesModal.bind(this, this.props.item)
      }, notesCell, "\xA0Notes"), this.props.showNoShowAction && showNoShow && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "2",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-close fa-1-5x",
        title: "No Show"
      }), "\xA0No Show"), this.props.showEstimatedCountAction && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "3",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-user fa-1-5x",
        title: "Actual Count"
      }), "\xA0Actual Count (", this.props.item.ActualCount, ")"), this.props.showAddToCalendarAction && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "4",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-calendar fa-1-5x",
        title: "Download ICS"
      }), "\xA0Add To Calendar"), /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "5",
        onSelect: this.props.showNewTaskModal.bind(this, this.props.item)
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check-square-o ",
        title: "Add Task"
      }), "\xA0New Task"), this.props.canShowLocationDetails && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "6",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-building fa-1-5x",
        title: "Location Details"
      }), "\xA0Location Details"), showExtendBooking && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "7",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-forward fa-1-5x",
        title: "Extend Booking"
      }), "\xA0Extend"), showEndBooking && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "8",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-ban fa-1-5x",
        title: "End Booking"
      }), "\xA0End"), this.props.item.RoomNeedsSanitized && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "9",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check fa-1-5x",
        title: "Clear Service Mode"
      }), "\xA0Clear Service"), showCheckin && /*#__PURE__*/React.createElement(ReactBootstrap.MenuItem, {
        eventKey: "10",
        onSelect: this.bookingActionSelect
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check-circle fa-1-5x",
        title: "Check-in"
      }), "\xA0Check-in"))))), /*#__PURE__*/React.createElement(ServicesCell, {
        item: this.props.item,
        settings: this.props.settings,
        toggleServices: this.toggleServices,
        userService: this.props.userService
      }), /*#__PURE__*/React.createElement("td", null, !this.props.isRelatedBooking && moment(this.props.item.BuildingLocalEventStart).isAfter(moment(), 'day') && /*#__PURE__*/React.createElement("a", {
        onClick: this.props.showNewTaskModal.bind(this, this.props.item),
        href: "#"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa " + (this.props.item.LinkedTaskId > 0 ? "fa-check-square-o" : "fa-square-o"),
        title: (this.props.item.LinkedTaskId > 0 ? "Edit" : "Create") + " linked task"
      }), " ")));
    }
  }]);

  return BookingRow;
}(React.Component);

BookingRow.propTypes = {
  item: React.PropTypes.object,
  settings: React.PropTypes.array,
  showHistory: React.PropTypes.func,
  showCompletionModal: React.PropTypes.func,
  showHistoryModal: React.PropTypes.func,
  setAvailableAt: React.PropTypes.func,
  showCarouselModal: React.PropTypes.func,
  toggleServices: React.PropTypes.func,
  isRelatedBooking: React.PropTypes.bool,
  showAddEmsNoteModal: React.PropTypes.func,
  showNoShowAction: React.PropTypes.bool,
  showEstimatedCountAction: React.PropTypes.bool,
  showAddToCalendarAction: React.PropTypes.bool,
  limitCompletionsByDeparments: React.PropTypes.bool
};

var ServicesRow = /*#__PURE__*/function (_React$Component3) {
  _inherits(ServicesRow, _React$Component3);

  var _super3 = _createSuper(ServicesRow);

  function ServicesRow(props) {
    _classCallCheck(this, ServicesRow);

    return _super3.call(this, props);
  }

  _createClass(ServicesRow, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("tr", {
        key: this.props.item.BookingId
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: 11
      }));
    }
  }]);

  return ServicesRow;
}(React.Component);

ServicesRow.propTypes = {
  item: React.PropTypes.object
};

var Cell = /*#__PURE__*/function (_React$Component4) {
  _inherits(Cell, _React$Component4);

  var _super4 = _createSuper(Cell);

  function Cell(props) {
    _classCallCheck(this, Cell);

    return _super4.call(this, props);
  }

  _createClass(Cell, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("td", {
        className: this.props.cellClass,
        onClick: this.props.toggleServices
      }, this.props.data);
    }
  }]);

  return Cell;
}(React.Component);

Cell.propTypes = {
  data: React.PropTypes.string,
  toggleServices: React.PropTypes.func,
  cellClass: React.PropTypes.string
};

var TwoRowCell = /*#__PURE__*/function (_React$Component5) {
  _inherits(TwoRowCell, _React$Component5);

  var _super5 = _createSuper(TwoRowCell);

  function TwoRowCell(props) {
    _classCallCheck(this, TwoRowCell);

    return _super5.call(this, props);
  }

  _createClass(TwoRowCell, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("td", {
        style: this.props.cellStyle,
        className: this.props.cellClass,
        onClick: this.props.toggleServices
      }, this.props.rowOne, /*#__PURE__*/React.createElement("br", null), this.props.rowTwo);
    }
  }]);

  return TwoRowCell;
}(React.Component);

TwoRowCell.propTypes = {
  rowOne: React.PropTypes.string,
  rowTwo: React.PropTypes.string,
  toggleServices: React.PropTypes.func,
  cellClass: React.PropTypes.string
};

var LocationEventNameCell = /*#__PURE__*/function (_React$Component6) {
  _inherits(LocationEventNameCell, _React$Component6);

  var _super6 = _createSuper(LocationEventNameCell);

  function LocationEventNameCell(props) {
    var _this4;

    _classCallCheck(this, LocationEventNameCell);

    _this4 = _super6.call(this, props);
    _this4.pointerClass = _this4.pointerClass.bind(_assertThisInitialized(_this4));
    return _this4;
  }

  _createClass(LocationEventNameCell, [{
    key: "pointerClass",
    value: function pointerClass(item) {
      if (item && item.Services && item.Services.length > 0) {
        return "pointer leCell";
      }

      return "leCell";
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var isMazevo = this.props.userService.apiTypeId() === "0E9DADB2-F56B-4E7E-A3B2-A59632C91D86";
      var checkinToolTip = "";

      if (this.props.item.LocalCheckin) {
        checkinToolTip = moment(this.props.item.LocalCheckin).format("LT");
      }

      var bcDash = null;

      if (this.props.item.BuildingCode) {
        bcDash = /*#__PURE__*/React.createElement("span", null, " - ");
      }

      var setupType = null;

      if (this.props.item.SetupType) {
        setupType = this.props.item.SetupType + ", ";
      }

      var roomDisplay = this.props.showRoomCode ? this.props.item.RoomCode : this.props.item.RoomDescription;
      return /*#__PURE__*/React.createElement("td", {
        className: this.pointerClass(this.props.item),
        onClick: this.props.toggleServices
      }, this.props.item.BuildingCode, " ", bcDash, " ", /*#__PURE__*/React.createElement("span", {
        className: "roomDesc"
      }, roomDisplay), " - (", setupType, this.props.item.SetupCount, ", act. ", this.props.item.ActualCount, ") \xA0", this.props.item.HasBookingAttachment && !isMazevo && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cubes fa-1-5x pointer",
        onClick: function onClick() {
          return _this5.props.showCarouselModal(_this5.props.item, false);
        }
      }), this.props.item.HasBookingAttachment && isMazevo && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cube fa-1-5x pointer",
        onClick: function onClick() {
          return _this5.props.showCarouselModal(_this5.props.item, false);
        }
      }), this.props.item.HasDrawings && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cube fa-1-5x pointer",
        onClick: function onClick() {
          return _this5.props.showCarouselModal(_this5.props.item, true);
        }
      }), /*#__PURE__*/React.createElement("br", null), this.props.item.EventName, "\xA0", this.props.item.IsCheckedIn && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check-square green",
        title: checkinToolTip
      }));
    }
  }]);

  return LocationEventNameCell;
}(React.Component);

LocationEventNameCell.propTypes = {
  item: React.PropTypes.object,
  showCarouselModal: React.PropTypes.func,
  toggleServices: React.PropTypes.func
};

var ServicesCell = /*#__PURE__*/function (_React$Component7) {
  _inherits(ServicesCell, _React$Component7);

  var _super7 = _createSuper(ServicesCell);

  function ServicesCell(props) {
    _classCallCheck(this, ServicesCell);

    return _super7.call(this, props);
  }

  _createClass(ServicesCell, [{
    key: "renderClassName",
    value: function renderClassName(keyName, defaultCss) {
      for (var i = 0; i < this.props.settings.length; i++) {
        if (this.props.settings[i].SettingKey === keyName) {
          if (this.props.settings[i].SettingValue !== "") {
            return this.props.settings[i].SettingValue;
          } else {
            break;
          }
        }
      }

      return defaultCss;
    }
    /*
         {this.props.item.HasACT && <i className={this.props.iconSizeClass + " " + this.renderClassName('ACTIconClass', 'fa fa-tasks')}>&nbsp;</i>}
                    {this.props.item.HasATT && <i className={this.props.iconSizeClass + " " + this.renderClassName('ATTIconClass', 'fa fa-users')} title="Attendees">&nbsp;</i>}
                    {this.props.item.HasNOT && <i className={this.props.iconSizeClass + " " + this.renderClassName('NOTIconClass', 'fa fa-newspaper-o')} title="Notes">&nbsp;</i>}
                    {this.props.item.HasCAT && <i className={this.props.iconSizeClass + " " + this.renderClassName('CATIconClass', 'fa fa-cutlery')} title="Catering">&nbsp;</i>}
                    {this.props.item.HasRSO && <i className={this.props.iconSizeClass + " " + this.renderClassName('RSOIconClass', 'fa fa-user')} title="Resources with service orders">&nbsp;</i>}
                    {this.props.item.HasRES && <i className={this.props.iconSizeClass + " " + this.renderClassName('RESIconClass', 'fa fa-folder')} title="Resources">&nbsp;</i>}
     */

  }, {
    key: "buildIconColor",
    value: function buildIconColor(item) {
      if (item.IconColor) {
        return item.IconColor;
      }

      return "";
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var linkStyle = {
        textDecoration: "none",
        color: this.props.textColor
      };
      var udfLabel = this.props.userService.apiTypeId() === "355A9B3B-BF7E-4D96-8B06-27B310EB01F0" ? "Custom Attributes" : "User Defined Fields";
      return /*#__PURE__*/React.createElement("td", {
        onClick: this.props.toggleServices,
        className: "serCell"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        style: linkStyle
      }, /*#__PURE__*/React.createElement("ul", {
        className: "completionIcons"
      }, this.props.item.CategoryIcons.map(function (x) {
        return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("i", {
          className: x.IconClass,
          title: x.ToolTip,
          style: {
            color: _this6.buildIconColor(x)
          }
        }, "\xA0"));
      }), this.props.item.LinkedTasks && this.props.item.LinkedTasks.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check-square-o",
        title: "Linked Tasks"
      }, "\xA0")), this.props.item.Udfs && this.props.item.Udfs.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("i", {
        className: this.renderClassName('UdfIconClass', 'fa fa-info-circle'),
        title: udfLabel
      }, "\xA0"))), /*#__PURE__*/React.createElement("span", {
        className: "visuallyhidden"
      }, "Click to toggle details")));
    }
  }]);

  return ServicesCell;
}(React.Component);

ServicesCell.propTypes = {
  item: React.PropTypes.object,
  settings: React.PropTypes.array,
  toggleServices: React.PropTypes.func,
  iconSizeClass: React.PropTypes.string,
  textColor: React.PropTypes.string
};
ServicesCell.defaultProps = {
  iconSizeClass: "fa-1-5x",
  textColor: ""
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CarouselModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CarouselModal, _React$Component);

  var _super = _createSuper(CarouselModal);

  function CarouselModal(props) {
    var _this;

    _classCallCheck(this, CarouselModal);

    _this = _super.call(this, props);
    _this.isPdf = _this.isPdf.bind(_assertThisInitialized(_this));
    _this.isDocx = _this.isDocx.bind(_assertThisInitialized(_this));
    _this.isImage = _this.isImage.bind(_assertThisInitialized(_this));
    _this.isDrawing = _this.isDrawing.bind(_assertThisInitialized(_this));
    _this.isiPhone = _this.isiPhone.bind(_assertThisInitialized(_this));
    _this.getToken = _this.getToken.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CarouselModal, [{
    key: "getToken",
    value: function getToken() {
      var userData = JSON.parse(window.localStorage.getItem('7PointUserData'));

      if (userData && userData.bearerToken) {
        return userData.bearerToken;
      }
    }
  }, {
    key: "endsWith",
    value: function endsWith(str, suffix) {
      return str.match(suffix + "$") == suffix;
    }
  }, {
    key: "isPdf",
    value: function isPdf(slide) {
      if (slide) {
        if (slide.FileName) {
          var fn = slide.FileName.toLowerCase();
          return this.endsWith(fn, ".pdf");
        }
      }

      return false;
    }
  }, {
    key: "isDocx",
    value: function isDocx(slide) {
      if (slide) {
        if (slide.FileName) {
          var fn = slide.FileName.toLowerCase();
          return this.endsWith(fn, ".docx");
        }
      }

      return false;
    }
  }, {
    key: "isDrawing",
    value: function isDrawing(slide) {
      return slide.Url;
    }
  }, {
    key: "isiPhone",
    value: function isiPhone() {
      if (/iPhone/.test(navigator.userAgent)) return true;else return false;
    }
  }, {
    key: "isImage",
    value: function isImage(slide) {
      if (slide) {
        if (slide.FileName) {
          var fn = slide.FileName.toLowerCase();

          if (this.endsWith(fn, ".png") || this.endsWith(fn, ".bmp") || this.endsWith(fn, ".gif") || this.endsWith(fn, ".jpg") || this.endsWith(fn, ".jpeg") || this.endsWith(fn, ".ico") || this.endsWith(fn, ".tif") || this.endsWith(fn, ".tiff") || this.endsWith(fn, ".svg")) {
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        bsSize: "large"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.title)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, null, /*#__PURE__*/React.createElement(ReactBootstrap.Carousel, {
        interval: 0,
        controls: this.props.slidesForModal.length > 1
      }, this.props.slidesForModal.map(function (slide) {
        return /*#__PURE__*/React.createElement(ReactBootstrap.Carousel.Item, {
          key: slide.ID
        }, !slide.IsExternalFile && /*#__PURE__*/React.createElement("div", {
          style: {
            minHeight: 250 + "px"
          },
          className: "text-center"
        }, _this2.isPdf(slide) && /*#__PURE__*/React.createElement("a", {
          href: "api/dailysetup/GetSetupDiagramAsPdf?bookingId=" + _this2.props.item.BookingId + "&reservationId=" + _this2.props.item.ReservationId + "&attachmentId=" + slide.ID + "&token=" + _this2.getToken(),
          target: "_blank"
        }, "Open in New"), !_this2.isDrawing(slide) && /*#__PURE__*/React.createElement("h3", null, slide.Description), _this2.isImage(slide) && /*#__PURE__*/React.createElement("img", {
          src: "data:image/png;base64," + slide.Base64Data,
          style: {
            "margin": "auto",
            "maxWidth": "100%"
          }
        }), _this2.isPdf(slide) && /*#__PURE__*/React.createElement(PDF, {
          pdfData: slide.StoredFile
        }, /*#__PURE__*/React.createElement(Viewer, null)), _this2.isiPhone() && _this2.isPdf(slide) && /*#__PURE__*/React.createElement("object", {
          data: "data:application/pdf;base64," + slide.Base64Data,
          type: "application/pdf",
          style: {
            "max-width": "98vw",
            "max-height": "95vh"
          }
        }), /*#__PURE__*/React.createElement(ReactBootstrap.Carousel.Caption, null, _this2.isDrawing(slide) && /*#__PURE__*/React.createElement("h3", null, slide.Description), _this2.isDrawing(slide) && /*#__PURE__*/React.createElement("a", {
          href: slide.Url,
          target: "_blank"
        }, "Open"))), slide.IsExternalFile && /*#__PURE__*/React.createElement("div", {
          style: {
            minHeight: 250 + "px"
          },
          className: "text-center"
        }, /*#__PURE__*/React.createElement("a", {
          href: "api/DailySetup/GetExternalAttachment?objectId=" + slide.Description + "&fileName=" + slide.FileName,
          target: "_blank"
        }, slide.FileName)));
      }))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Close")));
    }
  }]);

  return CarouselModal;
}(React.Component);

CarouselModal.propTypes = {
  slidesForModal: React.PropTypes.array,
  dataService: React.PropTypes.object
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CATItem = /*#__PURE__*/function (_React$Component) {
  _inherits(CATItem, _React$Component);

  var _super = _createSuper(CATItem);

  function CATItem(props) {
    _classCallCheck(this, CATItem);

    return _super.call(this, props);
  }

  _createClass(CATItem, [{
    key: "render",
    value: function render() {
      var gar = "";

      if (this.props.service.GuaranteedCount > 0) {
        gar = ", gc. " + this.props.service.GuaranteedCount;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "categoryHeading CAT"
      }, this.props.service.Category.Description, " - ", this.props.service.ServiceType, " (est. ", this.props.service.EstimatedCount, gar, ") from ", moment(this.props.service.TimeStart).format("LT"), " to ", moment(this.props.service.TimeEnd).format("LT")), /*#__PURE__*/React.createElement(SodItems, {
        ServiceOrderDetails: this.props.service.ServiceOrderDetails,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        apiService: this.props.apiService,
        filters: this.props.filters,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        updateItemInCollection: this.props.updateItemInCollection,
        highlightColor: this.props.highlightColor
      }));
    }
  }]);

  return CATItem;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CompletionsCell = /*#__PURE__*/function (_React$Component) {
  _inherits(CompletionsCell, _React$Component);

  var _super = _createSuper(CompletionsCell);

  function CompletionsCell(props) {
    _classCallCheck(this, CompletionsCell);

    return _super.call(this, props);
  }

  _createClass(CompletionsCell, [{
    key: "isAllDone",
    value: function isAllDone() {
      return this.props.completionsDataService.isAllDone(this.props.item);
    }
  }, {
    key: "isNothingCompleted",
    value: function isNothingCompleted() {
      if (this.props.allCompletionTypes) {
        for (var i = 0; i < this.props.allCompletionTypes.length; i++) {
          var completion = this.props.completionsDataService.getLastCompletionForType(this.props.allCompletionTypes[i].ID, this.props.item);

          if (completion) {
            if (this.props.limitCompletionsByDeparments) {
              if (this.userHasCompletionDepartment(this.props.allCompletionTypes[i])) {
                if (completion.CompletedAtUtc != null) {
                  return false;
                }
              }
            } else {
              if (completion.CompletedAtUtc != null) {
                return false;
              }
            }
          }
        }
      }

      return true;
    }
  }, {
    key: "hasAnyCompletion",
    value: function hasAnyCompletion() {
      if (this.props.allCompletionTypes) {
        for (var i = 0; i < this.props.allCompletionTypes.length; i++) {
          var completion = this.props.completionsDataService.getLastCompletionForType(this.props.allCompletionTypes[i].ID, this.props.item);

          if (completion) {
            if (completion.CompletedAtUtc != null) {
              return true;
            }
          }
        }
      }

      return false;
    }
  }, {
    key: "completionClass",
    value: function completionClass() {
      var completion = this.props.item.Completions[0];

      if (completion) {
        if (completion.CompletedAtUtc) {
          if (completion.Color) {
            return {
              "backgroundColor": completion.Color
            };
          } else {
            return {
              "backgroundColor": "#076d10"
            };
          }
        }
      }

      return {
        "backgroundColor": this.props.nothingDoneColor
      };
    }
  }, {
    key: "userHasCompletionDepartment",
    value: function userHasCompletionDepartment(completionType) {
      var userDepartmentIds = this.props.userService.departmentIds();

      for (var i = 0; i < userDepartmentIds.length; i++) {
        if (completionType.DepartmentId == userDepartmentIds[i]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "hasCompletionType",
    value: function hasCompletionType(ct) {
      var completion = this.props.completionsDataService.getLastCompletionForType(ct.ID, this.props.item);

      if (completion) {
        if (completion.CompletedAtUtc != null) {
          if (this.props.limitCompletionsByDeparments) {
            return this.userHasCompletionDepartment(ct);
          } else {
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "completionInitials",
    value: function completionInitials() {
      var completion = this.props.item.Completions[0];

      if (completion) {
        if (completion.CompletedAtUtc) {
          return completion.Initials;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var initials = this.completionInitials();
      var completionStyle = this.completionClass();
      var result = null;

      if (this.isAllDone()) {
        result = /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.props.showCompletionModal.bind(this, this.props.item),
          "aria-label": "All Done, Click to Open Completions Dialog"
        }, /*#__PURE__*/React.createElement("div", {
          className: "taskCircle",
          style: completionStyle,
          title: "Completions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-center taskCircleText"
        }, initials)));
      } else if (this.hasAnyCompletion() && this.isNothingCompleted()) {
        result = /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.props.showCompletionModal.bind(this, this.props.item),
          "aria-label": "Nothing Done, Click to open completions dialog"
        }, /*#__PURE__*/React.createElement("div", {
          className: "taskCircle",
          style: {
            backgroundColor: this.props.nothingDoneColor,
            position: 'relative'
          },
          title: "Completions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "nestedCircle",
          style: {
            backgroundColor: 'white'
          }
        })));
      } else if (!this.hasAnyCompletion()) {
        result = /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.props.showCompletionModal.bind(this, this.props.item),
          "aria-label": "Nothing Done, Click to open completions dialog"
        }, /*#__PURE__*/React.createElement("div", {
          className: "taskCircle",
          style: completionStyle,
          title: "Completions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-center taskCircleText"
        }, "\xA0")));
      } else {
        result = /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.props.showCompletionModal.bind(this, this.props.item),
          "aria-label": "List of what's be done, Click to open completions dialog"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
          className: "completionIcons"
        }, this.props.allCompletionTypes.map(function (ct) {
          return _this.hasCompletionType(ct) && /*#__PURE__*/React.createElement("li", {
            key: ct.ID,
            title: ct.Description
          }, /*#__PURE__*/React.createElement("i", {
            className: ct.IconClass,
            style: {
              color: ct.IconColor
            },
            "aria-label": ct.Description
          }));
        }))));
      }

      var pointerStyle = {
        cursor: "pointer"
      };
      return /*#__PURE__*/React.createElement("td", {
        style: pointerStyle,
        className: "cCell"
      }, result);
    }
  }]);

  return CompletionsCell;
}(React.Component);

CompletionsCell.propTypes = {
  item: React.PropTypes.object,
  allCompletionTypes: React.PropTypes.array,
  completionsComplete: React.PropTypes.func,
  showCompletionModal: React.PropTypes.func,
  completionsDataService: React.PropTypes.object,
  isAllDone: React.PropTypes.func,
  userService: React.PropTypes.object,
  limitCompletionsByDeparments: React.PropTypes.bool,
  nothingDoneColor: React.PropTypes.string
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CompletionsModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CompletionsModal, _React$Component);

  var _super = _createSuper(CompletionsModal);

  function CompletionsModal(props) {
    var _this;

    _classCallCheck(this, CompletionsModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "F", void 0);

    _this.loadAllDoneItem = _this.loadAllDoneItem.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.addCompletion = _this.addCompletion.bind(_assertThisInitialized(_this));
    _this.state = {
      endBooking: true
    };
    return _this;
  }

  _createClass(CompletionsModal, [{
    key: "addCompletion",
    value: function addCompletion(allDoneId) {
      this.props.completionsDataService.completeItem(allDoneId, this.props.item);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var target = event.target;
      var fieldVal = target.type === 'checkbox' ? target.checked : target.value;
      this.setState({
        endBooking: fieldVal
      });
    }
  }, {
    key: "completionButtonClass",
    value: function completionButtonClass(completionTypeId) {
      var lastCompletion = this.props.completionsDataService.getLastCompletionForType(completionTypeId, this.props.item);

      if (lastCompletion) {
        if (lastCompletion.CompletedAtUtc != null) {
          return "btn btn-success";
        } else {
          return "btn btn-danger";
        }
      } else {
        return "btn btn-danger";
      }
    }
  }, {
    key: "loadAllDoneItem",
    value: function loadAllDoneItem() {
      var result = null;

      for (var i = 0; i < this.props.completionTypes.length; i++) {
        var ct = this.props.completionTypes[i];

        if (ct.IsAllDoneType && (ct.AvailableForBooking && this.props.item.TaskId == 0 || ct.AvailableForTask && this.props.item.TaskId > 0 || ct.AvailableForServiceOrder && this.props.item.ID > 0)) {
          result = ct;
          break;
        }
      }

      return result;
    }
  }, {
    key: "completionSpan",
    value: function completionSpan(i) {
      var itemStyle = {
        display: "inline-block"
      };
      itemStyle.backgroundColor = i.Color ? i.Color : '#1171a3';
      return /*#__PURE__*/React.createElement("span", {
        style: itemStyle,
        className: "taskCircle text-center taskCircleText"
      }, i.Initials);
    }
  }, {
    key: "compeltionDetails",
    value: function compeltionDetails(i) {
      var result = null;

      if (i.CompletedAtUtc) {
        var completedAt = moment(moment.utc(i.CompletedAtUtc).toDate()).format("L LT");
        result = /*#__PURE__*/React.createElement("span", null, completedAt, " - ", /*#__PURE__*/React.createElement("i", {
          className: i.IconClass,
          style: {
            color: i.IconColor
          }
        }), " ", i.CompletionTypeDescription, " - Completed By - ", i.UserName);
      } else {
        var restAt = moment(moment.utc(i.DateAddedUtc).toDate()).format("L LT");
        result = /*#__PURE__*/React.createElement("span", {
          className: "red"
        }, restAt, " - ", /*#__PURE__*/React.createElement("i", {
          className: i.IconClass,
          style: {
            color: i.IconColor
          }
        }), " ", i.CompletionTypeDescription, " - Reset By - ", i.UserName);
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var loc = "";

      if (this.props.item.BuildingCode) {
        loc = this.props.item.BuildingCode;
        loc += " - ";
      }

      if (this.props.item.RoomDescription) {
        loc += this.props.item.RoomDescription;
      }

      var sortedItemCompletions = [];

      if (this.props.item && this.props.item.Completions) {
        sortedItemCompletions = this.props.item.Completions.sort(function (a, b) {
          a = new Date(a.DateAddedUtc);
          b = new Date(b.DateAddedUtc);
          return a > b ? -1 : a < b ? 1 : 0;
        });
      }

      var allDoneItem = this.loadAllDoneItem();
      var allDone = null;

      if (allDoneItem != null) {
        allDone = /*#__PURE__*/React.createElement("div", {
          className: "row text-center"
        }, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
          className: "margin-right " + this.completionButtonClass(allDoneItem.ID),
          onClick: function onClick() {
            return _this2.addCompletion(allDoneItem.ID);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: allDoneItem.IconClass
        }), allDoneItem.Description));
      }

      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        bsSize: "lg"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.ServiceType || this.props.item.EventName || this.props.item.TaskDescription), loc && /*#__PURE__*/React.createElement("h7", null, loc)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Complete"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-12"
      }, this.props.completionTypes.map(function (ct) {
        return !ct.IsAllDoneType && (ct.AvailableForBooking && _this2.props.item.TaskId == 0 || ct.AvailableForTask && _this2.props.item.TaskId > 0 || ct.AvailableForServiceOrder && _this2.props.item.ID > 0) && /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
          className: "margin-right " + _this2.completionButtonClass(ct.ID),
          style: {
            "marginBottom": ".5em"
          },
          key: ct.ID,
          onClick: function onClick() {
            return _this2.props.completionsDataService.completeItem(ct.ID, _this2.props.item);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: ct.IconClass
        }), ct.Description);
      }))), /*#__PURE__*/React.createElement("hr", null), allDone, /*#__PURE__*/React.createElement("div", {
        className: "row notesList"
      }, /*#__PURE__*/React.createElement("ul", null, sortedItemCompletions.map(function (i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i.ID
        }, _this2.completionSpan(i), "\xA0", _this2.compeltionDetails(i));
      })))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Close")));
    }
  }]);

  return CompletionsModal;
}(React.Component);

CompletionsModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  completionTypes: React.PropTypes.array,
  completionsDataService: React.PropTypes.object,
  userService: React.PropTypes.object,
  updateItemInCollection: React.PropTypes.func
};
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DailySetup = /*#__PURE__*/function (_React$Component) {
  _inherits(DailySetup, _React$Component);

  var _super = _createSuper(DailySetup);

  function DailySetup(props) {
    var _this;

    _classCallCheck(this, DailySetup);

    _this = _super.call(this, props);
    _this.completeClick = _this.completeClick.bind(_assertThisInitialized(_this));
    _this.hideCompletionModal = _this.hideCompletionModal.bind(_assertThisInitialized(_this));
    _this.showCompletionModal = _this.showCompletionModal.bind(_assertThisInitialized(_this));
    _this.hideNotesModal = _this.hideNotesModal.bind(_assertThisInitialized(_this));
    _this.showNotesModal = _this.showNotesModal.bind(_assertThisInitialized(_this));
    _this.hideHistoryModal = _this.hideHistoryModal.bind(_assertThisInitialized(_this));
    _this.showHistoryModal = _this.showHistoryModal.bind(_assertThisInitialized(_this));
    _this.sortHeaderClass = _this.sortHeaderClass.bind(_assertThisInitialized(_this));
    _this.canEditTask = _this.canEditTask.bind(_assertThisInitialized(_this));
    _this.hideCarouselModal = _this.hideCarouselModal.bind(_assertThisInitialized(_this));
    _this.showCarouselModal = _this.showCarouselModal.bind(_assertThisInitialized(_this));
    _this.showLocationDetailsModal = _this.showLocationDetailsModal.bind(_assertThisInitialized(_this));
    _this.hideLocationDetailsModal = _this.hideLocationDetailsModal.bind(_assertThisInitialized(_this));
    _this.minimize = _this.minimize.bind(_assertThisInitialized(_this));
    _this.isTaskAllDone = _this.isTaskAllDone.bind(_assertThisInitialized(_this));
    _this.toggleTaskShowingMode = _this.toggleTaskShowingMode.bind(_assertThisInitialized(_this));
    _this.toggleSoSchedule = _this.toggleSoSchedule.bind(_assertThisInitialized(_this));
    _this.updateItemInCollection = _this.updateItemInCollection.bind(_assertThisInitialized(_this));
    _this.handleFilterServices = _this.handleFilterServices.bind(_assertThisInitialized(_this));
    _this.applyServicesFilter = _this.applyServicesFilter.bind(_assertThisInitialized(_this));
    _this.state = {
      completionModalShowing: false,
      completionModalItem: {},
      completionTypes: [],
      notesModalItem: {},
      notesModalShowing: false,
      historyModalShowing: false,
      historyModalItem: {},
      carouselModalShowing: false,
      carouselModalItem: {},
      slidesForModal: [],
      newTaskModalItem: {},
      newTaskModalShowing: false,
      tasks: [],
      totalTaskCount: 0,
      taskShowingMode: 1,
      locationModalShowing: false,
      locationDetailsModalItem: {},
      activeDepartments: [],
      soItems: [],
      soTotalItemCount: 0,
      filteredSoItems: [],
      showSoSchedule: false,
      dropBookingsWhenComplete: false,
      showRoomCode: window.localStorage.getItem("OpsShowRoomCode") == 'true' ? true : false
    };
    return _this;
  }

  _createClass(DailySetup, [{
    key: "toggleSoSchedule",
    value: function toggleSoSchedule() {
      var newSoSchedule = !this.state.showSoSchedule;
      this.setState({
        showSoSchedule: newSoSchedule
      });
    }
  }, {
    key: "toggleRoomCode",
    value: function toggleRoomCode() {
      var newShowRoomCode = !this.state.showRoomCode;
      window.localStorage.setItem("OpsShowRoomCode", '' + newShowRoomCode);
      this.setState({
        showRoomCode: newShowRoomCode
      });
    }
  }, {
    key: "updateItemInCollection",
    value: function updateItemInCollection(itemToUpdate) {
      var tempCollection = this.props.bookings.concat();

      for (var i = 0; i < tempCollection.length; i++) {
        if (tempCollection[i]["BookingId"] === itemToUpdate["BookingId"]) {
          tempCollection[i] = itemToUpdate;
          break;
        }
      }

      this.props.bookings = tempCollection;
    }
  }, {
    key: "showLocationDetailsModal",
    value: function showLocationDetailsModal(item) {
      //no ad astra or centers
      if (this.props.userService.apiTypeId() !== "4D2BFEBD-7631-4AEE-96CF-392CFA0BFB3A" && this.props.userService.apiTypeId() !== "5C088F8B-7D16-4C06-B691-7E6FCD4344AD") {
        var _that = this;

        this.props.slidesDataService.getItems('api/DailySetup/GetLocationDetails/' + item.RoomId).then(function (response) {
          var locationData = response.data;

          _that.setState({
            locationModalShowing: true,
            locationDetailsModalItem: locationData
          });
        }, function (error) {});
      }
    }
  }, {
    key: "showCarouselModal",
    value: function showCarouselModal(item, isForDiagrams) {
      var _that = this;

      if (!isForDiagrams) {
        _that.setState({
          carouselTitle: "Attachments"
        });

        var idForCall = "";

        if (item.AdAstraEventId) {
          idForCall = item.AdAstraEventId;
        } else {
          idForCall = item.BookingId;
        }

        this.props.slidesDataService.getItems('api/DailySetup/GetSetupDiagrams/' + idForCall + '?reservationId=' + item.ReservationId).then(function (response) {
          _that.setState({
            carouselModalShowing: true,
            carouselModalItem: item,
            slidesForModal: response.data
          });
        }, function (error) {});
      } else {
        _that.setState({
          carouselTitle: "Drawings"
        });

        if (item.ExternalDrawingUrl) {
          window.open(item.ExternalDrawingUrl);
        } else {
          this.props.slidesDataService.getItems('api/DailySetup/GetDrawings/' + item.BookingId).then(function (response) {
            var drawings = response.data;
            var slides = [];

            for (var j = 0; j < drawings.length; j++) {
              var url = drawings[j].Url;

              if (url) {
                if (url.toLowerCase().indexOf("socialtables.com") != -1 || url.toLowerCase().indexOf("bit.ly") != -1 || url.toLowerCase().indexOf("allseated.com") != -1 || url.toLowerCase().indexOf("teams.microsoft.com") != -1 || url.toLowerCase().indexOf("sharepoint.com") != -1 || url.toLowerCase().indexOf("prismm.com") != -1) {
                  slides.push(drawings[j]);
                }
              }
            }

            if (slides.length > 0) {
              if (slides.length == 1) {
                window.open(slides[0].Url);
              } else {
                _that.setState({
                  carouselModalShowing: true,
                  carouselModalItem: item,
                  slidesForModal: slides
                });
              }
            }
          }, function (error) {});
        }
      }
    }
  }, {
    key: "hideCarouselModal",
    value: function hideCarouselModal() {
      this.setState({
        carouselModalShowing: false
      });
    }
  }, {
    key: "hideLocationDetailsModal",
    value: function hideLocationDetailsModal() {
      this.setState({
        locationModalShowing: false
      });
    }
  }, {
    key: "canEditTask",
    value: function canEditTask(task) {
      if (this.props.userService.userType() == "0") {
        return this.props.userService.userId() == task.CreatedById;
      } else {
        return true;
      }
    }
  }, {
    key: "completeClick",
    value: function completeClick(event) {
      this.setState({
        completionModalShowing: true
      });
    }
  }, {
    key: "hideNotesModal",
    value: function hideNotesModal() {
      this.setState({
        notesModalShowing: false
      });
    }
  }, {
    key: "showNotesModal",
    value: function showNotesModal(item) {
      var _that = this;

      this.props.slidesDataService.getItems("api/Departments/Active").then(function (response) {
        _that.setState({
          activeDepartments: response.data
        });
      }, function (error) {
        console.log(error);
      });

      if (item.Notes && item.Notes.length > 0) {
        var apiPath;

        if (item.TaskId > 0) {
          var isoDate = moment(this.props.onDate).format("YYYY-MM-DD");
          apiPath = "api/DailySetup/GetNotesForTask/" + item.TaskId + "/" + isoDate;
        } else {
          apiPath = "api/DailySetup/GetNotesForBooking/" + item.BookingId;
        }

        this.props.slidesDataService.getItems(apiPath).then(function (response) {
          item.Notes = response.data;

          _that.setState({
            notesModalShowing: true,
            notesModalItem: item
          });
        }, function (error) {});
      } else {
        this.setState({
          notesModalShowing: true,
          notesModalItem: item
        });
      }
    }
  }, {
    key: "hideCompletionModal",
    value: function hideCompletionModal() {
      this.setState({
        completionModalShowing: false
      });
    }
  }, {
    key: "showCompletionModal",
    value: function showCompletionModal(item) {
      var _that = this;

      this.props.completionsDataService.getCompletionTypesForItem(item).then(function (result) {
        _that.setState({
          completionModalShowing: true,
          completionModalItem: item,
          completionTypes: result
        });
      }, function (error) {});
    }
  }, {
    key: "hideHistoryModal",
    value: function hideHistoryModal() {
      this.setState({
        historyModalShowing: false
      });
    }
  }, {
    key: "showHistoryModal",
    value: function showHistoryModal(item) {
      this.props.getHistoryForBooking(item);
      this.setState({
        historyModalShowing: true,
        historyModalItem: item
      });
    }
  }, {
    key: "sortHeaderClass",
    value: function sortHeaderClass(propertyName) {
      if (this.props.sortProperty === propertyName) {
        if (this.props.sortIsDesc) {
          return "st-sort-descent";
        } else {
          return "st-sort-ascent";
        }
      }

      return "";
    }
  }, {
    key: "minimize",
    value: function minimize(tableId, iconId) {
      var $wcontent = $("#" + tableId);
      var iElement = $("#" + iconId);

      if ($wcontent.is(':visible')) {
        iElement.removeClass('fa fa-chevron-up');
        iElement.addClass('fa fa-chevron-down');
      } else {
        iElement.removeClass('fa fa-chevron-down');
        iElement.addClass('fa fa-chevron-up');
      }

      $wcontent.toggle(500);
    }
  }, {
    key: "toggleTaskShowingMode",
    value: function toggleTaskShowingMode(newMode) {
      this.setState({
        taskShowingMode: newMode
      });
    }
  }, {
    key: "isTaskAllDone",
    value: function isTaskAllDone(task) {
      return this.props.completionsDataService.getLastCompletionForType(task);
    }
  }, {
    key: "handleFilterServices",
    value: function handleFilterServices(event) {
      this.applyServicesFilter();
    }
  }, {
    key: "applyServicesFilter",
    value: function applyServicesFilter() {
      var filterString = document.getElementById("servicesFilter").value;
      var soItems = this.state.soItems;
      var regExp = new RegExp(filterString, "gi");

      var check = function check(obj) {
        if (obj !== null && _typeof(obj) === "object") {
          return Object.values(obj).some(check);
        }

        if (Array.isArray(obj)) {
          return obj.some(check);
        }

        return (typeof obj === "string" || typeof obj === "number") && regExp.test(obj);
      };

      this.setState({
        filteredSoItems: soItems.filter(check)
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var taskClone = nextProps.tasks.concat();
      var totalTaskCount = nextProps.allTasksCount;
      var taskForState = [];
      var numberToRemoveFromCount = 0;
      var settingExist = false;
      var dropBookingsWhenComplete = false;

      for (var i = 0; i < nextProps.settings.length; i++) {
        if (nextProps.settings[i].SettingKey === "DropTaskWhenComplete") {
          settingExist = true;

          if (nextProps.settings[i].SettingValue === "1") {
            taskClone.map(function (t) {
              if (!_this2.isTaskAllDone(t)) {
                taskForState.push(t);
              } else {
                numberToRemoveFromCount++;
              }
            });
          } else {
            taskForState = taskClone;
          }
        } else if (nextProps.settings[i].SettingKey === "DropBookingsWhenComplete") {
          if (nextProps.settings[i].SettingValue === "1") {
            dropBookingsWhenComplete = true;
          }
        }
      }

      if (!settingExist) {
        taskForState = taskClone;
      }

      totalTaskCount = totalTaskCount - numberToRemoveFromCount;
      var soItemCount = 0;
      var bookingsClone = nextProps.bookings.concat();
      var soItemsForState = [];
      bookingsClone.map(function (b) {
        if (b.Services) {
          for (var _i = 0; _i < b.Services.length; _i++) {
            var soItem = b.Services[_i];

            if (soItem.Category.ResourceCategoryTypeCode === "RSO" || soItem.Category.ResourceCategoryTypeCode === "CAT") {
              soItem.RoomDescription = b.RoomDescription;
              soItem.GroupName = b.GroupName;
              soItem.EventName = b.EventName;
              soItemsForState.push(soItem);
              soItemCount++;
            }
          }
        }
      });

      if (soItemsForState) {
        soItemsForState.sort(function (a, b) {
          return a.TimeStart > b.TimeStart ? 1 : -1;
        });
      }

      this.setState({
        tasks: taskForState,
        totalTaskCount: totalTaskCount,
        soItems: soItemsForState,
        soTotalItemCount: soItemCount,
        dropBookingsWhenComplete: dropBookingsWhenComplete,
        filteredSoItems: soItemsForState
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _React$createElement;

      var showServiceOrderSchedule = this.props.userService.isEmsApiType();
      var showSoScheduleText = this.state.showSoSchedule ? "Show Booking Schedule" : "Show Service Schedule";
      var showRoomCodeText = this.state.showRoomCode ? "Show Room Description" : "Show Room Code";
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-icons pull-right"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.minimize("tasksTable", "taskCollapse");
        },
        href: "#"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-up",
        id: "taskCollapse",
        "aria-label": "Collapase or Expand Table"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Tasks ", /*#__PURE__*/React.createElement("small", null, "(", this.state.tasks.length, " / ", this.state.totalTaskCount, ") "))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info",
        id: "tasksTable"
      }, /*#__PURE__*/React.createElement(TasksTable, (_React$createElement = {
        sortHeaderClass: this.sortHeaderClass,
        sort: this.props.sort,
        settings: this.props.settings,
        tasks: this.props.tasks,
        canEditTask: this.canEditTask,
        editTask: this.props.editTask,
        showNotesModal: this.showNotesModal,
        completionsDataService: this.props.completionsDataService,
        showCompletionModal: this.showCompletionModal,
        allCompletionTypes: this.props.allCompletionTypes,
        getLinkedBooking: this.props.getLinkedBooking,
        slidesDataService: this.props.slidesDataService,
        setAvailableAt: this.props.setAvailableAt,
        userService: this.props.userService
      }, _defineProperty(_React$createElement, "showNotesModal", this.showNotesModal), _defineProperty(_React$createElement, "showHistoryModal", this.showHistoryModal), _defineProperty(_React$createElement, "showCarouselModal", this.showCarouselModal), _defineProperty(_React$createElement, "settings", this.props.settings), _defineProperty(_React$createElement, "toggleServices", this.props.toggleServices), _defineProperty(_React$createElement, "apiService", this.props.slidesDataService), _defineProperty(_React$createElement, "limitCompletionsByDeparments", this.props.limitCompletionsByDeparments), _React$createElement)))), this.props.showDailySetup && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.toggleRoomCode();
        },
        href: "#"
      }, showRoomCodeText), "\xA0\xA0\xA0"), showServiceOrderSchedule && /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.toggleSoSchedule();
        },
        href: "#"
      }, showSoScheduleText)), !this.state.showSoSchedule && /*#__PURE__*/React.createElement("div", {
        className: "widget wblue clearBoth"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-icons pull-right"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.minimize("bookingsTable", "bookingCollapse");
        },
        href: "#"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-up",
        id: "bookingCollapse",
        "aria-label": "Collapase or Expand Bookings Table"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Events"), /*#__PURE__*/React.createElement("small", {
        className: "page-title-subtle"
      }, "(", this.props.bookings.length, " / ", this.props.allBookingsCount, ")"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info",
        id: "bookingsTable"
      }, /*#__PURE__*/React.createElement(EventsTable, {
        items: this.props.bookings,
        showReservedTime: this.props.showReservedTime,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        settings: this.props.settings,
        expandAllServices: this.props.expandAllServices,
        completionsComplete: this.props.completionsComplete,
        allCompletionTypes: this.props.allCompletionTypes,
        getHistoryForBooking: this.props.getHistoryForBooking,
        completionsDataService: this.props.completionsDataService,
        sortHeaderClass: this.sortHeaderClass,
        sort: this.props.sort,
        slidesDataService: this.props.slidesDataService,
        setAvailableAt: this.props.setAvailableAt,
        userService: this.props.userService,
        showNotesModal: this.showNotesModal,
        showHistoryModal: this.showHistoryModal,
        showCompletionModal: this.showCompletionModal,
        showCarouselModal: this.showCarouselModal,
        toggleServices: this.props.toggleServices,
        noEventsMessage: this.props.noEventsMessage,
        updateBookingWithTaskId: this.props.updateBookingWithTaskId,
        showNoShowBookingModal: this.showNoShowBookingModal,
        showNoShowAction: this.props.showNoShowAction,
        showEstimatedCountAction: this.props.showEstimatedCountAction,
        showAddToCalendarAction: this.props.showAddToCalendarAction,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        onDate: this.props.onDate,
        limitCompletionsByDeparments: this.props.limitCompletionsByDeparments,
        canEditTask: this.canEditTask,
        editTask: this.props.editTask,
        showLocationDetailsModal: this.showLocationDetailsModal,
        dropBookingsWhenComplete: this.state.dropBookingsWhenComplete,
        checkedInOnly: this.props.checkedInOnly,
        showRoomCode: this.state.showRoomCode,
        common: this.props.common,
        openNewTaskModal: this.props.openNewTaskModal
      })))), this.state.showSoSchedule && /*#__PURE__*/React.createElement("div", {
        className: "widget wblue clearBoth"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-icons pull-right"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.minimize("soTable", "soCollapse");
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-up",
        id: "soCollapse"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left so-schedule-title"
      }, "Services"), /*#__PURE__*/React.createElement("small", {
        className: "page-title-subtle"
      }, "(", this.state.filteredSoItems.length, " / ", this.state.soTotalItemCount, ")\xA0\xA0"), showServiceOrderSchedule && /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        type: "text",
        placeholder: "Filter Services",
        onKeyUp: this.handleFilterServices,
        className: "smallInput",
        id: "servicesFilter"
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info",
        id: "soTable"
      }, /*#__PURE__*/React.createElement(SoSchedule, {
        items: this.state.filteredSoItems,
        settings: this.props.settings,
        sortHeaderClass: this.sortHeaderClass,
        sort: this.props.sort,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        completionsDataService: this.props.completionsDataService,
        showCompletionModal: this.showCompletionModal,
        allCompletionTypes: this.props.allCompletionTypes,
        userService: this.props.userService,
        slidesDataService: this.props.slidesDataService
      }))), /*#__PURE__*/React.createElement(BookingHistoryModal, {
        show: this.state.historyModalShowing,
        item: this.state.historyModalItem,
        close: this.hideHistoryModal
      }), /*#__PURE__*/React.createElement(CompletionsModal, {
        show: this.state.completionModalShowing,
        item: this.state.completionModalItem,
        close: this.hideCompletionModal,
        completionTypes: this.state.completionTypes,
        completionsDataService: this.props.completionsDataService,
        userService: this.props.userService,
        updateItemInCollection: this.updateItemInCollection
      }), /*#__PURE__*/React.createElement(NotesModal, {
        show: this.state.notesModalShowing,
        item: this.state.notesModalItem,
        close: this.hideNotesModal,
        notesDataService: this.props.notesDataService,
        userService: this.props.userService,
        departments: this.state.activeDepartments
      }), /*#__PURE__*/React.createElement(CarouselModal, {
        show: this.state.carouselModalShowing,
        close: this.hideCarouselModal,
        slidesForModal: this.state.slidesForModal,
        title: this.state.carouselTitle,
        dataService: this.props.slidesDataService,
        item: this.state.carouselModalItem
      }), /*#__PURE__*/React.createElement(RoomDetailsModal, {
        show: this.state.locationModalShowing,
        item: this.state.locationDetailsModalItem,
        close: this.hideLocationDetailsModal
      }));
    }
  }]);

  return DailySetup;
}(React.Component);

DailySetup.propTypes = {
  soitems: React.PropTypes.array,
  tasks: React.PropTypes.array,
  allTasksCount: React.PropTypes.number,
  sort: React.PropTypes.func,
  sortProperty: React.PropTypes.string,
  sortIsDesc: React.PropTypes.bool,
  userService: React.PropTypes.object,
  completionsDataService: React.PropTypes.object,
  bookings: React.PropTypes.array,
  allBookingsCount: React.PropTypes.number,
  showDailySetup: React.PropTypes.bool,
  settings: React.PropTypes.array,
  notesDataService: React.PropTypes.object,
  allCompletionTypes: React.PropTypes.array,
  setAvailableAt: React.PropTypes.func,
  showReservedTime: React.PropTypes.bool,
  expandAllServices: React.PropTypes.bool,
  editTask: React.PropTypes.func,
  slidesDataService: React.PropTypes.object,
  getLinkedBooking: React.PropTypes.func,
  toggleServices: React.PropTypes.func,
  minutesSinceLastChange: React.PropTypes.number,
  getHistoryForBooking: React.PropTypes.func,
  noEventsMessage: React.PropTypes.string,
  updateBookingWithTaskId: React.PropTypes.func,
  showNoShowAction: React.PropTypes.bool,
  showEstimatedCountAction: React.PropTypes.bool,
  showAddToCalendarAction: React.PropTypes.bool,
  updateItemForBookingAction: React.PropTypes.func,
  filters: React.PropTypes.object,
  onDate: React.PropTypes.object,
  limitCompletionsByDeparments: React.PropTypes.bool,
  checkedInOnly: React.PropTypes.bool,
  common: React.PropTypes.object,
  openNewTaskModal: React.PropTypes.func
};
DailySetup.defaultProps = {
  tasks: [],
  allTasksCount: 0,
  bookings: [],
  allBookingsCount: 0,
  settings: []
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.
var instanceCount = 0;
var CalendarHeader = React.createClass({
  displayName: 'DatePickerHeader',
  propTypes: {
    displayDate: React.PropTypes.object.isRequired,
    minDate: React.PropTypes.string,
    maxDate: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    monthLabels: React.PropTypes.array.isRequired,
    previousButtonElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]).isRequired,
    nextButtonElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]).isRequired
  },
  displayingMinMonth: function displayingMinMonth() {
    if (!this.props.minDate) return false;
    var displayDate = new Date(this.props.displayDate);
    var minDate = new Date(this.props.minDate);
    return minDate.getFullYear() == displayDate.getFullYear() && minDate.getMonth() == displayDate.getMonth();
  },
  displayingMaxMonth: function displayingMaxMonth() {
    if (!this.props.maxDate) return false;
    var displayDate = new Date(this.props.displayDate);
    var maxDate = new Date(this.props.maxDate);
    return maxDate.getFullYear() == displayDate.getFullYear() && maxDate.getMonth() == displayDate.getMonth();
  },
  handleClickPrevious: function handleClickPrevious() {
    var newDisplayDate = new Date(this.props.displayDate);
    newDisplayDate.setDate(1);
    newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
    this.props.onChange(newDisplayDate);
  },
  handleClickNext: function handleClickNext() {
    var newDisplayDate = new Date(this.props.displayDate);
    newDisplayDate.setDate(1);
    newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
    this.props.onChange(newDisplayDate);
  },
  render: function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-muted pull-left datepicker-previous-wrapper",
      onClick: this.handleClickPrevious,
      style: {
        cursor: 'pointer'
      }
    }, this.displayingMinMonth() ? null : this.props.previousButtonElement), /*#__PURE__*/React.createElement("span", null, this.props.monthLabels[this.props.displayDate.getMonth()], " ", this.props.displayDate.getFullYear()), /*#__PURE__*/React.createElement("div", {
      className: "text-muted pull-right datepicker-next-wrapper",
      onClick: this.handleClickNext,
      style: {
        cursor: 'pointer'
      }
    }, this.displayingMaxMonth() ? null : this.props.nextButtonElement));
  }
});
var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var Calendar = React.createClass({
  displayName: 'DatePickerCalendar',
  propTypes: {
    selectedDate: React.PropTypes.object,
    displayDate: React.PropTypes.object.isRequired,
    minDate: React.PropTypes.string,
    maxDate: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    dayLabels: React.PropTypes.array.isRequired,
    cellPadding: React.PropTypes.string.isRequired,
    weekStartsOn: React.PropTypes.number,
    showTodayButton: React.PropTypes.bool,
    todayButtonLabel: React.PropTypes.string,
    roundedCorners: React.PropTypes.bool
  },
  handleClick: function handleClick(day) {
    var newSelectedDate = this.setTimeToNoon(new Date(this.props.displayDate));
    newSelectedDate.setDate(day);
    this.props.onChange(newSelectedDate);
  },
  handleClickToday: function handleClickToday() {
    var newSelectedDate = this.setTimeToNoon(new Date());
    this.props.onChange(newSelectedDate);
  },
  setTimeToNoon: function setTimeToNoon(date) {
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  },
  render: function render() {
    var _this = this;

    var currentDate = this.setTimeToNoon(new Date());
    var selectedDate = this.props.selectedDate ? this.setTimeToNoon(new Date(this.props.selectedDate)) : null;
    var minDate = this.props.minDate ? this.setTimeToNoon(new Date(this.props.minDate)) : null;
    var maxDate = this.props.maxDate ? this.setTimeToNoon(new Date(this.props.maxDate)) : null;
    var year = this.props.displayDate.getFullYear();
    var month = this.props.displayDate.getMonth();
    var firstDay = new Date(year, month, 1);
    var startingDay = this.props.weekStartsOn > 1 ? firstDay.getDay() - this.props.weekStartsOn + 7 : this.props.weekStartsOn === 1 ? firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1 : firstDay.getDay();
    var monthLength = daysInMonth[month];

    if (month == 1) {
      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
        monthLength = 29;
      }
    }

    var weeks = [];
    var day = 1;

    for (var i = 0; i < 9; i++) {
      var week = [];

      for (var j = 0; j <= 6; j++) {
        if (day <= monthLength && (i > 0 || j >= startingDay)) {
          var className = null;
          var date = new Date(year, month, day, 12, 0, 0, 0).toISOString();
          var beforeMinDate = minDate && Date.parse(date) < Date.parse(minDate);
          var afterMinDate = maxDate && Date.parse(date) > Date.parse(maxDate);

          if (beforeMinDate || afterMinDate) {
            week.push( /*#__PURE__*/React.createElement("td", {
              key: j,
              style: {
                padding: this.props.cellPadding
              },
              className: "text-muted"
            }, day));
          } else {
            if (Date.parse(date) === Date.parse(selectedDate)) {
              className = 'bg-primary';
            } else if (Date.parse(date) === Date.parse(currentDate)) {
              className = 'text-primary';
            }

            week.push( /*#__PURE__*/React.createElement("td", {
              key: j,
              onClick: this.handleClick.bind(this, day),
              style: {
                cursor: 'pointer',
                padding: this.props.cellPadding,
                borderRadius: this.props.roundedCorners ? 5 : 0
              },
              className: className
            }, day));
          }

          day++;
        } else {
          week.push( /*#__PURE__*/React.createElement("td", {
            key: j
          }));
        }
      }

      weeks.push( /*#__PURE__*/React.createElement("tr", {
        key: i
      }, week));

      if (day > monthLength) {
        break;
      }
    }

    return /*#__PURE__*/React.createElement("table", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, this.props.dayLabels.map(function (label, index) {
      return /*#__PURE__*/React.createElement("td", {
        key: index,
        className: "text-muted",
        style: {
          padding: _this.props.cellPadding
        }
      }, /*#__PURE__*/React.createElement("small", null, label));
    }))), /*#__PURE__*/React.createElement("tbody", null, weeks), this.props.showTodayButton && /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: this.props.dayLabels.length,
      style: {
        paddingTop: '9px'
      }
    }, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
      block: true,
      bsSize: "xsmall",
      className: "u-today-button",
      onClick: this.handleClickToday
    }, this.props.todayButtonLabel)))));
  }
});

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this2;

    _classCallCheck(this, DatePicker);

    _this2 = _super.call(this, props);
    _this2.getDayLabels = _this2.getDayLabels.bind(_assertThisInitialized(_this2));
    _this2.makeDateValues = _this2.makeDateValues.bind(_assertThisInitialized(_this2));
    _this2.clear = _this2.clear.bind(_assertThisInitialized(_this2));
    _this2.handleHide = _this2.handleHide.bind(_assertThisInitialized(_this2));
    _this2.handleKeyDown = _this2.handleKeyDown.bind(_assertThisInitialized(_this2));
    _this2.handleFocus = _this2.handleFocus.bind(_assertThisInitialized(_this2));
    _this2.handleBlur = _this2.handleBlur.bind(_assertThisInitialized(_this2));
    _this2.getValue = _this2.getValue.bind(_assertThisInitialized(_this2));
    _this2.getFormattedValue = _this2.getFormattedValue.bind(_assertThisInitialized(_this2));
    _this2.getCalendarPlacement = _this2.getCalendarPlacement.bind(_assertThisInitialized(_this2));
    _this2.makeInputValueString = _this2.makeInputValueString.bind(_assertThisInitialized(_this2));
    _this2.handleBadInput = _this2.handleBadInput.bind(_assertThisInitialized(_this2));
    _this2.handleInputChange = _this2.handleInputChange.bind(_assertThisInitialized(_this2));
    _this2.onChangeMonth = _this2.onChangeMonth.bind(_assertThisInitialized(_this2));
    _this2.onChangeDate = _this2.onChangeDate.bind(_assertThisInitialized(_this2));
    _this2.state = {
      focused: false,
      inputFocused: false,
      placeholder: _this2.props.placeholder || _this2.props.dateFormat,
      separator: _this2.props.dateFormat.match(/[^A-Z]/)[0],
      dayLabels: _this2.getDayLabels()
    };

    var dates = _this2.makeDateValues(null);

    Object.assign(_this2.state, dates);
    return _this2;
  }

  _createClass(DatePicker, [{
    key: "getDayLabels",
    value: function getDayLabels() {
      if (this.props.weekStartsOn > 1) {
        return this.props.dayLabels.slice(this.props.weekStartsOn).concat(this.props.dayLabels.slice(0, this.props.weekStartsOn));
      } else if (this.props.weekStartsOn === 1) {
        return this.props.dayLabels.slice(1).concat(this.props.dayLabels.slice(0, 1));
      } else {
        return this.props.dayLabels;
      }
    }
  }, {
    key: "makeDateValues",
    value: function makeDateValues(isoString) {
      var displayDate;
      var selectedDate = isoString ? new Date("".concat(isoString.slice(0, 10), "T12:00:00.000Z")) : null;
      var minDate = this.props.minDate ? new Date("".concat(isoString.slice(0, 10), "T12:00:00.000Z")) : null;
      var maxDate = this.props.maxDate ? new Date("".concat(isoString.slice(0, 10), "T12:00:00.000Z")) : null;
      var inputValue = isoString ? this.makeInputValueString(selectedDate) : null;

      if (selectedDate) {
        displayDate = new Date(selectedDate);
      } else {
        var today = new Date("".concat(new Date().toISOString().slice(0, 10), "T12:00:00.000Z"));

        if (minDate && Date.parse(minDate) >= Date.parse(today)) {
          displayDate = minDate;
        } else if (maxDate && Date.parse(maxDate) <= Date.parse(today)) {
          displayDate = maxDate;
        } else {
          displayDate = today;
        }
      }

      return {
        value: selectedDate ? selectedDate.toISOString() : null,
        displayDate: displayDate,
        selectedDate: selectedDate,
        inputValue: inputValue
      };
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.props.onClear) {
        this.props.onClear();
      } else {
        this.setState(this.makeDateValues(null));
      }

      if (this.props.onChange) {
        this.props.onChange(null, null);
      }
    }
  }, {
    key: "handleHide",
    value: function handleHide() {
      if (this.state.inputFocused) {
        return;
      }

      this.setState({
        focused: false
      });

      if (this.props.onBlur) {
        var event = document.createEvent('CustomEvent');
        event.initEvent('Change Date', true, false);
        ReactDOM.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
        this.props.onBlur(event);
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.which === 9 && this.state.inputFocused) {
        this.setState({
          focused: false
        });

        if (this.props.onBlur) {
          var event = document.createEvent('CustomEvent');
          event.initEvent('Change Date', true, false);
          ReactDOM.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
          this.props.onBlur(event);
        }
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (this.state.focused === true) {
        return;
      }

      var placement = this.getCalendarPlacement();
      this.setState({
        inputFocused: true,
        focused: true,
        calendarPlacement: placement
      });

      if (this.props.onFocus) {
        var event = document.createEvent('CustomEvent');
        event.initEvent('Change Date', true, false);
        ReactDOM.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
        this.props.onFocus(event);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        inputFocused: false
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(this.state.inputFocused === true && nextState.inputFocused === false);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
    }
  }, {
    key: "getFormattedValue",
    value: function getFormattedValue() {
      return this.state.displayDate ? this.state.inputValue : null;
    }
  }, {
    key: "getCalendarPlacement",
    value: function getCalendarPlacement() {
      var tag = Object.prototype.toString.call(this.props.calendarPlacement);
      var isFunction = tag === '[object AsyncFunction]' || tag === '[object Function]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';

      if (isFunction) {
        return this.props.calendarPlacement();
      } else {
        return this.props.calendarPlacement;
      }
    }
  }, {
    key: "makeInputValueString",
    value: function makeInputValueString(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate(); //this method is executed during intialState setup... handle a missing state properly

      var separator = this.state ? this.state.separator : this.props.dateFormat.match(/[^A-Z]/)[0];

      if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
        return (month > 9 ? month : "0".concat(month)) + separator + (day > 9 ? day : "0".concat(day)) + separator + date.getFullYear();
      } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
        return (day > 9 ? day : "0".concat(day)) + separator + (month > 9 ? month : "0".concat(month)) + separator + date.getFullYear();
      } else {
        return date.getFullYear() + separator + (month > 9 ? month : "0".concat(month)) + separator + (day > 9 ? day : "0".concat(day));
      }
    }
  }, {
    key: "handleBadInput",
    value: function handleBadInput(originalValue) {
      var parts = originalValue.replace(new RegExp("[^0-9".concat(this.state.separator, "]")), '').split(this.state.separator);

      if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/)) {
        if (parts[0] && parts[0].length > 2) {
          parts[1] = parts[0].slice(2) + (parts[1] || '');
          parts[0] = parts[0].slice(0, 2);
        }

        if (parts[1] && parts[1].length > 2) {
          parts[2] = parts[1].slice(2) + (parts[2] || '');
          parts[1] = parts[1].slice(0, 2);
        }

        if (parts[2]) {
          parts[2] = parts[2].slice(0, 4);
        }
      } else {
        if (parts[0] && parts[0].length > 4) {
          parts[1] = parts[0].slice(4) + (parts[1] || '');
          parts[0] = parts[0].slice(0, 4);
        }

        if (parts[1] && parts[1].length > 2) {
          parts[2] = parts[1].slice(2) + (parts[2] || '');
          parts[1] = parts[1].slice(0, 2);
        }

        if (parts[2]) {
          parts[2] = parts[2].slice(0, 2);
        }
      }

      this.setState({
        inputValue: parts.join(this.state.separator)
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange() {
      var originalValue = ReactDOM.findDOMNode(this.refs.input).value;
      var inputValue = originalValue.replace(/(-|\/\/)/g, this.state.separator).slice(0, 10);

      if (!inputValue) {
        this.clear();
        return;
      }

      var month, day, year;

      if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
        if (!inputValue.match(/[0-1][0-9].[0-3][0-9].[1-2][0-9][0-9][0-9]/)) {
          return this.handleBadInput(originalValue);
        }

        month = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
        day = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
        year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
      } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
        if (!inputValue.match(/[0-3][0-9].[0-1][0-9].[1-2][0-9][0-9][0-9]/)) {
          return this.handleBadInput(originalValue);
        }

        day = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
        month = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
        year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
      } else {
        if (!inputValue.match(/[1-2][0-9][0-9][0-9].[0-1][0-9].[0-3][0-9]/)) {
          return this.handleBadInput(originalValue);
        }

        year = inputValue.slice(0, 4).replace(/[^0-9]/g, '');
        month = inputValue.slice(5, 7).replace(/[^0-9]/g, '');
        day = inputValue.slice(8, 10).replace(/[^0-9]/g, '');
      }

      var monthInteger = parseInt(month, 10);
      var dayInteger = parseInt(day, 10);
      var yearInteger = parseInt(year, 10);

      if (monthInteger > 12 || dayInteger > 31) {
        return this.handleBadInput(originalValue);
      }

      if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999) {
        var selectedDate = new Date(yearInteger, monthInteger - 1, dayInteger, 12, 0, 0, 0);
        this.setState({
          selectedDate: selectedDate,
          displayDate: selectedDate,
          value: selectedDate.toISOString()
        });

        if (this.props.onChange) {
          this.props.onChange(selectedDate.toISOString(), inputValue);
        }
      }

      this.setState({
        inputValue: inputValue
      });
    }
  }, {
    key: "onChangeMonth",
    value: function onChangeMonth(newDisplayDate) {
      this.setState({
        displayDate: newDisplayDate
      });
    }
  }, {
    key: "onChangeDate",
    value: function onChangeDate(newSelectedDate) {
      var inputValue = this.makeInputValueString(newSelectedDate);
      this.setState({
        inputValue: inputValue,
        selectedDate: newSelectedDate,
        displayDate: newSelectedDate,
        value: newSelectedDate.toISOString(),
        focused: false
      });

      if (this.props.onBlur) {
        var event = document.createEvent('CustomEvent');
        event.initEvent('Change Date', true, false);
        ReactDOM.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
        this.props.onBlur(event);
      }

      if (this.props.onChange) {
        this.props.onChange(newSelectedDate.toISOString(), inputValue, this.props.id);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var value = newProps.value;

      if (this.getValue() !== value) {
        this.setState(this.makeDateValues(value));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var calendarHeader = /*#__PURE__*/React.createElement(CalendarHeader, {
        previousButtonElement: this.props.previousButtonElement,
        nextButtonElement: this.props.nextButtonElement,
        displayDate: this.state.displayDate,
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        onChange: this.onChangeMonth,
        monthLabels: this.props.monthLabels,
        dateFormat: this.props.dateFormat
      });
      var control = this.props.customControl ? React.cloneElement(this.props.customControl, {
        onKeyDown: this.handleKeyDown,
        value: this.state.inputValue || '',
        required: this.props.required,
        placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
        ref: 'input',
        disabled: this.props.disabled,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleInputChange,
        className: this.props.className,
        style: this.props.style,
        autoComplete: this.props.autoComplete
      }) : /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        onKeyDown: this.handleKeyDown,
        value: this.state.inputValue || '',
        required: this.props.required,
        ref: "input",
        type: "text",
        className: this.props.className,
        style: this.props.style,
        autoFocus: this.props.autoFocus,
        disabled: this.props.disabled,
        placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleInputChange,
        autoComplete: this.props.autoComplete
      });
      return /*#__PURE__*/React.createElement(ReactBootstrap.InputGroup, {
        ref: "inputGroup",
        bsClass: this.props.showClearButton ? this.props.bsClass : '',
        bsSize: this.props.bsSize,
        id: this.props.id ? "".concat(this.props.id, "_group") : null
      }, control, /*#__PURE__*/React.createElement(ReactBootstrap.Overlay, {
        rootClose: true,
        onHide: this.handleHide,
        show: this.state.focused,
        container: function container() {
          return _this3.props.calendarContainer || ReactDOM.findDOMNode(_this3.refs.overlayContainer);
        },
        target: function target() {
          return ReactDOM.findDOMNode(_this3.refs.input);
        },
        placement: this.state.calendarPlacement,
        delayHide: 200
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Popover, {
        id: "date-picker-popover-".concat(this.props.instanceCount),
        className: "date-picker-popover",
        title: calendarHeader
      }, /*#__PURE__*/React.createElement(Calendar, {
        cellPadding: this.props.cellPadding,
        selectedDate: this.state.selectedDate,
        displayDate: this.state.displayDate,
        onChange: this.onChangeDate,
        dayLabels: this.state.dayLabels,
        weekStartsOn: this.props.weekStartsOn,
        showTodayButton: this.props.showTodayButton,
        todayButtonLabel: this.props.todayButtonLabel,
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        roundedCorners: this.props.roundedCorners
      }))), /*#__PURE__*/React.createElement("div", {
        ref: "overlayContainer",
        style: {
          position: 'relative'
        }
      }), /*#__PURE__*/React.createElement("input", {
        ref: "hiddenInput",
        type: "hidden",
        id: this.props.id,
        name: this.props.name,
        value: this.state.value || '',
        "data-formattedvalue": this.state.value ? this.state.inputValue : ''
      }), this.props.showClearButton && !this.props.customControl && /*#__PURE__*/React.createElement(ReactBootstrap.InputGroup.Addon, {
        onClick: this.props.disabled ? null : this.clear,
        style: {
          cursor: this.state.inputValue && !this.props.disabled ? 'pointer' : 'not-allowed'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          opacity: this.state.inputValue && !this.props.disabled ? 1 : 0.5
        }
      }, this.props.clearButtonElement)), this.props.children);
    }
  }]);

  return DatePicker;
}(React.Component);

DatePicker.propTypes = {
  defaultValue: React.PropTypes.string,
  value: React.PropTypes.string,
  required: React.PropTypes.bool,
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  minDate: React.PropTypes.string,
  maxDate: React.PropTypes.string,
  cellPadding: React.PropTypes.string,
  autoComplete: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  dayLabels: React.PropTypes.array,
  monthLabels: React.PropTypes.array,
  onChange: React.PropTypes.func,
  onClear: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  onFocus: React.PropTypes.func,
  autoFocus: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
  weekStartsOnMonday: function weekStartsOnMonday(props, propName, componentName) {
    if (props[propName]) {
      return new Error("Prop '".concat(propName, "' supplied to '").concat(componentName, "' is obsolete. Use 'weekStartsOn' instead."));
    }
  },
  weekStartsOn: React.PropTypes.number,
  clearButtonElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
  showClearButton: React.PropTypes.bool,
  previousButtonElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
  nextButtonElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
  calendarPlacement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.func]),
  dateFormat: React.PropTypes.string,
  // 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD-MM-YYYY'
  bsClass: React.PropTypes.string,
  bsSize: React.PropTypes.string,
  calendarContainer: React.PropTypes.object,
  id: React.PropTypes.string,
  name: React.PropTypes.string,
  showTodayButton: React.PropTypes.bool,
  todayButtonLabel: React.PropTypes.string,
  instanceCount: React.PropTypes.number,
  customControl: React.PropTypes.object,
  roundedCorners: React.PropTypes.bool,
  children: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.node), React.PropTypes.node])
};
DatePicker.defaultProps = {
  dateFormat: 'MM/DD/YYYY',
  cellPadding: '5px',
  dayLabels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  clearButtonElement: '×',
  previousButtonElement: '<',
  nextButtonElement: '>',
  calendarPlacement: 'bottom',
  showClearButton: true,
  autoFocus: false,
  disabled: false,
  showTodayButton: true,
  todayButtonLabel: 'Today',
  autoComplete: 'on',
  instanceCount: 1,
  style: {
    width: '100%'
  },
  roundedCorners: false
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var GroupContactCell = /*#__PURE__*/function (_React$Component) {
  _inherits(GroupContactCell, _React$Component);

  var _super = _createSuper(GroupContactCell);

  function GroupContactCell(props) {
    var _this2;

    _classCallCheck(this, GroupContactCell);

    _this2 = _super.call(this, props);
    _this2.toggle = _this2.toggle.bind(_assertThisInitialized(_this2));
    _this2.state = {
      show: false
    };
    return _this2;
  }

  _createClass(GroupContactCell, [{
    key: "toggle",
    value: function toggle() {
      console.log(this.props.item.Phone);

      if (!this.state.show && !this.props.item.Phone) {
        var _this = this;

        var apiTypeId = this.props.userService.apiTypeId();

        if (apiTypeId === "4CF523BF-F6DD-441C-810F-C87347963B5D") {
          //platform services
          this.props.apiService.getItem("api/DailySetup/ReservationDetails/" + this.props.item.ReservationId).then(function (response) {
            _this.props.item.Phone = response.data.Phone;

            if (response.data.EmailAddress) {
              _this.props.item.Email = response.data.EmailAddress;
            }

            _this.props.item.GroupType = response.data.GroupType;
            _this.props.item.WebUser = response.data.WebUser;
            _this.props.item.EventCoordinator = response.data.EventCoordinator;
            _this.props.item.SalesPerson = response.data.SalesPerson;
          });
        }

        if (apiTypeId === "0E9DADB2-F56B-4E7E-A3B2-A59632C91D86") {
          this.props.apiService.getItem("api/DailySetup/MazevoEventDetails/" + this.props.item.EventLocator).then(function (response) {
            _this.props.item.Phone = response.data.Phone;

            if (response.data.EmailAddress) {
              _this.props.item.Email = response.data.EmailAddress;
            }
          });
        }
      }

      this.setState({
        show: !this.state.show
      });
    }
  }, {
    key: "render",
    value: function render() {
      var ecLabel = /*#__PURE__*/React.createElement("dt", null, "Event Coordinator");
      var ecData = /*#__PURE__*/React.createElement("dd", null, this.props.item.EventCoordinator, "\xA0");
      var spLabel = /*#__PURE__*/React.createElement("dt", null, "Sales Person");
      var spData = /*#__PURE__*/React.createElement("dd", null, this.props.item.SalesPerson, "\xA0");
      var commentData = "";
      var dateChanged = moment.utc(this.props.item.DateChangedUtc).toDate();
      var r = moment(dateChanged).format("MM/DD/YYYY hh:mm A");
      var apiTypeId = this.props.userService.apiTypeId();

      if (apiTypeId === "BCA944F7-7795-45CD-A21B-CB5F16DC4175" && this.props.item.GroupComments.length > 0) {
        commentData = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Group Comments"), /*#__PURE__*/React.createElement("ul", null, this.props.item.GroupComments.map(function (c) {
          return /*#__PURE__*/React.createElement("li", null, c);
        })));
      }

      var gtLabel = null;
      var gtData = null;

      if (this.props.item.GroupType) {
        gtLabel = /*#__PURE__*/React.createElement("dt", null, "Group Type");
        gtData = /*#__PURE__*/React.createElement("dd", null, this.props.item.GroupType);
      }

      var wuLabel = null;
      var wuData = null;

      if (this.props.item.WebUser) {
        wuLabel = /*#__PURE__*/React.createElement("dt", null, "Everyday User");
        wuData = /*#__PURE__*/React.createElement("dd", null, this.props.item.WebUser);
      }

      var popoverClickRootClose = /*#__PURE__*/React.createElement(ReactBootstrap.Popover, {
        id: "popover-" + this.props.item.BookingId,
        title: "Details"
      }, /*#__PURE__*/React.createElement("div", {
        className: "groupDetails"
      }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Reservation ID"), /*#__PURE__*/React.createElement("dd", null, this.props.item.ReservationId, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Booking ID"), /*#__PURE__*/React.createElement("dd", null, this.props.item.EventLocator, "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Phone"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("a", {
        href: "tel:{this.props.item.Phone}"
      }, this.props.item.Phone), "\xA0"), /*#__PURE__*/React.createElement("dt", null, "Email"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("a", {
        href: "mailto:{this.props.item.Email}"
      }, this.props.item.Email), "\xA0"), ecLabel, ecData, this.props.item.SalesPerson && spLabel, this.props.item.SalesPerson && spData, gtLabel, gtData, wuLabel, wuData, /*#__PURE__*/React.createElement("dt", null, "Modified At"), /*#__PURE__*/React.createElement("dd", null, r)), commentData));
      return /*#__PURE__*/React.createElement(ReactBootstrap.OverlayTrigger, {
        trigger: "click",
        rootClose: true,
        placement: "top",
        overlay: popoverClickRootClose
      }, /*#__PURE__*/React.createElement("td", {
        onClick: this.toggle,
        className: "pointer gcCell"
      }, /*#__PURE__*/React.createElement("span", {
        className: this.props.item.IsVip ? 'vipEvent' : ''
      }, this.props.item.GroupName, "\xA0", this.props.item.GroupComments.length > 0 && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-user-plus fa-1-2x pointer",
        title: "Has preferences"
      }), /*#__PURE__*/React.createElement("br", null), this.props.item.FirstContact, "\xA0")));
    }
  }]);

  return GroupContactCell;
}(React.Component);

GroupContactCell.propTypes = {
  item: React.PropTypes.object,
  apiService: React.PropTypes.object,
  userService: React.PropTypes.object
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NewTaskModal = /*#__PURE__*/function (_React$Component) {
  _inherits(NewTaskModal, _React$Component);

  var _super = _createSuper(NewTaskModal);

  function NewTaskModal(props) {
    var _this;

    _classCallCheck(this, NewTaskModal);

    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.saveAndClose = _this.saveAndClose.bind(_assertThisInitialized(_this));
    _this.handleDepartmentChange = _this.handleDepartmentChange.bind(_assertThisInitialized(_this));
    _this.handleDateChanged = _this.handleDateChanged.bind(_assertThisInitialized(_this));
    _this.validate = _this.validate.bind(_assertThisInitialized(_this));
    _this.isDepartmentChecked = _this.isDepartmentChecked.bind(_assertThisInitialized(_this));
    _this.handleTemplateChanged = _this.handleTemplateChanged.bind(_assertThisInitialized(_this));
    _this.state = {
      LinkedTask: _this.props.linkedTask,
      usersInDepartments: [],
      taskTemplates: [],
      selectedTemplate: ''
    };
    return _this;
  }

  _createClass(NewTaskModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        LinkedTask: nextProps.linkedTask
      });
      this.setState({
        usersInDepartments: nextProps.initialUsersInDepartment
      });
      this.setState({
        taskTemplates: nextProps.taskTemplates
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var linkedTask = this.state.LinkedTask;
      var target = event.target;
      var fieldName = target.id;
      var fieldVal = target.type === 'checkbox' ? target.checked : target.value;
      linkedTask[fieldName] = fieldVal;
      this.setState({
        LinkedTask: linkedTask
      });
    }
  }, {
    key: "handleTemplateChanged",
    value: function handleTemplateChanged(event) {
      var linkedTask = this.state.LinkedTask;
      var target = event.target;
      var selectedTemplateId = target.value;
      this.setState({
        selectedTemplate: selectedTemplateId
      });

      if (selectedTemplateId) {
        for (var i = 0; i < this.state.taskTemplates.length; i++) {
          var t = this.state.taskTemplates[i];

          if (selectedTemplateId === t.UId) {
            if (linkedTask.Description) {
              linkedTask.Description = linkedTask.Description + '\n' + t.Description;
            } else {
              linkedTask.Description = t.Description;
            }

            linkedTask.DepartmentIds = t.DepartmentIds;
            linkedTask.StartAt = moment(t.StartAt, 'HH:mm').format("HH:mm");
            linkedTask.FinishBy = moment(t.FinishBy, 'HH:mm').format("HH:mm");
            break;
          }
        }
      }

      this.setState({
        LinkedTask: linkedTask
      });
    }
  }, {
    key: "handleDepartmentChange",
    value: function handleDepartmentChange(event) {
      //this.handleChange(event);
      var linkedTask = this.state.LinkedTask;
      var target = event.target;
      var fieldId = target.id;
      var idParts = fieldId.split("-");
      var deptId = Number(idParts[1]);

      if (target.checked) {
        linkedTask.DepartmentIds.push(deptId);
      } else {
        var index = linkedTask.DepartmentIds.indexOf(deptId);

        if (index > -1) {
          linkedTask.DepartmentIds.splice(index, 1);
        }
      }

      var usersInDepartments = [];
      var addedUserIds = [];

      for (var i = 0; i < this.props.allUsers.length; i++) {
        var user = this.props.allUsers[i];

        for (var j = 0; j < user.Departments.length; j++) {
          for (var ii = 0; ii < linkedTask.DepartmentIds.length; ii++) {
            if (linkedTask.DepartmentIds[ii] == user.Departments[j]) {
              if (addedUserIds.indexOf(user.Id) === -1) {
                addedUserIds.push(user.Id);
                usersInDepartments.push(user);
              }
            }
          }
        }
      }

      this.setState({
        LinkedTask: linkedTask,
        usersInDepartments: usersInDepartments
      });
    }
  }, {
    key: "handleDateChanged",
    value: function handleDateChanged(isoDate, dateOnly, controlId) {
      var linkedTask = this.state.LinkedTask;
      linkedTask[controlId] = isoDate;
      this.setState({
        LinkedTask: linkedTask
      });
    }
  }, {
    key: "handleClear",
    value: function handleClear(id) {
      this.handleDateChanged("", null, id);
    }
  }, {
    key: "isDepartmentChecked",
    value: function isDepartmentChecked(id) {
      if (this.state.LinkedTask && this.state.LinkedTask.DepartmentIds) {
        return this.state.LinkedTask.DepartmentIds.indexOf(id) >= 0;
      }

      return false;
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      var _that = this;

      var linkedTask = this.state.LinkedTask;
      var mStartAt = moment(linkedTask.StartAt, 'HH:mm');
      var mDisplayOn = moment(linkedTask.DisplayOn, 'YYYY-MM-DD');
      linkedTask.DisplayOn = mDisplayOn.format("YYYY-MM-DDT00:00");
      this.props.apiService.saveItem('api/Tasks', linkedTask).then(function (saveResult) {
        _that.props.updateBookingWithTaskId(_that.props.linkedTaskModalItem, saveResult.data.TaskId);

        _that.props.close();
      })["catch"](function (error) {});
    }
  }, {
    key: "validateHaveData",
    value: function validateHaveData(linkedTask, key, errors) {
      if (this.isEmpty(linkedTask[key])) {
        errors[key] = "Required";
      } else {
        errors[key] = "";
      }
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(data) {
      return !data || data.length === 0;
    }
  }, {
    key: "validate",
    value: function validate() {
      var linkedTask = this.state.LinkedTask;
      var errors = {};

      if (linkedTask) {
        this.validateHaveData(linkedTask, "Description", errors);
        this.validateHaveData(linkedTask, "DisplayOn", errors);
        this.validateHaveData(linkedTask, "StartAt", errors);
        this.validateShowOnDays(linkedTask, errors);
        this.validateDisplayUntil(linkedTask, errors);
      }

      return errors;
    }
  }, {
    key: "validateShowOnDays",
    value: function validateShowOnDays(linkedTask, errors) {
      if (!this.isEmpty(linkedTask.DisplayUntil)) {
        if (linkedTask.DisplaysOnSunday || linkedTask.DisplaysOnMonday || linkedTask.DisplaysOnTuesday || linkedTask.DisplaysOnWednesday || linkedTask.DisplaysOnThursday || linkedTask.DisplaysOnFriday || linkedTask.DisplaysOnSunday) {
          errors.WeekDayDisplay = "";
        } else {
          errors.WeekDayDisplay = "Repeating tasks must repeat on a least one day of the week";
        }
      } else {
        errors.WeekDayDisplay = "";
      }
    }
  }, {
    key: "validateDisplayUntil",
    value: function validateDisplayUntil(linkedTask, errors) {
      var key = "DisplayUntil";

      if (this.isEmpty(linkedTask.DisplayUntil) || this.isEmpty(linkedTask.StartAt) || this.isEmpty(linkedTask.DisplayOn)) {
        errors[key] = "";
        return;
      }

      var mStartAt = moment(linkedTask.StartAt, 'HH:mm');
      var mDisplayOn = moment(linkedTask.DisplayOn, 'YYYY-MM-DD');
      var fromLocal = new Date(mDisplayOn.get('year'), mDisplayOn.get('month'), mDisplayOn.get('day'), mStartAt.get('hour'), mStartAt.get('minutes'), 0, 0);
      var displayFrom = moment(fromLocal);
      var displayUntil = moment(linkedTask["DisplayUntil"]);

      if (displayFrom.isAfter(displayUntil)) {
        errors[key] = "Display Until must be after Display On";
      } else {
        errors[key] = "";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var errors = this.validate();
      var isDisabled = Object.keys(errors).some(function (x) {
        return errors[x];
      });
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        bsSize: "lg"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, "New Linked Task")), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        controlId: "taskTemplate"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Template"), /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        componentClass: "select",
        value: this.state.selectedTemplate,
        onChange: this.handleTemplateChanged,
        id: "taskTemplate"
      }, /*#__PURE__*/React.createElement("option", {
        key: "",
        value: ""
      }), this.state.taskTemplates.map(function (template, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: template.UId,
          value: template.UId
        }, template.TemplateName);
      }))), /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        controlId: "Description",
        validationState: errors.Description.length > 0 ? "error" : null
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Description"), /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        type: "textarea",
        value: this.state.LinkedTask.Description,
        placeholder: "Enter text",
        componentClass: "textarea",
        onChange: this.handleChange
      }), /*#__PURE__*/React.createElement(ReactBootstrap.HelpBlock, null, errors.Description)), /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        controlId: "DepartmentId"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Departments"), /*#__PURE__*/React.createElement("div", null, this.props.departments.map(function (dept, i) {
        return /*#__PURE__*/React.createElement("label", {
          style: {
            paddingRight: 20 + "px",
            fontWeight: "normal"
          }
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: "dept-" + dept.ID,
          onChange: _this2.handleDepartmentChange,
          checked: _this2.isDepartmentChecked(dept.ID)
        }), dept.Description);
      }))), /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        controlId: "AssignedToUserId"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Assigned To "), /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        componentClass: "select",
        value: this.state.LinkedTask.AssignedToUserId,
        onChange: this.handleChange,
        id: "AssignedToUserId"
      }, /*#__PURE__*/React.createElement("option", {
        key: "",
        value: ""
      }, "(unassigned)"), this.state.usersInDepartments.map(function (user, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: user.Id,
          value: user.Id
        }, user.UserName);
      }))), /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        validationState: errors.DisplayOn.length > 0 ? "error" : null
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Display On"), /*#__PURE__*/React.createElement(DatePicker, {
        id: "DisplayOn",
        onChange: this.handleDateChanged,
        value: this.state.LinkedTask.DisplayOn
      }), this.isEmpty(this.state.LinkedTask.DisplayOn) && /*#__PURE__*/React.createElement(ReactBootstrap.HelpBlock, null, "Required")), /*#__PURE__*/React.createElement(TimePicker, {
        id: "StartAt",
        label: "Start At",
        onChange: this.handleChange,
        value: this.state.LinkedTask.StartAt,
        validationState: errors.StartAt.length > 0 ? "error" : null,
        feedBack: errors.StartAt,
        allowEmpty: false
      }), /*#__PURE__*/React.createElement(TimePicker, {
        id: "FinishBy",
        label: "Finish By",
        onChange: this.handleChange,
        value: this.state.LinkedTask.FinishBy,
        validationState: null
      }), /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        validationState: errors.DisplayUntil.length > 0 ? "error" : null
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Display Until"), /*#__PURE__*/React.createElement(DatePicker, {
        id: "DisplayUntil",
        onClear: function onClear() {
          _this2.handleClear('DisplayUntil');
        },
        onChange: this.handleDateChanged,
        value: this.state.LinkedTask.DisplayUntil
      }), /*#__PURE__*/React.createElement(ReactBootstrap.HelpBlock, null, errors.DisplayUntil)), /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        validationState: errors.WeekDayDisplay.length > 0 ? "error" : null
      }, /*#__PURE__*/React.createElement(ReactBootstrap.FormControl.Static, null, /*#__PURE__*/React.createElement("span", {
        className: "help-block control-label"
      }, "Show on the following days")), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnSunday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnSunday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Sunday"), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnMonday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnMonday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Monday"), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnTuesday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnTuesday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Tuesday"), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnWednesday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnWednesday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Wednesday"), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnThursday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnThursday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Thursday"), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnFriday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnFriday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Friday"), /*#__PURE__*/React.createElement("label", {
        style: {
          paddingRight: 20 + "px",
          fontWeight: "normal"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "DisplaysOnSaturday",
        onChange: this.handleChange,
        checked: this.state.LinkedTask.DisplaysOnSaturday,
        disabled: !this.state.LinkedTask.DisplayUntil
      }), "Saturday"), /*#__PURE__*/React.createElement(ReactBootstrap.HelpBlock, null, errors.WeekDayDisplay)))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose,
        className: "btn btn-primary",
        disabled: isDisabled
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-save"
      }), /*#__PURE__*/React.createElement("span", {
        className: "detailsButtonText"
      }, "Save")), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Close")));
    }
  }]);

  return NewTaskModal;
}(React.Component);

NewTaskModal.propTypes = {
  departments: React.PropTypes.array,
  linkedTask: React.PropTypes.object,
  apiService: React.PropTypes.object,
  linkedTaskModalItem: React.PropTypes.object,
  updateBookingWithTaskId: React.PropTypes.func,
  allUsers: React.PropTypes.array,
  initialUsersInDepartment: React.PropTypes.array
};
NewTaskModal.defaultProps = {
  departments: [],
  allUsers: [],
  linkedTask: {},
  linkedTaskModalItem: {},
  initialUsersInDepartment: []
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NotesModal = /*#__PURE__*/function (_React$Component) {
  _inherits(NotesModal, _React$Component);

  var _super = _createSuper(NotesModal);

  function NotesModal(props) {
    var _this;

    _classCallCheck(this, NotesModal);

    _this = _super.call(this, props);
    _this.addNote = _this.addNote.bind(_assertThisInitialized(_this));
    _this.isFormInvalid = _this.isFormInvalid.bind(_assertThisInitialized(_this));
    _this.deleteNote = _this.deleteNote.bind(_assertThisInitialized(_this));
    _this.deleteAttachment = _this.deleteAttachment.bind(_assertThisInitialized(_this));
    _this.updateNote = _this.updateNote.bind(_assertThisInitialized(_this));
    _this.canEdit = _this.canEdit.bind(_assertThisInitialized(_this));
    _this.canDelete = _this.canDelete.bind(_assertThisInitialized(_this));
    _this.addAndClose = _this.addAndClose.bind(_assertThisInitialized(_this));
    _this.acknowledgeNote = _this.acknowledgeNote.bind(_assertThisInitialized(_this));
    _this.toggleDepartment = _this.toggleDepartment.bind(_assertThisInitialized(_this));
    _this.modalClosing = _this.modalClosing.bind(_assertThisInitialized(_this));
    _this.state = {
      disableDepartment: true,
      isFormInvalid: false
    };
    return _this;
  }

  _createClass(NotesModal, [{
    key: "canEdit",
    value: function canEdit(n) {
      return n.CreatedById == this.props.userService.userId();
    }
  }, {
    key: "canDelete",
    value: function canDelete(n) {
      return this.canEdit(n) || this.props.userService.userType() > 0;
    }
  }, {
    key: "toggleDepartment",
    value: function toggleDepartment() {
      if ($("#alertUser").is(":checked")) {
        this.setState({
          disableDepartment: false
        });
      } else {
        $("#department").val("");
        this.setState({
          disableDepartment: true
        });
      }
    }
  }, {
    key: "addNote",
    value: function addNote() {
      this.isFormInvalid();
      var note = {};
      note.Notes = $("#newNote").val();
      note.DepartmentId = $("#department").val();
      var that = this;
      var p = this.props.notesDataService.newNote(note, this.props.item);

      if (p) {
        p.then(function (x) {
          var found = false;

          for (var i = 0; i < that.props.item.Notes.length; i++) {
            if (that.props.item.Notes[i].ID === x.ID) {
              found = true;
              break;
            }
          }

          if (found === false) {
            that.props.item.Notes.push(x);
          }
        });
      }

      $("#newNote").val("");
      this.setState({
        invalidForm: false
      });
    }
  }, {
    key: "isFormInvalid",
    value: function isFormInvalid() {
      var imgInput = document.getElementById("photo");
      var isUploading = imgInput && imgInput.files.length > 0;
      var hasNoteValue = $("#newNote").val();

      if (isUploading) {
        if (hasNoteValue) {
          this.setState({
            isFormInvalid: false
          });
        } else {
          this.setState({
            isFormInvalid: true
          });
        }
      } else {
        this.setState({
          isFormInvalid: false
        });
      }
    }
  }, {
    key: "addAndClose",
    value: function addAndClose() {
      this.isFormInvalid();

      if (!this.state.isFormInvalid) {
        this.addNote();
        this.props.close();
      }
    }
  }, {
    key: "updateNote",
    value: function updateNote(note) {
      note.Notes = $("#editingNotes").val();
      this.props.notesDataService.updateNote(note, this.props.item);
      this.refs.editOverlay.hide();
    }
  }, {
    key: "deleteNote",
    value: function deleteNote(note) {
      this.props.notesDataService.deleteNote(note, this.props.item);

      if (this.refs.editOverlay) {
        this.refs.editOverlay.hide();
      }
    }
  }, {
    key: "acknowledgeNote",
    value: function acknowledgeNote(note) {
      this.props.notesDataService.acknowledgeNote(note, this.props.item);
      this.refs.acknowledgeOverlay.hide();
    }
  }, {
    key: "deleteAttachment",
    value: function deleteAttachment(id, note) {
      this.props.notesDataService.deleteAttachment(id, note);
      this.refs.overlay.hide();
    }
  }, {
    key: "deleteConfirmationPopover",
    value: function deleteConfirmationPopover(id, type, title, clickFunc) {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(ReactBootstrap.Popover, {
        id: "popover-" + type + id,
        title: title
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-danger",
        onClick: clickFunc
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash-o"
      }), "Delete"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-warning btn-form-md",
        onClick: function onClick() {
          _this2.refs.overlay.hide();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-undo"
      }), "Cancel")));
    }
  }, {
    key: "editPopover",
    value: function editPopover(note, type, title, clickFunc) {
      var _this3 = this;

      return /*#__PURE__*/React.createElement(ReactBootstrap.Popover, {
        id: "popover-" + type + note.ID,
        title: title
      }, /*#__PURE__*/React.createElement("textarea", {
        className: "entryEdit",
        defaultValue: note.Notes,
        id: "editingNotes"
      }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary",
        onClick: clickFunc
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash-o"
      }), "Save"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-warning btn-form-md",
        onClick: function onClick() {
          _this3.refs.editOverlay.hide();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-undo"
      }), "Cancel")));
    }
  }, {
    key: "acknowledgePopover",
    value: function acknowledgePopover(note, type, title, clickFunc) {
      var _this4 = this;

      return /*#__PURE__*/React.createElement(ReactBootstrap.Popover, {
        id: "popover-" + type + note.ID,
        title: title
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary",
        onClick: clickFunc
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-thumbs-up"
      }), "Acknowledge"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-warning btn-form-md",
        onClick: function onClick() {
          _this4.refs.acknowledgeOverlay.hide();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-undo"
      }), "Cancel")));
    }
  }, {
    key: "modalClosing",
    value: function modalClosing() {
      this.setState({
        disableDepartment: true,
        isFormInvalid: false
      });
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var sortedNotes = [];

      if (this.props.item && this.props.item.Notes) {
        sortedNotes = this.props.item.Notes.sort(function (a, b) {
          a = new Date(a.DateAddedUtc);
          b = new Date(b.DateAddedUtc);
          return a > b ? -1 : a < b ? 1 : 0;
        });
      }

      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.modalClosing,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, this.props.item.EventName && /*#__PURE__*/React.createElement("h3", null, " ", this.props.item.EventName), this.props.item.TaskDescription && /*#__PURE__*/React.createElement("h3", null, this.props.item.TaskDescription)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "notesModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Notes"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "text-left"
      }, "Note"), /*#__PURE__*/React.createElement("textarea", {
        id: "newNote",
        name: "newNote",
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-left fileUpload"
      }, /*#__PURE__*/React.createElement("label", null, "Upload\xA0"), /*#__PURE__*/React.createElement("input", {
        id: "photo",
        name: "photo",
        type: "file",
        className: "upload",
        accept: "image/*"
      })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        className: "pull-left"
      }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "alertUser",
        onClick: function onClick() {
          return _this5.toggleDepartment();
        }
      }), "Urgent Action Required")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pull-left"
      }, /*#__PURE__*/React.createElement("label", {
        className: "text-left"
      }, "Alert users in this department\xA0")), /*#__PURE__*/React.createElement("select", {
        id: "department",
        name: "department",
        className: "form-control",
        disabled: this.state.disableDepartment
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }), this.props.departments.map(function (dept, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: dept.ID,
          value: dept.ID
        }, dept.Description);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this5.addNote();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }), "Add Note"), /*#__PURE__*/React.createElement("br", null), this.state.isFormInvalid && /*#__PURE__*/React.createElement("span", {
        className: "red"
      }, "You must supply a note...     ")), /*#__PURE__*/React.createElement("div", {
        className: "row notesList"
      }, /*#__PURE__*/React.createElement("ul", null, sortedNotes.map(function (n) {
        return /*#__PURE__*/React.createElement("li", {
          key: n.ID
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            display: "inline-block",
            backgroundColor: n.Color ? n.Color : "#1171a3"
          },
          className: "taskCircle  text-center taskCircleText"
        }, n.Initials), /*#__PURE__*/React.createElement("span", {
          className: "userName"
        }, n.UserName), /*#__PURE__*/React.createElement("p", {
          className: "notesListNote"
        }, n.Notes), /*#__PURE__*/React.createElement("div", {
          className: "timeAndActions noHoverA"
        }, moment(moment.utc(n.DateAddedUtc).toDate()).format("MMM DD [at] hh:mm A"), "\xA0", _this5.canEdit(n) && /*#__PURE__*/React.createElement(ReactBootstrap.OverlayTrigger, {
          trigger: "click",
          rootClose: true,
          placement: "top",
          ref: "editOverlay",
          overlay: _this5.editPopover(n, "editNote", "Edit Note", function () {
            return _this5.updateNote(n);
          })
        }, /*#__PURE__*/React.createElement("a", {
          className: "noHoverA"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-edit fa-1-5x icon-vertical-middle"
        }), " Edit\xA0")), _this5.canDelete(n) && /*#__PURE__*/React.createElement(ReactBootstrap.OverlayTrigger, {
          trigger: "click",
          rootClose: true,
          placement: "top",
          ref: "overlay",
          overlay: _this5.deleteConfirmationPopover(n.ID, "note", "Delete Note", function () {
            return _this5.deleteNote(n);
          })
        }, /*#__PURE__*/React.createElement("a", {
          className: "noHoverA"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash-o fa-1-5x icon-vertical-middle"
        }), " Delete")), n.UserCanAcknowledge && /*#__PURE__*/React.createElement("div", {
          className: "pull-right"
        }, /*#__PURE__*/React.createElement(ReactBootstrap.OverlayTrigger, {
          trigger: "click",
          rootClose: true,
          placement: "top",
          ref: "acknowledgeOverlay",
          overlay: _this5.acknowledgePopover(n, "ack", "Acknowledge Note", function () {
            return _this5.acknowledgeNote(n);
          })
        }, /*#__PURE__*/React.createElement("a", {
          className: "noHoverA"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-thumbs-up fa-1-5x icon-vertical-middle"
        }), " Acknowledge"))), n.AcknowledgedBy && /*#__PURE__*/React.createElement("div", {
          className: "pull-right"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-thumbs-up fa-1-5x icon-vertical-middle"
        }), " by ", n.AcknowledgedBy)), n.Base64Data && /*#__PURE__*/React.createElement("div", {
          className: "photoBox"
        }, /*#__PURE__*/React.createElement("img", {
          src: "data:image/png;base64," + n.Base64Data,
          style: {
            margin: 'auto'
          }
        }), /*#__PURE__*/React.createElement("br", null), _this5.canDelete(n) && /*#__PURE__*/React.createElement(ReactBootstrap.OverlayTrigger, {
          trigger: "click",
          rootClose: true,
          placement: "top",
          ref: "overlay",
          overlay: _this5.deleteConfirmationPopover(n.AttachmentId, "att", "Delete Attachment", function () {
            return _this5.deleteAttachment(n.AttachmentId, n);
          })
        }, /*#__PURE__*/React.createElement("a", {
          className: "noHoverA"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-thumbs-up fa-1-5x icon-vertical-middle"
        }), " Delete"))));
      })))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, this.state.isFormInvalid && /*#__PURE__*/React.createElement("span", {
        className: "red"
      }, "You must supply a note...     "), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.addAndClose
      }, "Ok")));
    }
  }]);

  return NotesModal;
}(React.Component);

NotesModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  notesDataService: React.PropTypes.object
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NOTItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NOTItem, _React$Component);

  var _super = _createSuper(NOTItem);

  function NOTItem(props) {
    _classCallCheck(this, NOTItem);

    return _super.call(this, props);
  }

  _createClass(NOTItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      var s = {};

      if (this.props.highlightColor !== "") {
        s.color = this.props.highlightColor;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "categoryHeading NOT"
      }, this.props.service.Category.Description), this.props.service.ServiceOrderDetails.map(function (sod) {
        return /*#__PURE__*/React.createElement("p", {
          style: sod.MinutesSinceLastChange < _this.props.minutesSinceLastChange ? s : {},
          className: "preWrap indent" + (sod.MinutesSinceLastChange < _this.props.minutesSinceLastChange ? "sodRecentlyChanged" : ""),
          key: sod.ID,
          dangerouslySetInnerHTML: {
            __html: sod.Notes
          },
          highlightColor: _this.props.highlightColor
        });
      }));
    }
  }]);

  return NOTItem;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PDF = /*#__PURE__*/function (_React$Component) {
  _inherits(PDF, _React$Component);

  var _super = _createSuper(PDF);

  function PDF(props) {
    var _this;

    _classCallCheck(this, PDF);

    _this = _super.call(this, props);
    _this.state = {
      pdf: null,
      scale: 1.2
    };
    return _this;
  }

  _createClass(PDF, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        pdf: this.state.pdf,
        scale: this.state.scale
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var that = this;
      pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
      var pdfData = window.atob(this.props.pdfData);
      var loadingTask = pdfjsLib.getDocument({
        data: pdfData
      });
      loadingTask.promise.then(function (pdf) {
        _this2.setState({
          pdf: pdf
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "pdf-context"
      }, this.props.children);
    }
  }]);

  return PDF;
}(React.Component);

PDF.propTypes = {
  pdfData: React.PropTypes.string.isRequired
};
PDF.childContextTypes = {
  pdf: React.PropTypes.object,
  scale: React.PropTypes.number
};

var Page = /*#__PURE__*/function (_React$Component2) {
  _inherits(Page, _React$Component2);

  var _super2 = _createSuper(Page);

  function Page(props) {
    var _this3;

    _classCallCheck(this, Page);

    _this3 = _super2.call(this, props);
    _this3.state = {
      status: 'N/A',
      page: null,
      width: 0,
      height: 0
    };
    return _this3;
  }

  _createClass(Page, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.context.pdf != nextContext.pdf || this.state.status !== nextState.status;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps, nextState, nextContext) {
      this._update(nextContext.pdf);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._update(this.context.pdf);
    }
  }, {
    key: "_update",
    value: function _update(pdf) {
      if (pdf) {
        this._loadPage(pdf);
      } else {
        this.setState({
          status: 'loading'
        });
      }
    }
  }, {
    key: "_loadPage",
    value: function _loadPage(pdf) {
      if (this.state.status === 'rendering' || this.state.page != null) return;
      pdf.getPage(this.props.index).then(this._renderPage.bind(this), function (error) {
        console.log(error);
      });
      this.setState({
        status: 'rendering'
      });
    }
  }, {
    key: "_renderPage",
    value: function _renderPage(page) {
      var scale = this.context.scale;
      var canvas = this.refs.canvas;
      var context = canvas.getContext('2d');
      var viewport = page.getViewport({
        scale: scale
      });
      var outputScale = window.devicePixelRatio || 1;
      canvas.width = Math.floor(viewport.width * outputScale);
      canvas.height = Math.floor(viewport.height * outputScale);
      canvas.style.width = Math.floor(viewport.width) + "px";
      canvas.style.heigth = Math.floor(viewport.height) + "px";
      var transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;
      var renderContext = {
        canvasContext: context,
        transform: transform,
        viewport: viewport
      };
      var renderTask = page.render(renderContext);
      renderTask.promise.then(function () {});
      this.setState({
        status: 'rendered',
        page: page
      }); //style={{ width, height }}
    }
  }, {
    key: "render",
    value: function render() {
      var status = this.state.status;
      return /*#__PURE__*/React.createElement("div", {
        className: 'pdf-page {status}'
      }, /*#__PURE__*/React.createElement("canvas", {
        ref: "canvas"
      }));
    }
  }]);

  return Page;
}(React.Component);

Page.propTypes = {
  index: React.PropTypes.number.isRequired
};
Page.contextTypes = PDF.childContextTypes;

var Viewer = /*#__PURE__*/function (_React$Component3) {
  _inherits(Viewer, _React$Component3);

  var _super3 = _createSuper(Viewer);

  function Viewer() {
    _classCallCheck(this, Viewer);

    return _super3.apply(this, arguments);
  }

  _createClass(Viewer, [{
    key: "render",
    value: function render() {
      var pdf = this.context.pdf; //let numPages = pdf ? pdf.pdfInfo.numPages : 0

      var numPages = pdf ? pdf.numPages : 0;
      var fingerprint = pdf ? pdf.fingerprints : 'none';
      var pages = Array.apply(null, {
        length: numPages
      }).map(function (v, i) {
        return /*#__PURE__*/React.createElement(Page, {
          index: i + 1,
          key: "".concat(fingerprint, "-").concat(i)
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "pdf-viewer"
      }, pages);
    }
  }]);

  return Viewer;
}(React.Component);

Viewer.contextTypes = PDF.childContextTypes;
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SPPdfViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(SPPdfViewer, _React$Component);

  var _super = _createSuper(SPPdfViewer);

  function SPPdfViewer(props) {
    var _this;

    _classCallCheck(this, SPPdfViewer);

    _this = _super.call(this, props);
    _this.state = {
      pdfUrl: null
    };
    return _this;
  }

  _createClass(SPPdfViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log(this.props.pdfData);
      var bytes = window.atob(this.props.pdfData);
      var length = bytes.length;
      var out = new Uint8Array(length);

      while (length--) {
        out[length] = bytes.charCodeAt(length);
      }

      var blob = new Blob([out], {
        type: 'application/pdf'
      });
      this.setState({
        pdfUrl: URL.createObjectURL(blob)
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid rgba(0, 0, 0, 0.3)',
          height: '750px'
        }
      }, /*#__PURE__*/React.createElement(Viewer, {
        fileUrl: this.state.pdfUrl
      }));
    }
  }]);

  return SPPdfViewer;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RecentChangesCell = /*#__PURE__*/function (_React$Component) {
  _inherits(RecentChangesCell, _React$Component);

  var _super = _createSuper(RecentChangesCell);

  function RecentChangesCell(props) {
    _classCallCheck(this, RecentChangesCell);

    return _super.call(this, props);
  }

  _createClass(RecentChangesCell, [{
    key: "render",
    value: function render() {
      var clickHtml = this.props.showHistoryModal.bind(this, this.props.item);
      var cellStyle = {
        width: '30px',
        cursor: 'default',
        textAlign: 'center'
      };
      var bookingIconClass = "";
      var bookingTitle = "";
      var bookingIcon = null;

      if (this.props.item.MinutesSinceLastChange < this.props.minutesSinceLastChange) {
        if (this.props.item.MinutesSinceFirstCompletion > this.props.item.MinutesSinceLastChange && this.props.item.MinutesSinceLastChange > 0) {
          bookingIconClass = "fa-warning";
          cellStyle.cursor = "pointer";
          bookingTitle = "Booking change after completion";
        } else {
          if (this.props.item.DateAddedUtc == this.props.item.DateChangedUtc) {
            bookingIconClass = "fa-bolt";
            bookingTitle = "New booking";
          } else {
            bookingIconClass = "fa-exclamation";
            cellStyle.cursor = "pointer";
            bookingTitle = "Recent booking changes";
          }
        }

        bookingIcon = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-1-5x " + bookingIconClass,
          title: bookingTitle
        });
      }

      var soIconClass = "";
      var soTitle = "";
      var soIcon = null;

      if (this.props.item.MinutesSinceLastDetailChange < this.props.minutesSinceLastChange && this.props.item.MinutesSinceLastDetailChange > 0) {
        if (this.props.item.MinutesSinceFirstCompletion >= this.props.item.MinutesSinceLastDetailChange) {
          soIconClass = "fa-italic";
          cellStyle.cursor = "pointer";
          soTitle = "Service change after completion";
        } else {
          soIconClass = "fa-info";
          cellStyle.cursor = "pointer";
          soTitle = "Recent service changes";
        }

        soIcon = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-1-5x " + soIconClass,
          title: soTitle
        });
      }

      var needsSanatized = null;

      if (this.props.item.RoomNeedsSanitized) {
        needsSanatized = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-1-5x fa-circle serviceMode",
          title: "Room needs service"
        });
      }

      var requireAck = null;

      if (this.props.item.RequiresAcknowledgement) {
        requireAck = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-1-5x fa-bell faa-flash animated orange",
          title: "High priority note"
        });
      }

      return /*#__PURE__*/React.createElement("td", {
        className: "rcCell",
        style: cellStyle,
        onClick: clickHtml
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        "aria-label": "open booking history"
      }, requireAck, bookingIcon, soIcon, needsSanatized));
    }
  }]);

  return RecentChangesCell;
}(React.Component);

RecentChangesCell.propTypes = {
  item: React.PropTypes.object,
  minutesSinceLastChange: React.PropTypes.number,
  close: React.PropTypes.func
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RESItem = /*#__PURE__*/function (_React$Component) {
  _inherits(RESItem, _React$Component);

  var _super = _createSuper(RESItem);

  function RESItem(props) {
    _classCallCheck(this, RESItem);

    return _super.call(this, props);
  }

  _createClass(RESItem, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "categoryHeading RES"
      }, this.props.service.Category.Description), /*#__PURE__*/React.createElement(SodItems, {
        ServiceOrderDetails: this.props.service.ServiceOrderDetails,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        apiService: this.props.apiService,
        filters: this.props.filters,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        updateItemInCollection: this.props.updateItemInCollection,
        highlightColor: this.props.highlightColor
      }));
    }
  }]);

  return RESItem;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RoomDetailsModal = /*#__PURE__*/function (_React$Component) {
  _inherits(RoomDetailsModal, _React$Component);

  var _super = _createSuper(RoomDetailsModal);

  function RoomDetailsModal(props) {
    _classCallCheck(this, RoomDetailsModal);

    return _super.call(this, props);
  }

  _createClass(RoomDetailsModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.Description)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "locationDetailsModal"
      }, /*#__PURE__*/React.createElement("div", null, this.props.item && this.props.item.Notes && /*#__PURE__*/React.createElement("span", {
        className: "userName"
      }, "Notes:\xA0"), /*#__PURE__*/React.createElement("span", {
        className: "preWrap"
      }, " ", this.props.item && this.props.item.Notes)), this.props.item && this.props.item.Features && this.props.item.Features.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Features"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row setupTypesList"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.item.Features.map(function (st) {
        return /*#__PURE__*/React.createElement("li", {
          key: st.ID
        }, /*#__PURE__*/React.createElement("span", {
          className: "userName"
        }, st.Description));
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Setups"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row setupTypesList"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.item && this.props.item.SetupTypes && this.props.item.SetupTypes.map(function (st) {
        return /*#__PURE__*/React.createElement("li", {
          key: st.ID
        }, /*#__PURE__*/React.createElement("span", {
          className: "userName"
        }, st.Description), " ", st.MinCapacity > 0 ? " - min: " + st.MinCapacity : "", " ", st.MaxCapacity > 0 ? " - max: " + st.MaxCapacity : "", st.ImageData && /*#__PURE__*/React.createElement("div", {
          className: "photoBox"
        }, /*#__PURE__*/React.createElement("img", {
          src: "data:image/png;base64," + st.ImageData,
          style: {
            margin: 'auto'
          }
        }), /*#__PURE__*/React.createElement("br", null)));
      }))))), this.props.item && this.props.item.Images && this.props.item.Images.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Images"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row setupTypesList"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.item.Images.map(function (st) {
        return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
          className: "photoBox"
        }, /*#__PURE__*/React.createElement("img", {
          src: "data:image/png;base64," + st,
          style: {
            margin: 'auto'
          }
        }), /*#__PURE__*/React.createElement("br", null)));
      })))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Close")));
    }
  }]);

  return RoomDetailsModal;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RSOItem = /*#__PURE__*/function (_React$Component) {
  _inherits(RSOItem, _React$Component);

  var _super = _createSuper(RSOItem);

  function RSOItem(props) {
    _classCallCheck(this, RSOItem);

    return _super.call(this, props);
  }

  _createClass(RSOItem, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "categoryHeading RSO"
      }, this.props.service.Category.Description, " - ", this.props.service.ServiceType, " from ", moment(this.props.service.TimeStart).format("LT"), " to ", moment(this.props.service.TimeEnd).format("LT")), /*#__PURE__*/React.createElement(SodItems, {
        ServiceOrderDetails: this.props.service.ServiceOrderDetails,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        apiService: this.props.apiService,
        filters: this.props.filters,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        updateItemInCollection: this.props.updateItemInCollection,
        highlightColor: this.props.highlightColor
      }));
    }
  }]);

  return RSOItem;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ServicesList = /*#__PURE__*/function (_React$Component) {
  _inherits(ServicesList, _React$Component);

  var _super = _createSuper(ServicesList);

  function ServicesList(props) {
    _classCallCheck(this, ServicesList);

    return _super.call(this, props);
  }

  _createClass(ServicesList, [{
    key: "render",
    value: function render() {
      var _this = this;

      var s = {};

      if (this.props.highlightColor !== "") {
        s.color = this.props.highlightColor;
      }

      return /*#__PURE__*/React.createElement("ul", null, this.props.services.map(function (so) {
        return /*#__PURE__*/React.createElement("li", {
          key: so.ID,
          style: so.MinutesSinceLastChange < _this.props.minutesSinceLastChange ? s : {},
          className: so.MinutesSinceLastChange < _this.props.minutesSinceLastChange ? "soRecentlyChanged" : ""
        }, so.Category.ResourceCategoryTypeCode === "RES" && /*#__PURE__*/React.createElement(RESItem, {
          service: so,
          minutesSinceLastChange: _this.props.minutesSinceLastChange,
          apiService: _this.props.apiService,
          filters: _this.props.filters,
          updateItemForBookingAction: _this.props.updateItemForBookingAction,
          updateItemInCollection: _this.props.updateItemInCollection,
          highlightColor: _this.props.highlightColor
        }), so.Category.ResourceCategoryTypeCode === "ACT" && /*#__PURE__*/React.createElement(ACTItem, {
          service: so,
          minutesSinceLastChange: _this.props.minutesSinceLastChange,
          highlightColor: _this.props.highlightColor
        }), so.Category.ResourceCategoryTypeCode === "RSO" && /*#__PURE__*/React.createElement(RSOItem, {
          service: so,
          minutesSinceLastChange: _this.props.minutesSinceLastChange,
          apiService: _this.props.apiService,
          filters: _this.props.filters,
          updateItemForBookingAction: _this.props.updateItemForBookingAction,
          updateItemInCollection: _this.props.updateItemInCollection,
          highlightColor: _this.props.highlightColor
        }), so.Category.ResourceCategoryTypeCode === "CAT" && /*#__PURE__*/React.createElement(CATItem, {
          service: so,
          minutesSinceLastChange: _this.props.minutesSinceLastChange,
          apiService: _this.props.apiService,
          filters: _this.props.filters,
          updateItemForBookingAction: _this.props.updateItemForBookingAction,
          updateItemInCollection: _this.props.updateItemInCollection,
          highlightColor: _this.props.highlightColor
        }), so.Category.ResourceCategoryTypeCode === "NOT" && /*#__PURE__*/React.createElement(NOTItem, {
          service: so,
          minutesSinceLastChange: _this.props.minutesSinceLastChange,
          highlightColor: _this.props.highlightColor
        }), so.Category.ResourceCategoryTypeCode === "ATT" && /*#__PURE__*/React.createElement(ATTItem, {
          service: so,
          minutesSinceLastChange: _this.props.minutesSinceLastChange,
          highlightColor: _this.props.highlightColor,
          apiService: _this.props.apiService,
          filters: _this.props.filters,
          updateItemForBookingAction: _this.props.updateItemForBookingAction,
          updateItemInCollection: _this.props.updateItemInCollection
        }));
      }));
    }
  }]);

  return ServicesList;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SodItems = /*#__PURE__*/function (_React$Component) {
  _inherits(SodItems, _React$Component);

  var _super = _createSuper(SodItems);

  function SodItems(props) {
    var _this;

    _classCallCheck(this, SodItems);

    _this = _super.call(this, props);
    _this.showQtyUpdateModal = _this.showQtyUpdateModal.bind(_assertThisInitialized(_this));
    _this.hideQtyUpdateModal = _this.hideQtyUpdateModal.bind(_assertThisInitialized(_this));
    _this.state = {
      updateQtyModalShowing: false,
      updateQtySod: {}
    };
    return _this;
  }

  _createClass(SodItems, [{
    key: "showQtyUpdateModal",
    value: function showQtyUpdateModal(item) {
      this.setState({
        updateQtyModalShowing: true,
        updateQtySod: item
      });
    }
  }, {
    key: "hideQtyUpdateModal",
    value: function hideQtyUpdateModal() {
      this.setState({
        updateQtyModalShowing: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var s = {};

      if (this.props.highlightColor !== "") {
        s.color = this.props.highlightColor;
      }

      return /*#__PURE__*/React.createElement("ul", null, this.props.ServiceOrderDetails.map(function (sod) {
        return /*#__PURE__*/React.createElement("li", {
          key: sod.ID,
          style: sod.MinutesSinceLastChange < _this2.props.minutesSinceLastChange ? s : {},
          className: sod.MinutesSinceLastChange < _this2.props.minutesSinceLastChange ? "sodRecentlyChanged" : ""
        }, sod.Quantity, "\xA0-\xA0", sod.TempResourceDescription || sod.Resource && sod.Resource.Description || "Bad Config - Missing Resource", sod.AllowQtyEdit && /*#__PURE__*/React.createElement("span", {
          onClick: function onClick() {
            return _this2.showQtyUpdateModal(sod);
          }
        }, "\xA0-\xA0", /*#__PURE__*/React.createElement("i", {
          className: "pointer fa fa-pencil black",
          title: "Edit Quantity"
        })), sod.Groupings && sod.Groupings.map(function (rg) {
          return /*#__PURE__*/React.createElement("ul", {
            key: rg.ResourceGroupID
          }, /*#__PURE__*/React.createElement("li", null, rg.Description, /*#__PURE__*/React.createElement("ul", null, rg.Items.map(function (i) {
            return /*#__PURE__*/React.createElement("li", {
              key: i.ID
            }, i.Description, " ", i.Notes && /*#__PURE__*/React.createElement("span", null, " - ", i.Notes));
          }))));
        }), sod.Notes && /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.Notes), /*#__PURE__*/React.createElement("p", {
          className: "preWrap indent"
        }, sod.SpecialInstructions));
      }), /*#__PURE__*/React.createElement(UpdateSodQtyModal, {
        show: this.state.updateQtyModalShowing,
        close: this.hideQtyUpdateModal,
        sod: this.state.updateQtySod,
        apiService: this.props.apiService,
        updateItemForBookingAction: this.props.updateItemForBookingAction,
        filters: this.props.filters,
        updateItemInCollection: this.props.updateItemInCollection
      }));
    }
  }]);

  return SodItems;
}(React.Component);
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SoSchedule = /*#__PURE__*/function (_React$Component) {
  _inherits(SoSchedule, _React$Component);

  var _super = _createSuper(SoSchedule);

  function SoSchedule(props) {
    var _this;

    _classCallCheck(this, SoSchedule);

    _this = _super.call(this, props);
    _this.hideAssignServiceModal = _this.hideAssignServiceModal.bind(_assertThisInitialized(_this));
    _this.showAssignUserModal = _this.showAssignUserModal.bind(_assertThisInitialized(_this));
    _this.sortHeaderClass = _this.sortHeaderClass.bind(_assertThisInitialized(_this));
    _this.sort = _this.sort.bind(_assertThisInitialized(_this));
    _this.state = {
      assignServiceModalShowing: false,
      itemForAssignTo: {},
      allUsers: [],
      currentSortColumn: "TimeStart",
      isSortDesc: false
    };
    return _this;
  }

  _createClass(SoSchedule, [{
    key: "showAssignUserModal",
    value: function showAssignUserModal(item) {
      var _that = this;

      this.props.slidesDataService.getItem("api/DailySetup/GetUsersWithDepartments").then(function (response) {
        _that.setState({
          assignServiceModalShowing: true,
          itemForAssignTo: item,
          allUsers: response.data
        });
      });
    }
  }, {
    key: "hideAssignServiceModal",
    value: function hideAssignServiceModal() {
      this.setState({
        assignServiceModalShowing: false
      });
    }
  }, {
    key: "sort",
    value: function sort(propertyName) {
      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };

      var isDesc = this.state.isSortDesc;

      if (this.state.currentSortColumn === propertyName) {
        isDesc = !this.state.isSortDesc;
        this.setState({
          isSortDesc: isDesc
        });
      } else {
        isDesc = false;
        this.setState({
          currentSortColumn: propertyName,
          isSortDesc: false
        });
      }

      var props = {
        prop: propertyName,
        desc: isDesc
      };

      var _sortBy = function () {
        var _defaults = {
          parser: function parser(x) {
            return x;
          },
          desc: false
        };

        var isObject = function isObject(o) {
          return o !== null && (typeof o === "undefined" ? "undefined" : _typeof(o)) === "object";
        };

        var isDefined = function isDefined(v) {
          return typeof v !== "undefined";
        }; //gets the item to be sorted


        function getItem(x) {
          var sortObj = x;
          var sortProp = this.prop;
          var parts = this.prop.split('.');

          if (parts.length > 1) {
            sortObj = x[parts[0]];
            sortProp = parts[1];
          }

          var isProp = isObject(sortObj) && isDefined(sortObj[sortProp]);
          return this.parser(isProp ? sortObj[sortProp] : sortObj);
        }

        return function (array, options) {
          if (!(array instanceof Array) || !array.length) return [];
          var opt = Object.assign({}, _defaults, options);
          opt.desc = opt.desc ? -1 : 1;
          return array.sort(function (a, b) {
            a = getItem.call(opt, a);
            b = getItem.call(opt, b);

            if (a === null) {
              return -1;
            } else if (b === null) {
              return 1;
            }

            if (a.toLowerCase) {
              a = a.toLowerCase();
              b = b.toLowerCase();
            }

            return opt.desc * (a < b ? -1 : +(a > b));
          });
        };
      }();

      _sortBy(this.props.items, props);
    }
  }, {
    key: "sortHeaderClass",
    value: function sortHeaderClass(propertyName) {
      if (this.state.currentSortColumn === propertyName) {
        if (this.state.isSortDesc) {
          return "st-sort-descent";
        } else {
          return "st-sort-ascent";
        }
      }

      return "";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      //let canShowLocationDetails = this.props.userService.apiTypeId() !== "4D2BFEBD-7631-4AEE-96CF-392CFA0BFB3A" && this.props.userService.apiTypeId() !== "5C088F8B-7D16-4C06-B691-7E6FCD4344AD";
      var nothingDoneColor = "red";
      var serviceHighlightColor = "";

      for (var i = 0; i < this.props.settings.length; i++) {
        if (this.props.settings[i].SettingKey === "NothingDoneDotColor") {
          nothingDoneColor = this.props.settings[i].SettingValue;
        } else if (this.props.settings[i].SettingKey === "ServiceHighlightColor") {
          serviceHighlightColor = this.props.settings[i].SettingValue;
        }
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
        id: "soScheduleTable",
        className: "responsiveTable dailySetup table table-condensed table-striped-hiddenRows"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        className: "dotColumn"
      }, "Done"), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 85 + 'px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("TimeStart"),
        onClick: function onClick() {
          return _this2.sort('TimeStart');
        }
      }, "Start")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 80 + 'px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("TimeEnd"),
        onClick: function onClick() {
          return _this2.sort('TimeEnd');
        }
      }, "End")), /*#__PURE__*/React.createElement("th", {
        className: "pointer"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.sort('RoomDescription');
        },
        className: this.sortHeaderClass("RoomDescription")
      }, "Location")), /*#__PURE__*/React.createElement("th", {
        className: "pointer"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.sort('EventName');
        },
        className: this.sortHeaderClass("EventName")
      }, "Event Name")), /*#__PURE__*/React.createElement("th", {
        className: "pointer"
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("GroupName"),
        onClick: function onClick() {
          return _this2.sort('GroupName');
        }
      }, "Group")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        onClick: function onClick() {
          return _this2.sort('EstimatedCount');
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("EstimatedCount")
      }, "PPL")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        onClick: function onClick() {
          return _this2.sort('ServiceType');
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("ServiceType")
      }, "Service Type")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        onClick: function onClick() {
          return _this2.sort('AssignedTo');
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("AssignedTo")
      }, "Assigned To")))), this.props.items.length === 0 && /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "9"
      }, "No services scheduled today"))), this.props.items.map(function (item) {
        return /*#__PURE__*/React.createElement("tbody", {
          key: item.ID
        }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(CompletionsCell, {
          item: item,
          showCompletionModal: _this2.props.showCompletionModal,
          allCompletionTypes: _this2.props.allCompletionTypes,
          completionsDataService: _this2.props.completionsDataService,
          userService: _this2.props.userService,
          limitCompletionsByDeparments: _this2.props.limitCompletionsByDeparments,
          nothingDoneColor: nothingDoneColor
        })), /*#__PURE__*/React.createElement("td", null, moment(item.TimeStart).format("LT")), /*#__PURE__*/React.createElement("td", null, moment(item.TimeEnd).format("LT")), /*#__PURE__*/React.createElement("td", null, item.RoomDescription), /*#__PURE__*/React.createElement("td", null, item.EventName), /*#__PURE__*/React.createElement("td", null, item.GroupName), /*#__PURE__*/React.createElement("td", null, item.EstimatedCount), /*#__PURE__*/React.createElement("td", null, item.ServiceType), /*#__PURE__*/React.createElement("td", null, item.AssignedToUserId > 0 && /*#__PURE__*/React.createElement("a", {
          onClick: function onClick() {
            return _this2.showAssignUserModal(item);
          }
        }, item.AssignedTo), item.AssignedToUserId == 0 && /*#__PURE__*/React.createElement("a", {
          onClick: function onClick() {
            return _this2.showAssignUserModal(item);
          }
        }, "assign"))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colSpan: "9"
        }, /*#__PURE__*/React.createElement("div", {
          className: "detailsHeading"
        }, "Resources"), /*#__PURE__*/React.createElement(SodItems, {
          ServiceOrderDetails: item.ServiceOrderDetails,
          minutesSinceLastChange: _this2.props.minutesSinceLastChange,
          apiService: _this2.props.slidesDataService,
          filters: _this2.props.filters,
          updateItemForBookingAction: _this2.props.updateItemForBookingAction,
          updateItemInCollection: _this2.props.updateItemInCollection,
          highlightColor: serviceHighlightColor
        }))));
      })), /*#__PURE__*/React.createElement(AssignServiceModal, {
        show: this.state.assignServiceModalShowing,
        linkedTask: this.state.newTaskModalItem,
        departments: this.state.departments,
        allUsers: this.state.allUsers,
        close: this.hideAssignServiceModal,
        apiService: this.props.slidesDataService,
        updateBookingWithTaskId: this.props.updateBookingWithTaskId,
        initialUsersInDepartment: this.state.initialUsersInDepartment,
        item: this.state.itemForAssignTo
      }));
    }
  }]);

  return SoSchedule;
}(React.Component);

SoSchedule.propTypes = {
  items: React.PropTypes.array,
  minutesSinceLastChange: React.PropTypes.number,
  settings: React.PropTypes.array,
  allCompletionTypes: React.PropTypes.array,
  completionsDataService: React.PropTypes.object,
  notesDataService: React.PropTypes.object,
  userService: React.PropTypes.object,
  sort: React.PropTypes.func,
  sortProperty: React.PropTypes.string,
  sortIsDesc: React.PropTypes.bool,
  filters: React.PropTypes.object
};

var AssignServiceModal = /*#__PURE__*/function (_React$Component2) {
  _inherits(AssignServiceModal, _React$Component2);

  var _super2 = _createSuper(AssignServiceModal);

  function AssignServiceModal(props) {
    var _this3;

    _classCallCheck(this, AssignServiceModal);

    _this3 = _super2.call(this, props);
    _this3.assignService = _this3.assignService.bind(_assertThisInitialized(_this3));
    _this3.saveAndClose = _this3.saveAndClose.bind(_assertThisInitialized(_this3));
    _this3.handleChange = _this3.handleChange.bind(_assertThisInitialized(_this3));
    _this3.state = {
      selectedUserId: 0
    };
    return _this3;
  }

  _createClass(AssignServiceModal, [{
    key: "handleChange",
    value: function handleChange(event) {
      var target = event.target;
      var fieldVal = target.value;
      this.props.item.AssignedToUserId = fieldVal;
      this.setState({
        selectedUserId: fieldVal
      });
    }
  }, {
    key: "assignService",
    value: function assignService() {
      var that = this;
      var dto = {
        ServiceOrderId: this.props.item.ID,
        AssignedToUserId: this.state.selectedUserId
      };
      this.props.apiService.saveItem('api/DailySetup/AssignUserToService', dto).then(function (response) {
        that.props.close();
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.assignService();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.item.ServiceType)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "assignServiceModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Assign User to this service"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        controlId: "AssignedToUserId"
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, "Assigned To "), /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        componentClass: "select",
        value: this.props.item.AssignedToUserId,
        onChange: this.handleChange,
        id: "AssignedToUserId"
      }, /*#__PURE__*/React.createElement("option", {
        key: "0",
        value: "0"
      }, "(unassigned)"), this.props.allUsers.map(function (user, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: user.Id,
          value: user.Id
        }, user.UserName);
      }))))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return AssignServiceModal;
}(React.Component);

AssignServiceModal.propTypes = {
  show: React.PropTypes.bool,
  item: React.PropTypes.object,
  apiService: React.PropTypes.object,
  close: React.PropTypes.func,
  settings: React.PropTypes.array,
  updateItemForBookingAction: React.PropTypes.func,
  filters: React.PropTypes.object,
  updateItemInCollection: React.PropTypes.func
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TasksTable = /*#__PURE__*/function (_React$Component) {
  _inherits(TasksTable, _React$Component);

  var _super = _createSuper(TasksTable);

  function TasksTable(props) {
    var _this;

    _classCallCheck(this, TasksTable);

    _this = _super.call(this, props);
    _this.sort = _this.sort.bind(_assertThisInitialized(_this));
    _this.sortHeaderClass = _this.sortHeaderClass.bind(_assertThisInitialized(_this));
    _this.state = {
      tasks: _this.props.tasks,
      sortedTasks: [],
      sortBy: 'TaskStartAt',
      sortDir: 'ASC'
    };
    return _this;
  }

  _createClass(TasksTable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.setState({
        tasks: [].concat(nextProps.tasks)
      }, function () {
        return _this2.sort(_this2.state.sortBy, true);
      });
    }
  }, {
    key: "sortHeaderClass",
    value: function sortHeaderClass(propertyName) {
      if (this.state.sortBy === propertyName) {
        if (this.state.sortDir === "DESC") {
          return "st-sort-descent";
        } else {
          return "st-sort-ascent";
        }
      }

      return "";
    }
  }, {
    key: "sort",
    value: function sort(propertyName, dontChangeDirection) {
      var sortDir = this.state.sortDir;
      var sortBy = propertyName;

      if (!dontChangeDirection) {
        if (sortBy === this.state.sortBy) {
          sortDir = this.state.sortDir === 'ASC' ? 'DESC' : 'ASC';
        } else {
          sortDir = 'DESC';
        }
      }

      var rows = this.state.tasks.slice();
      rows.sort(function (a, b) {
        var sortVal = 0;
        var aSort = a[sortBy];
        var bSort = b[sortBy];
        var multiplier = sortDir === 'DESC' ? -1 : 1;

        if (aSort) {
          aSort = aSort.toLowerCase();
        } else {
          return -1 * multiplier;
        }

        if (bSort) {
          bSort = bSort.toLowerCase();
        } else {
          return 1 * multiplier;
        }

        if (aSort > bSort) {
          sortVal = 1;
        }

        if (aSort < bSort) {
          sortVal = -1;
        }

        sortVal = sortVal * multiplier;
        return sortVal;
      });
      this.setState({
        sortBy: sortBy,
        sortDir: sortDir,
        sortedTasks: rows
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var nothingDoneColor = "red";
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
        id: "dailySetupTasks",
        className: "responsiveTable table table-condensed table-striped"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        className: "dotColumn"
      }, "Done"), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 13 + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("TaskStartAt"),
        onClick: function onClick() {
          return _this3.sort('TaskStartAt');
        }
      }, "Start At"), " "), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 13 + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("TaskFinishBy"),
        onClick: function onClick() {
          return _this3.sort('TaskFinishBy');
        }
      }, "Finish By")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 10 + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("Department"),
        onClick: function onClick() {
          return _this3.sort('Department');
        }
      }, "Department")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 10 + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("AssignedTo"),
        onClick: function onClick() {
          return _this3.sort('AssignedTo');
        }
      }, "Assigned To")), /*#__PURE__*/React.createElement("th", {
        className: "pointer",
        style: {
          width: 34 + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.sortHeaderClass("TaskDescription"),
        onClick: function onClick() {
          return _this3.sort('TaskDescription');
        }
      }, "Description")), /*#__PURE__*/React.createElement("th", {
        style: {
          width: 5 + "%"
        }
      }, "Notes"), /*#__PURE__*/React.createElement("th", {
        style: {
          width: 5 + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, "Linked Task")))), this.state.sortedTasks.map(function (task) {
        return /*#__PURE__*/React.createElement(TaskRow, {
          key: task.TaskId,
          item: task,
          showCompletionModal: _this3.props.showCompletionModal,
          showNotesModal: _this3.props.showNotesModal,
          canEditTask: _this3.props.canEditTask,
          editTask: _this3.props.editTask,
          showHistoryModal: _this3.props.showHistoryModal,
          settings: _this3.props.settings,
          completionsDataService: _this3.props.completionsDataService,
          allCompletionTypes: _this3.props.allCompletionTypes,
          getLinkedBooking: _this3.props.getLinkedBooking,
          toggleServices: _this3.props.toggleServices,
          showCarouselModal: _this3.props.showCarouselModal,
          userService: _this3.props.userService,
          limitCompletionsByDeparments: _this3.props.limitCompletionsByDeparments,
          nothingDoneColor: nothingDoneColor
        });
      })));
    }
  }]);

  return TasksTable;
}(React.Component);

TasksTable.propTypes = {
  tasks: React.PropTypes.array,
  sort: React.PropTypes.func,
  sortHeaderClass: React.PropTypes.func,
  editTask: React.PropTypes.func,
  settings: React.PropTypes.array,
  allCompletionTypes: React.PropTypes.array,
  getLinkedBooking: React.PropTypes.func,
  toggleServices: React.PropTypes.func,
  showCarouselModal: React.PropTypes.func,
  userService: React.PropTypes.object,
  limitCompletionsByDeparments: React.PropTypes.bool
};

var TaskRow = /*#__PURE__*/function (_React$Component2) {
  _inherits(TaskRow, _React$Component2);

  var _super2 = _createSuper(TaskRow);

  function TaskRow(props) {
    var _this4;

    _classCallCheck(this, TaskRow);

    _this4 = _super2.call(this, props);
    _this4.isAllDone = _this4.isAllDone.bind(_assertThisInitialized(_this4));
    return _this4;
  }

  _createClass(TaskRow, [{
    key: "isAllDone",
    value: function isAllDone() {
      var lastCompletion = this.props.completionsDataService.getLastCompletionForType(0, this.props.item);

      if (lastCompletion) {
        if (lastCompletion.CompletedAtUtc != null) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var showAvailAt = true;

      for (var i = 0; i < this.props.settings.length; i++) {
        if (this.props.settings[i].SettingKey === "AvailableAtTimeToUse") {
          if (this.props.settings[i].SettingValue.toLowerCase() === 'fb35dae1-e2e8-4aac-b5c0-6236e594acc9') {
            showAvailAt = false;
          }
        }
      }

      var notesCell = null;

      if (this.props.item.Notes && this.props.item.Notes.length > 0) {
        notesCell = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-comments fa-1-5x",
          title: "View/Add Notes"
        });
      } else {
        notesCell = /*#__PURE__*/React.createElement("i", {
          className: "fa fa-comments-o fa-1-5x",
          title: "Add Notes"
        });
      }

      var myTaskClass = '';

      if (this.props.userService.userId() == this.props.item.AssignedToUserId) {
        myTaskClass = 'assignedToMe';
      }

      var displayRow = true;

      for (var _i = 0; _i < this.props.settings.length; _i++) {
        if (this.props.settings[_i].SettingKey === "DropTaskWhenComplete") {
          if (this.props.settings[_i].SettingValue === "1") {
            if (this.isAllDone()) {
              displayRow = false;
            }
          }

          continue;
        } else if (this.props.settings[_i].SettingKey === "NothingDoneDotColor") {
          nothingDoneColor = this.props.settings[_i].SettingValue;
        }
      }

      return displayRow && /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
        key: this.props.item.TaskId,
        className: "responsiveRow dailySetupRow " + myTaskClass
      }, /*#__PURE__*/React.createElement(CompletionsCell, {
        item: this.props.item,
        showCompletionModal: this.props.showCompletionModal,
        allCompletionTypes: this.props.allCompletionTypes,
        completionsDataService: this.props.completionsDataService,
        isAllDone: this.isAllDone,
        limitCompletionsByDeparments: this.props.limitCompletionsByDeparments,
        userService: this.props.userService,
        nothingDoneColor: this.props.nothingDoneColor
      }), /*#__PURE__*/React.createElement("td", null, this.props.includeDate && moment(this.props.item.TaskDisplayOn).format("MM/DD/yyyy "), " ", moment(this.props.item.TaskStartAt).format("h:mm A"), "\xA0"), /*#__PURE__*/React.createElement("td", null, this.props.item.TaskFinishBy && moment(this.props.item.TaskFinishBy).format("h:mm A"), "\xA0"), /*#__PURE__*/React.createElement("td", null, this.props.item.Department), /*#__PURE__*/React.createElement("td", null, this.props.item.AssignedTo, "\xA0"), /*#__PURE__*/React.createElement("td", {
        className: "preWrap"
      }, this.props.canEditTask(this.props.item) && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this5.props.editTask(_this5.props.item);
        }
      }, this.props.item.TaskDescription), !this.props.canEditTask(this.props.item) && this.props.item.TaskDescription), /*#__PURE__*/React.createElement("td", {
        onClick: this.props.showNotesModal.bind(this, this.props.item)
      }, /*#__PURE__*/React.createElement("a", null, notesCell)), /*#__PURE__*/React.createElement("td", null, this.props.item.LinkedBookingId && !this.props.hideLinkedBooking && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this5.props.getLinkedBooking(_this5.props.item);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-calendar-check-o",
        title: "View linked event"
      })))), this.props.item.RelatedBookingItem && this.props.item.showingRelatedBooking && !this.props.hideLinkedBooking && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: 8
      }, /*#__PURE__*/React.createElement("table", {
        style: {
          width: 100 + "%"
        }
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
        className: "dotColumn"
      }, "Done"), /*#__PURE__*/React.createElement("th", {
        style: {
          width: 80 + 'px'
        }
      }, "Available"), /*#__PURE__*/React.createElement("th", {
        style: {
          width: 85 + 'px'
        }
      }, "Starts"), /*#__PURE__*/React.createElement("th", {
        style: {
          width: 80 + 'px'
        }
      }, "Ends"), /*#__PURE__*/React.createElement("th", null, "Location/Event Name"), /*#__PURE__*/React.createElement("th", null, "Group/Contact"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null, "Notes"), /*#__PURE__*/React.createElement("th", null, "Services"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(BookingRow, {
        key: "related-" + this.props.item.RelatedBookingItem.BookingId,
        item: this.props.item.RelatedBookingItem,
        minutesSinceLastChange: this.props.minutesSinceLastChange,
        showReservedTime: this.props.showReservedTime,
        settings: this.props.settings,
        completionTypes: this.props.completionTypes,
        getHistoryForBooking: this.props.getHistoryForBooking,
        completionsDataService: this.props.completionsDataService,
        showCompletionModal: this.props.showCompletionModal,
        showHistoryModal: this.props.showHistoryModal,
        allCompletionTypes: this.props.allCompletionTypes,
        setAvailableAt: this.props.setAvailableAt,
        showNotesModal: this.props.showNotesModal,
        showCarouselModal: this.props.showCarouselModal,
        showNewTaskModal: this.showNewTaskModal,
        toggleServices: this.props.toggleServices,
        isRelatedBooking: true,
        apiService: this.props.apiService,
        userService: this.props.userService,
        showAvailAt: showAvailAt,
        nothingDoneColor: nothingDoneColor,
        showRow: true
      }), this.props.item.RelatedBookingItem.Services.length > 0 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "11"
      }, /*#__PURE__*/React.createElement(ServicesList, {
        services: this.props.item.RelatedBookingItem.Services,
        minutesSinceLastChange: this.props.minutesSinceLastChange
      }))))))));
    }
  }]);

  return TaskRow;
}(React.Component);

TaskRow.propTypes = {
  item: React.PropTypes.object,
  settings: React.PropTypes.array,
  showCompletionModal: React.PropTypes.func,
  showCarouselModal: React.PropTypes.func,
  showNotesModal: React.PropTypes.func,
  userService: React.PropTypes.object,
  editTask: React.PropTypes.func,
  showRelatedBooking: React.PropTypes.func,
  showHistoryModal: React.PropTypes.func,
  toggleServices: React.PropTypes.func,
  isAllDone: React.PropTypes.func
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props);
    _this.state = {
      editMode: false,
      timeData: []
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.loadTimeData();
    }
  }, {
    key: "loadTimeData",
    value: function loadTimeData() {
      if (this.state.timeData.length === 0) {
        var times = [],
            i,
            j,
            t,
            h,
            hh,
            m;

        for (i = 0; i < 24; i++) {
          hh = i;

          if (i === 0) {
            h = "12";
          } else {
            if (i > 12) {
              h = i % 12;
            } else {
              h = i;
            }
          }

          for (j = 0; j < 4; j++) {
            t = h + ":" + (j === 0 ? "00" : 15 * j);
            m = (hh < 10 ? "0" + hh : hh) + ":" + (j === 0 ? "00" : 15 * j);
            t += " " + Number(i) < 12 ? " AM" : " PM";
            times.push({
              value: m,
              text: t
            });
          }
        }

        this.setState({
          timeData: times
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var times = this.state.timeData;
      return /*#__PURE__*/React.createElement(ReactBootstrap.FormGroup, {
        controlId: this.props.id,
        validationState: this.props.validationState
      }, /*#__PURE__*/React.createElement(ReactBootstrap.ControlLabel, null, this.props.label), /*#__PURE__*/React.createElement(ReactBootstrap.FormControl, {
        componentClass: "select",
        value: this.props.value,
        onChange: this.props.onChange
      }, this.props.allowEmpty && /*#__PURE__*/React.createElement("option", {
        value: ""
      }), times.map(function (time, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: time.value,
          value: time.value
        }, time.text);
      })), /*#__PURE__*/React.createElement(ReactBootstrap.HelpBlock, null, this.props.feedBack));
    }
  }]);

  return TimePicker;
}(React.Component);

TimePicker.propTypes = {
  allowEmpty: React.PropTypes.bool,
  value: React.PropTypes.string,
  onChange: React.PropTypes.func.isRequired,
  validationState: React.PropTypes.string,
  feedBack: React.PropTypes.string
};
TimePicker.defaultProps = {
  allowEmpty: true,
  value: '',
  validationState: null,
  feedBack: ''
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UdfsList = /*#__PURE__*/function (_React$Component) {
  _inherits(UdfsList, _React$Component);

  var _super = _createSuper(UdfsList);

  function UdfsList(props) {
    var _this;

    _classCallCheck(this, UdfsList);

    _this = _super.call(this, props);
    _this.addHyperlinks = _this.addHyperlinks.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UdfsList, [{
    key: "addHyperlinks",
    value: function addHyperlinks(text) {
      // Create your regex pattern for urls 
      var urlPattern = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\z`!()\[\]{};:'".,<>?«»“”‘’]))/ig; // Check string for any url patterns and wrap them in anchor tags 

      var result = text.replace(urlPattern, function (url) {
        return "<a href=\"".concat(url.trim(), "\" target=\"_blank\">").concat(url.trim(), "</a>");
      });
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("ul", null, this.props.udfs.map(function (udf) {
        return /*#__PURE__*/React.createElement("li", null, udf.Description, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
          className: "preWrap",
          dangerouslySetInnerHTML: {
            __html: _this2.addHyperlinks(udf.FieldValue)
          }
        })));
      }));
    }
  }]);

  return UdfsList;
}(React.Component);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UpdateSodQtyModal = /*#__PURE__*/function (_React$Component) {
  _inherits(UpdateSodQtyModal, _React$Component);

  var _super = _createSuper(UpdateSodQtyModal);

  function UpdateSodQtyModal(props) {
    var _this;

    _classCallCheck(this, UpdateSodQtyModal);

    _this = _super.call(this, props);
    _this.updateSodQty = _this.updateSodQty.bind(_assertThisInitialized(_this));
    _this.updateAndClose = _this.updateAndClose.bind(_assertThisInitialized(_this));
    _this.state = {
      value: ""
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UpdateSodQtyModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.sod.Quantity
      });
    }
  }, {
    key: "updateSodQty",
    value: function updateSodQty() {
      var that = this;
      var qty = this.state.value;

      if (qty) {
        var dto = {
          Filters: this.props.filters,
          SoId: this.props.sod.ServiceOrderID,
          SodId: this.props.sod.ID,
          NewQuantity: qty,
          IsCheckinRequest: false
        };
        this.props.apiService.saveItem('api/DailySetup/UpdateSod', dto).then(function (response) {
          if (response.data) {
            that.props.updateItemForBookingAction(response.data);
            that.props.updateItemInCollection(response.data);
          }
        }, function (error) {
          console.log(error);
        });
      }

      this.setState({
        value: ""
      });
    }
  }, {
    key: "updateAndClose",
    value: function updateAndClose() {
      this.updateSodQty();
      this.props.close();
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var re = /^[0-9\b]+$/;

      if (e.target.value === '' || re.test(e.target.value)) {
        this.setState({
          value: e.target.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, this.props.sod.TempResourceDescription || this.props.sod.Resource && this.props.sod.Resource.Description || "Bad Config - Missing Resource")), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "updateSodModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Specify New Quantity"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "text-left",
        htmlFor: "quantity"
      }, "Quantity"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        id: "quantity",
        name: "quantity",
        className: "form-control",
        value: this.state.value,
        onChange: this.onChange
      }))))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.updateAndClose
      }, "Ok"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "Cancel")));
    }
  }]);

  return UpdateSodQtyModal;
}(React.Component);

var ConfirmAttendeeCheckinModal = /*#__PURE__*/function (_React$Component2) {
  _inherits(ConfirmAttendeeCheckinModal, _React$Component2);

  var _super2 = _createSuper(ConfirmAttendeeCheckinModal);

  function ConfirmAttendeeCheckinModal(props) {
    var _this2;

    _classCallCheck(this, ConfirmAttendeeCheckinModal);

    _this2 = _super2.call(this, props);
    _this2.confirmCheckin = _this2.confirmCheckin.bind(_assertThisInitialized(_this2));
    _this2.saveAndClose = _this2.saveAndClose.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(ConfirmAttendeeCheckinModal, [{
    key: "confirmCheckin",
    value: function confirmCheckin() {
      var that = this;
      var dto = {
        Filters: this.props.filters,
        SoId: this.props.sod.ServiceOrderID,
        SodId: this.props.sod.ID,
        NewQuantity: 0,
        IsCheckinRequest: true
      };
      this.props.apiService.saveItem('api/DailySetup/UpdateSod', dto).then(function (response) {
        if (response.data) {
          that.props.updateItemForBookingAction(response.data);
          that.props.updateItemInCollection(response.data);
        }
      }, function (error) {
        console.log(error);
      });
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.confirmCheckin();
      this.props.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactBootstrap.Modal, {
        show: this.props.show,
        onHide: this.props.close,
        enforceFocus: false
      }, /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("h3", null, "Checkin ", this.props.sod.TempResourceDescription)), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Body, {
        id: "emsEndBookingModal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget wblue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "widget-head truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "page-title pull-left"
      }, "Attendee Check-In"), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "widget-content text-center text-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left form-group"
      }, "Are you sure you want to check in ", this.props.sod.TempResourceDescription, "?")))), /*#__PURE__*/React.createElement(ReactBootstrap.Modal.Footer, null, /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.saveAndClose
      }, "Yes"), /*#__PURE__*/React.createElement(ReactBootstrap.Button, {
        onClick: this.props.close
      }, "No")));
    }
  }]);

  return ConfirmAttendeeCheckinModal;
}(React.Component);